export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string with format `Y-m-d`, e.g. `2018-05-23`. */
  Date: { input: any; output: any; }
  /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-05-23 13:43:32`. */
  DateTime: { input: any; output: any; }
  /** A datetime string with format `Y-m-d\TH:i:s.uP`, e.g. `2020-04-20T16:20:04.000000+04:00`. */
  DateTimeTz: { input: any; output: any; }
  /**
   * Loose type that allows any value. Be careful when passing in large `Int` or `Float` literals,
   * as they may not be parsed correctly on the server side. Use `String` literals if you are
   * dealing with really large numbers to be on the safe side.
   */
  Mixed: { input: any; output: any; }
};

export type ActivityLog = {
  actionableItem?: Maybe<ActivityLogActionableItem>;
  attribute_changes?: Maybe<Scalars['Mixed']['output']>;
  causer?: Maybe<User>;
  created_at: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  event: ActivityLogEvent;
  id: Scalars['ID']['output'];
  properties?: Maybe<Scalars['Mixed']['output']>;
  subject: ActivityLogSubject;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ActivityLogActionableItem = Blocklist | BookingChangeRequest | BookingPaymentRequest;

export enum ActivityLogEvent {
  AssignmentCompleted = 'ASSIGNMENT_COMPLETED',
  AssignmentDelivered = 'ASSIGNMENT_DELIVERED',
  AssignmentDriverRated = 'ASSIGNMENT_DRIVER_RATED',
  AssignmentOnRoad = 'ASSIGNMENT_ON_ROAD',
  AssignmentPayoutCreated = 'ASSIGNMENT_PAYOUT_CREATED',
  AssignmentPayoutDeleted = 'ASSIGNMENT_PAYOUT_DELETED',
  BookingAccepted = 'BOOKING_ACCEPTED',
  BookingAssignedLine = 'BOOKING_ASSIGNED_LINE',
  BookingCancelled = 'BOOKING_CANCELLED',
  BookingChangeRequestActioned = 'BOOKING_CHANGE_REQUEST_ACTIONED',
  BookingChangeRequestApproved = 'BOOKING_CHANGE_REQUEST_APPROVED',
  BookingChangeRequestPlaced = 'BOOKING_CHANGE_REQUEST_PLACED',
  BookingChangeRequestRejected = 'BOOKING_CHANGE_REQUEST_REJECTED',
  BookingClaimed = 'BOOKING_CLAIMED',
  BookingCompleted = 'BOOKING_COMPLETED',
  BookingConfirmed = 'BOOKING_CONFIRMED',
  BookingCustomerBlocked = 'BOOKING_CUSTOMER_BLOCKED',
  BookingFerryRefundFormCompleted = 'BOOKING_FERRY_REFUND_FORM_COMPLETED',
  BookingFerryRefundFormRejected = 'BOOKING_FERRY_REFUND_FORM_REJECTED',
  BookingFerryRefundFormSent = 'BOOKING_FERRY_REFUND_FORM_SENT',
  BookingFerryRefundFormSubmitted = 'BOOKING_FERRY_REFUND_FORM_SUBMITTED',
  BookingFuelRefundFormCompleted = 'BOOKING_FUEL_REFUND_FORM_COMPLETED',
  BookingFuelRefundFormRejected = 'BOOKING_FUEL_REFUND_FORM_REJECTED',
  BookingFuelRefundFormSent = 'BOOKING_FUEL_REFUND_FORM_SENT',
  BookingFuelRefundFormSubmitted = 'BOOKING_FUEL_REFUND_FORM_SUBMITTED',
  BookingHoldingDepositReleased = 'BOOKING_HOLDING_DEPOSIT_RELEASED',
  BookingHoldingDepositReleaseFailed = 'BOOKING_HOLDING_DEPOSIT_RELEASE_FAILED',
  BookingPaymentRequestCancelled = 'BOOKING_PAYMENT_REQUEST_CANCELLED',
  BookingPaymentRequestCaptured = 'BOOKING_PAYMENT_REQUEST_CAPTURED',
  BookingPaymentRequestCreated = 'BOOKING_PAYMENT_REQUEST_CREATED',
  BookingPaymentRequestPending = 'BOOKING_PAYMENT_REQUEST_PENDING',
  BookingPending = 'BOOKING_PENDING',
  BookingReleasedLine = 'BOOKING_RELEASED_LINE',
  BookingVip = 'BOOKING_VIP',
  Created = 'CREATED',
  Deleted = 'DELETED',
  Email = 'EMAIL',
  EmailFailed = 'EMAIL_FAILED',
  IncidentClaimOpened = 'INCIDENT_CLAIM_OPENED',
  IncidentClaimPaid = 'INCIDENT_CLAIM_PAID',
  IncidentClaimRejected = 'INCIDENT_CLAIM_REJECTED',
  IncidentClosed = 'INCIDENT_CLOSED',
  IncidentReopened = 'INCIDENT_REOPENED',
  IncidentReported = 'INCIDENT_REPORTED',
  IntegrationClick4WheelsBookingPushed = 'INTEGRATION_CLICK4WHEELS_BOOKING_PUSHED',
  IntegrationClick4WheelsBookingPushedFailed = 'INTEGRATION_CLICK4WHEELS_BOOKING_PUSHED_FAILED',
  IntegrationJucyBookingPushed = 'INTEGRATION_JUCY_BOOKING_PUSHED',
  IntegrationJucyBookingPushedFailed = 'INTEGRATION_JUCY_BOOKING_PUSHED_FAILED',
  InvoiceIssued = 'INVOICE_ISSUED',
  InvoicePaymentCreated = 'INVOICE_PAYMENT_CREATED',
  InvoicePaymentDeleted = 'INVOICE_PAYMENT_DELETED',
  InvoicePaymentUpdated = 'INVOICE_PAYMENT_UPDATED',
  InvoiceVoided = 'INVOICE_VOIDED',
  MarketingEventTriggered = 'MARKETING_EVENT_TRIGGERED',
  Note = 'NOTE',
  OrganisationInvitationAccepted = 'ORGANISATION_INVITATION_ACCEPTED',
  OrganisationInvitationRevoked = 'ORGANISATION_INVITATION_REVOKED',
  OrganisationMemberAdded = 'ORGANISATION_MEMBER_ADDED',
  OrganisationMemberInvited = 'ORGANISATION_MEMBER_INVITED',
  OrganisationMemberRemoved = 'ORGANISATION_MEMBER_REMOVED',
  PhoneCall = 'PHONE_CALL',
  RelocationArchived = 'RELOCATION_ARCHIVED',
  RelocationBooked = 'RELOCATION_BOOKED',
  RelocationDuplicated = 'RELOCATION_DUPLICATED',
  RelocationExpired = 'RELOCATION_EXPIRED',
  RelocationPaused = 'RELOCATION_PAUSED',
  RelocationProDriverRequested = 'RELOCATION_PRO_DRIVER_REQUESTED',
  RelocationReady = 'RELOCATION_READY',
  RelocationReleased = 'RELOCATION_RELEASED',
  Sms = 'SMS',
  Updated = 'UPDATED',
  WaitlistMatchesSent = 'WAITLIST_MATCHES_SENT',
  WorkOrderArchived = 'WORK_ORDER_ARCHIVED',
  WorkOrderAssigningDrivers = 'WORK_ORDER_ASSIGNING_DRIVERS',
  WorkOrderCompleted = 'WORK_ORDER_COMPLETED',
  WorkOrderDriversAssigned = 'WORK_ORDER_DRIVERS_ASSIGNED',
  WorkOrderDriverAssigned = 'WORK_ORDER_DRIVER_ASSIGNED',
  WorkOrderDriverUnassigned = 'WORK_ORDER_DRIVER_UNASSIGNED',
  WorkOrderInvoiced = 'WORK_ORDER_INVOICED',
  WorkOrderInProgress = 'WORK_ORDER_IN_PROGRESS',
  WorkOrderQuoteAccepted = 'WORK_ORDER_QUOTE_ACCEPTED',
  WorkOrderQuoteIssued = 'WORK_ORDER_QUOTE_ISSUED',
  WorkOrderQuoteRejected = 'WORK_ORDER_QUOTE_REJECTED',
  WorkOrderQuoteRequested = 'WORK_ORDER_QUOTE_REQUESTED'
}

/** A paginated list of ActivityLog items. */
export type ActivityLogPaginator = {
  /** A list of ActivityLog items. */
  data: Array<ActivityLog>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ActivityLogSubject = Booking | BookingChangeRequest | BookingPaymentRequest | Waitlist;

export type Address = {
  address_line_1?: Maybe<Scalars['String']['output']>;
  address_line_2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  formatted_address_line_1: Scalars['String']['output'];
  formatted_address_line_2: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locationMedia?: Maybe<Media>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export enum AgeSurchargeType {
  FlatFee = 'FLAT_FEE',
  PerDay = 'PER_DAY',
  Unspecified = 'UNSPECIFIED'
}

export type AgentConversation = {
  id: Scalars['ID']['output'];
  messages: Array<AgentMessage>;
  run_number: Scalars['Int']['output'];
  started_at: Scalars['DateTime']['output'];
};

export type AgentMessage = {
  completion_tokens?: Maybe<Scalars['Int']['output']>;
  content: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  model?: Maybe<Scalars['String']['output']>;
  prompt_tokens?: Maybe<Scalars['Int']['output']>;
  /** Either 'user' or 'assistant'. */
  role: Scalars['String']['output'];
  steps: Array<AgentToolCall>;
};

/** One thing an agent handled, whichever automation ran it. */
export type AgentRun = {
  created_at: Scalars['DateTime']['output'];
  failure_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: AgentRunKind;
  note?: Maybe<Scalars['String']['output']>;
  state: AgentRunState;
  /** The automation's own status, e.g. SETTLED or COMPLETED. */
  status: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type AgentRunDetail = {
  created_at: Scalars['DateTime']['output'];
  /** Whatever is worth knowing about this run at a glance. */
  facts: Array<AgentRunFact>;
  failure_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: AgentRunKind;
  /** What the automation recorded doing, in order. */
  log: Array<AgentRunLogEntry>;
  note?: Maybe<Scalars['String']['output']>;
  state: AgentRunState;
  status: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** Every agent conversation on this record, oldest first. */
  transcript: Array<AgentConversation>;
};

export type AgentRunFact = {
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum AgentRunKind {
  MailboxEmail = 'MAILBOX_EMAIL',
  ThlListImport = 'THL_LIST_IMPORT'
}

export type AgentRunLogEntry = {
  detail: Scalars['String']['output'];
  label: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
};

export type AgentRunPaginator = {
  data: Array<AgentRun>;
  paginatorInfo: PaginatorInfo;
};

export enum AgentRunState {
  Done = 'DONE',
  Failed = 'FAILED',
  NeedsAttention = 'NEEDS_ATTENTION',
  NotRelevant = 'NOT_RELEVANT',
  Processing = 'PROCESSING'
}

export type AgentToolCall = {
  arguments_json: Scalars['String']['output'];
  denied: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  result?: Maybe<Scalars['String']['output']>;
  tool: Scalars['String']['output'];
};

export type AllCity = {
  delivery_city_ids?: Maybe<Array<Scalars['ID']['output']>>;
  delivery_relocation_count: Scalars['Int']['output'];
  departing_gap_rental_count: Scalars['Int']['output'];
  departing_relocation_count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  region: Region;
  slug: Scalars['String']['output'];
  state: State;
};

export type AllSupplierBookingStatusStat = {
  avg_confirmation_hours?: Maybe<Scalars['Float']['output']>;
  cancelled_count: Scalars['Int']['output'];
  completed_count: Scalars['Int']['output'];
  confirmed_count: Scalars['Int']['output'];
  pending_count: Scalars['Int']['output'];
  supplier_id: Scalars['ID']['output'];
  supplier_name: Scalars['String']['output'];
};

export type AllSupplierDashboardBookingStats = {
  lastPeriod: OrganisationDashboardStatsPeriod;
  suppliers: Array<AllSupplierBookingStatusStat>;
  thisPeriod: OrganisationDashboardStatsPeriod;
};

export type ApproveBookingPaymentInput = {
  amount_to_capture: Scalars['Int']['input'];
  payment_id: Scalars['ID']['input'];
};

export type AssignSupplierToTenantInput = {
  supplier_id: Scalars['ID']['input'];
  tenant_id: Scalars['ID']['input'];
};

export type AssignmentLocationData = {
  assignmentId: Scalars['ID']['output'];
  latestLocation?: Maybe<WorkOrderAssignmentLocation>;
  locations: Array<WorkOrderAssignmentLocation>;
};

export type BelongsToAddress = {
  connect?: InputMaybe<Scalars['ID']['input']>;
  upsert?: InputMaybe<UpsertAddressInput>;
};

export type BlockBookingCustomerInput = {
  booking_id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type Blocklist = {
  created_at: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  managed_by_id: Scalars['ID']['output'];
  phone: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

/** A paginated list of Blocklist items. */
export type BlocklistPaginator = {
  /** A list of Blocklist items. */
  data: Array<Blocklist>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum BlogAudience {
  Customer = 'CUSTOMER',
  Supplier = 'SUPPLIER'
}

export type BlogAuthor = {
  bio?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Media>;
  name: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type BlogPost = {
  audience: BlogAudience;
  author?: Maybe<BlogAuthor>;
  available_locales: Array<Scalars['String']['output']>;
  body_html: Scalars['String']['output'];
  body_images: Array<Media>;
  created_at: Scalars['DateTime']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  hero_image?: Maybe<Media>;
  id: Scalars['ID']['output'];
  is_published: Scalars['Boolean']['output'];
  locale: Scalars['String']['output'];
  published_at?: Maybe<Scalars['DateTime']['output']>;
  reading_time_minutes?: Maybe<Scalars['Int']['output']>;
  seo_image?: Maybe<Media>;
  slug: Scalars['String']['output'];
  tags: Array<BlogTag>;
  title: Scalars['String']['output'];
  translations: Array<BlogPostTranslation>;
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of BlogPost items. */
export type BlogPostPaginator = {
  /** A list of BlogPost items. */
  data: Array<BlogPost>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type BlogPostRating = {
  rating?: Maybe<Scalars['Float']['output']>;
  slug: Scalars['String']['output'];
};

export enum BlogPostStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type BlogPostTranslation = {
  body_html?: Maybe<Scalars['String']['output']>;
  excerpt?: Maybe<Scalars['String']['output']>;
  locale: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type BlogPostTripArticle = {
  blogPost?: Maybe<BlogPost>;
  blog_post_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type BlogTag = {
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type Booking = {
  address?: Maybe<Scalars['String']['output']>;
  admin_url: Scalars['String']['output'];
  /** The booking vehicle's purchasable extras enabled for the relocation's type */
  availablePurchasableExtras: Array<SupplierPurchasableExtra>;
  cancelledByActivity?: Maybe<ActivityLog>;
  charge_summary: BookingChargeSummary;
  charges: Array<BookingCharge>;
  confirmed_at?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  currency: Currency;
  customerPayments: Array<Payment>;
  customer_note?: Maybe<Scalars['String']['output']>;
  customer_payment_amount?: Maybe<Scalars['Int']['output']>;
  customer_url: Scalars['String']['output'];
  date_of_birth: Scalars['String']['output'];
  deliver_at: Scalars['DateTime']['output'];
  deliveryOffice: SupplierOffice;
  depart_at: Scalars['DateTime']['output'];
  departureOffice: SupplierOffice;
  discounted_units: Scalars['Int']['output'];
  distance_allowed?: Maybe<Scalars['Int']['output']>;
  email: Scalars['String']['output'];
  full_price_units: Scalars['Int']['output'];
  gender?: Maybe<Gender>;
  hire_unit_type: HireUnitType;
  id: Scalars['ID']['output'];
  inclusions: Array<BookingInclusion>;
  managed_by_id: Scalars['ID']['output'];
  matchedRelocationsCount?: Maybe<Scalars['Int']['output']>;
  measurement: Measurement;
  name: Scalars['String']['output'];
  number_of_travellers: Scalars['Int']['output'];
  organisation_url: Scalars['String']['output'];
  original_relocation_id: Scalars['ID']['output'];
  payments?: Maybe<Array<Payment>>;
  /** @deprecated Use customer_url */
  permalink: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  potentialDuplicates: Array<Booking>;
  preferred_ferry_date?: Maybe<Scalars['String']['output']>;
  purchasableExtras: Array<BookingPurchasableExtra>;
  reference: Scalars['String']['output'];
  relocation: Relocation;
  relocationLine?: Maybe<RelocationLine>;
  status: BookingStatus;
  supplier: Supplier;
  supplierInsuranceOption: SupplierInsuranceOption;
  supplierPayments?: Maybe<Array<Payment>>;
  supplier_reference?: Maybe<Scalars['String']['output']>;
  total_booking_value: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userRating?: Maybe<BookingUserRating>;
  user_id?: Maybe<Scalars['ID']['output']>;
  uuid: Scalars['String']['output'];
  vehicle: Vehicle;
};

export type BookingChangeRelocationInput = {
  release_linked_relocation: Scalars['Boolean']['input'];
  relocation_id: Scalars['ID']['input'];
};

export type BookingChangeRequest = {
  admin_fee_amount: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  booking: Booking;
  changes?: Maybe<Scalars['Mixed']['output']>;
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  price_delta_amount: Scalars['Int']['output'];
  request?: Maybe<Scalars['String']['output']>;
  status: BookingChangeRequestStatus;
  stripePayment?: Maybe<StripePayment>;
  type: BookingChangeRequestType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

/** A paginated list of BookingChangeRequest items. */
export type BookingChangeRequestPaginator = {
  /** A list of BookingChangeRequest items. */
  data: Array<BookingChangeRequest>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type BookingChangeRequestQuote = {
  admin_fee_amount: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  currency: Currency;
  price_delta_amount: Scalars['Int']['output'];
  type: BookingChangeRequestType;
};

export type BookingChangeRequestQuoteInput = {
  deliver_at?: InputMaybe<Scalars['DateTime']['input']>;
  depart_at?: InputMaybe<Scalars['DateTime']['input']>;
  type: BookingChangeRequestType;
};

export enum BookingChangeRequestStatus {
  Actioned = 'ACTIONED',
  Approved = 'APPROVED',
  AwaitingPayment = 'AWAITING_PAYMENT',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export enum BookingChangeRequestType {
  DateChange = 'DATE_CHANGE',
  DriverDetails = 'DRIVER_DETAILS',
  Other = 'OTHER'
}

export type BookingCharge = {
  amount: Scalars['Int']['output'];
  booking_inclusion_id?: Maybe<Scalars['ID']['output']>;
  booking_purchasable_extra_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  inclusion?: Maybe<BookingInclusion>;
  platform_amount_collectable: Scalars['Int']['output'];
  platform_amount_refundable: Scalars['Int']['output'];
  platform_unit_price_collectable: Scalars['Int']['output'];
  purchasableExtra?: Maybe<BookingPurchasableExtra>;
  quantity: Scalars['Int']['output'];
  supplier_amount_collectable: Scalars['Int']['output'];
  supplier_amount_refundable: Scalars['Int']['output'];
  supplier_unit_price_collectable: Scalars['Int']['output'];
  type: BookingChargeType;
  unit_price: Scalars['Int']['output'];
};

export type BookingChargeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  platform_unit_price_collectable?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  supplier_unit_price_collectable?: InputMaybe<Scalars['Int']['input']>;
  type: BookingChargeType;
};

export type BookingChargeSummary = {
  pay_later_additional_charges_amount: Scalars['Int']['output'];
  pay_later_cost_amount: Scalars['Int']['output'];
  pay_later_daily_rate_amount: Scalars['Int']['output'];
  pay_later_purchasable_extra_amount: Scalars['Int']['output'];
  pay_later_relocation_rate_amount: Scalars['Int']['output'];
  pay_later_subtotal_amount: Scalars['Int']['output'];
  pay_later_total_amount: Scalars['Int']['output'];
  pay_now_booking_fee_amount: Scalars['Int']['output'];
  pay_now_cost_amount: Scalars['Int']['output'];
  pay_now_daily_rate_deposit_amount: Scalars['Int']['output'];
  pay_now_holding_deposit_amount: Scalars['Int']['output'];
  pay_now_total_amount: Scalars['Int']['output'];
  platform_refund_amount: Scalars['Int']['output'];
  refund_amount: Scalars['Int']['output'];
  subtotal_amount: Scalars['Int']['output'];
  supplier_refund_amount: Scalars['Int']['output'];
  total_amount: Scalars['Int']['output'];
};

export enum BookingChargeType {
  AdditionalCharge = 'ADDITIONAL_CHARGE',
  BookingFee = 'BOOKING_FEE',
  DailyRate = 'DAILY_RATE',
  PlatformHeldDeposit = 'PLATFORM_HELD_DEPOSIT',
  PurchasableExtra = 'PURCHASABLE_EXTRA',
  RelocationRate = 'RELOCATION_RATE',
  SupplierRefundDeposit = 'SUPPLIER_REFUND_DEPOSIT'
}

export type BookingInclusion = {
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  has_free_tank: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  type: RelocationInclusionType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type BookingInclusionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  has_free_tank?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type: RelocationInclusionType;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated list of Booking items. */
export type BookingPaginator = {
  /** A list of Booking items. */
  data: Array<Booking>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type BookingPaymentRequest = {
  amount: Scalars['Int']['output'];
  booking: Booking;
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  permalink: Scalars['String']['output'];
  status: BookingPaymentRequestStatus;
  stripePayment?: Maybe<StripePayment>;
  updated_at: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** A paginated list of BookingPaymentRequest items. */
export type BookingPaymentRequestPaginator = {
  /** A list of BookingPaymentRequest items. */
  data: Array<BookingPaymentRequest>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum BookingPaymentRequestStatus {
  AwaitingPayment = 'AWAITING_PAYMENT',
  Cancelled = 'CANCELLED',
  Paid = 'PAID',
  PaymentPending = 'PAYMENT_PENDING'
}

export enum BookingPaymentStatus {
  OnHold = 'OnHold',
  Paid = 'Paid',
  PartiallyRefunded = 'PartiallyRefunded',
  Pending = 'Pending',
  Refunded = 'Refunded'
}

export type BookingPurchasableExtra = {
  booking: Booking;
  id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  supplierPurchasableExtra: SupplierPurchasableExtra;
};

export type BookingPurchasableExtraInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  supplier_purchasable_extra_id: Scalars['ID']['input'];
};

export enum BookingRelocationMatchType {
  Broad = 'BROAD',
  Exact = 'EXACT',
  Similar = 'SIMILAR'
}

export enum BookingReportDateBasis {
  Booked = 'BOOKED',
  Confirmed = 'CONFIRMED',
  Deliver = 'DELIVER',
  Depart = 'DEPART',
  Posted = 'POSTED'
}

export enum BookingStatus {
  Accepted = 'ACCEPTED',
  AdminCancelled = 'ADMIN_CANCELLED',
  AwaitingConfirmation = 'AWAITING_CONFIRMATION',
  AwaitingPayment = 'AWAITING_PAYMENT',
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  CustomerCancelled = 'CUSTOMER_CANCELLED',
  CustomerCancelledConfirmationTimeliness = 'CUSTOMER_CANCELLED_CONFIRMATION_TIMELINESS',
  CustomerCancelledNoShow = 'CUSTOMER_CANCELLED_NO_SHOW',
  CustomerCancelledRebooked = 'CUSTOMER_CANCELLED_REBOOKED',
  SupplierCancelled = 'SUPPLIER_CANCELLED',
  SupplierCancelledMechanicalFailure = 'SUPPLIER_CANCELLED_MECHANICAL_FAILURE',
  SupplierCancelledNotAvailable = 'SUPPLIER_CANCELLED_NOT_AVAILABLE',
  SupplierCancelledNoFerry = 'SUPPLIER_CANCELLED_NO_FERRY',
  Vip = 'VIP'
}

export type BookingStatusStat = {
  count: Scalars['Int']['output'];
  status: BookingStatus;
};

export type BookingSupplierConfirmation = {
  booking?: Maybe<Booking>;
  booking_reference?: Maybe<Scalars['String']['output']>;
  checks: Array<BookingSupplierConfirmationCheck>;
  created_at: Scalars['DateTime']['output'];
  email_from: Scalars['String']['output'];
  email_received_at: Scalars['DateTime']['output'];
  email_subject: Scalars['String']['output'];
  failure_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pdf?: Maybe<Media>;
  resolvedBy?: Maybe<User>;
  resolved_at?: Maybe<Scalars['DateTime']['output']>;
  source: BookingSupplierConfirmationSource;
  status: BookingSupplierConfirmationStatus;
  supplier_reference?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type BookingSupplierConfirmationCheck = {
  actual?: Maybe<Scalars['String']['output']>;
  expected?: Maybe<Scalars['String']['output']>;
  outcome: BookingSupplierConfirmationCheckOutcome;
  type: BookingSupplierConfirmationCheckType;
};

export enum BookingSupplierConfirmationCheckOutcome {
  Fail = 'FAIL',
  Pass = 'PASS',
  Warn = 'WARN'
}

export enum BookingSupplierConfirmationCheckType {
  AmountDueOnArrival = 'AMOUNT_DUE_ON_ARRIVAL',
  BookingFound = 'BOOKING_FOUND',
  BookingStatus = 'BOOKING_STATUS',
  Currency = 'CURRENCY',
  CustomerName = 'CUSTOMER_NAME',
  DropoffDate = 'DROPOFF_DATE',
  DropoffLocation = 'DROPOFF_LOCATION',
  DropoffTime = 'DROPOFF_TIME',
  ExtraDays = 'EXTRA_DAYS',
  Passengers = 'PASSENGERS',
  PickupDate = 'PICKUP_DATE',
  PickupLocation = 'PICKUP_LOCATION',
  PickupTime = 'PICKUP_TIME',
  RelocationDays = 'RELOCATION_DAYS',
  TradePartnerCredit = 'TRADE_PARTNER_CREDIT',
  Vehicle = 'VEHICLE'
}

export enum BookingSupplierConfirmationSource {
  RcmEmail = 'RCM_EMAIL',
  ThlPdf = 'THL_PDF'
}

export enum BookingSupplierConfirmationStatus {
  AwaitingReview = 'AWAITING_REVIEW',
  Confirmed = 'CONFIRMED',
  Dismissed = 'DISMISSED',
  Duplicate = 'DUPLICATE',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

export type BookingUserRating = {
  completedRelocationCount: Scalars['Int']['output'];
  isBlocked: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  isVerifiedEmail: Scalars['Boolean']['output'];
  isVerifiedPhone: Scalars['Boolean']['output'];
};

export type BookingsSalesData = {
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type CallLogStat = {
  date: Scalars['String']['output'];
  note_count: Scalars['Int']['output'];
  phone_call_count: Scalars['Int']['output'];
};

export type CallbackLead = {
  became_callable_at?: Maybe<Scalars['DateTime']['output']>;
  booking?: Maybe<Booking>;
  bookings: Array<Booking>;
  bookings_count: Scalars['Int']['output'];
  calls: Array<CallbackLeadCall>;
  calls_count: Scalars['Int']['output'];
  closedBy?: Maybe<User>;
  closed_at?: Maybe<Scalars['DateTime']['output']>;
  contact_attempts: Scalars['Int']['output'];
  convertedBooking?: Maybe<Booking>;
  created_at: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  expires_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  last_contacted_at?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<CallbackLeadOutcome>;
  phone: Scalars['String']['output'];
  relocation?: Maybe<Relocation>;
  snoozed_until?: Maybe<Scalars['DateTime']['output']>;
  source: CallbackLeadSource;
  status: CallbackLeadStatus;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  waitlist?: Maybe<Waitlist>;
};

export type CallbackLeadCall = {
  answered_at?: Maybe<Scalars['DateTime']['output']>;
  callbackLead?: Maybe<CallbackLead>;
  created_at: Scalars['DateTime']['output'];
  /** The URI the rep's browser opens to make their Zoom client dial. */
  dial_url: Scalars['String']['output'];
  dialled_at: Scalars['DateTime']['output'];
  direction: CallbackLeadCallDirection;
  duration_seconds?: Maybe<Scalars['Int']['output']>;
  ended_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  phone: Scalars['String']['output'];
  result?: Maybe<CallbackLeadCallResult>;
  status: CallbackLeadCallStatus;
  user?: Maybe<User>;
};

export enum CallbackLeadCallDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export enum CallbackLeadCallResult {
  Busy = 'BUSY',
  Cancelled = 'CANCELLED',
  Connected = 'CONNECTED',
  NoAnswer = 'NO_ANSWER',
  Other = 'OTHER',
  Voicemail = 'VOICEMAIL'
}

export enum CallbackLeadCallStatus {
  /**
   * No call log ever arrived for a number we dialled, so the rep most likely
   * abandoned it before it connected.
   */
  Abandoned = 'ABANDONED',
  Completed = 'COMPLETED',
  /**
   * We handed the number to the rep's Zoom client and are waiting to hear what
   * became of it. Zoom tells us nothing until the call is over.
   */
  Dialling = 'DIALLING'
}

export type CallbackLeadCounts = {
  pending: Scalars['Int']['output'];
  pendingIncompleteBooking: Scalars['Int']['output'];
  pendingSupplierCancellation: Scalars['Int']['output'];
  snoozed: Scalars['Int']['output'];
};

export enum CallbackLeadOutcome {
  Booked = 'BOOKED',
  CallBackLater = 'CALL_BACK_LATER',
  Converted = 'CONVERTED',
  Dismissed = 'DISMISSED',
  DoNotCall = 'DO_NOT_CALL',
  Expired = 'EXPIRED',
  NotInterested = 'NOT_INTERESTED',
  NoAnswer = 'NO_ANSWER',
  WillRebook = 'WILL_REBOOK',
  WrongNumber = 'WRONG_NUMBER'
}

/** A paginated list of CallbackLead items. */
export type CallbackLeadPaginator = {
  /** A list of CallbackLead items. */
  data: Array<CallbackLead>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum CallbackLeadSource {
  IncompleteBooking = 'INCOMPLETE_BOOKING',
  Manual = 'MANUAL',
  SupplierCancellation = 'SUPPLIER_CANCELLATION',
  Waitlist = 'WAITLIST'
}

export enum CallbackLeadStatus {
  Closed = 'CLOSED',
  Pending = 'PENDING',
  Snoozed = 'SNOOZED'
}

export type CancelBookingStatusInput = {
  customer_note?: InputMaybe<Scalars['String']['input']>;
  /** Send the cancellation email to the supplier. Admin only; ignored for other organisations. Defaults to true. */
  notify_supplier?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
  release_relocation: Scalars['Boolean']['input'];
  status: BookingStatus;
};

export type CitiesWithDealsByRegion = {
  cities: Array<CityWithDeals>;
  region: Region;
};

export type City = {
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  formatted_name: Scalars['String']['output'];
  heroImage?: Maybe<Media>;
  heroImageGeneration?: Maybe<ImageGeneration>;
  hero_image_generation_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  region: Region;
  slug: Scalars['String']['output'];
  state: State;
  timezone: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of City items. */
export type CityPaginator = {
  /** A list of City items. */
  data: Array<City>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type CityWithDeals = {
  deal_count: Scalars['Int']['output'];
  heroImage?: Maybe<Media>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  region: Region;
  slug: Scalars['String']['output'];
  state: State;
};

export type ClosestCityResult = {
  city?: Maybe<City>;
  distance_km?: Maybe<Scalars['Float']['output']>;
};

export enum ComparisonMode {
  PreviousPeriod = 'PREVIOUS_PERIOD',
  PreviousYear = 'PREVIOUS_YEAR'
}

export enum Competitor {
  Coseats = 'COSEATS',
  Drivenow = 'DRIVENOW',
  Supplier = 'SUPPLIER',
  Transfercar = 'TRANSFERCAR'
}

export type ConfirmBookingInput = {
  customer_note?: InputMaybe<Scalars['String']['input']>;
  supplier_reference?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectBelongsTo = {
  connect?: InputMaybe<Scalars['ID']['input']>;
};

export type ConnectMorphTo = {
  connect?: InputMaybe<ConnectMorphToInput>;
};

export type ConnectMorphToInput = {
  id: Scalars['ID']['input'];
  type: ModelType;
};

export type ConnectQuote = {
  id: Scalars['ID']['input'];
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectQuoteBelongsToMany = {
  connect?: InputMaybe<Array<ConnectQuote>>;
};

export type ConnectWorkOrderInvoice = {
  id: Scalars['ID']['input'];
};

export type ConnectWorkOrderInvoiceBelongsToMany = {
  connect?: InputMaybe<Array<ConnectWorkOrderInvoice>>;
};

export type ConnectWorkOrderQuote = {
  id: Scalars['ID']['input'];
  is_current_quote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectWorkOrderQuoteBelongsToMany = {
  connect?: InputMaybe<Array<ConnectWorkOrderQuote>>;
};

export type Contact = {
  billingAddress?: Maybe<Address>;
  billing_cycle_day_of_month: Scalars['Int']['output'];
  billing_email?: Maybe<Scalars['String']['output']>;
  billing_phone?: Maybe<Scalars['String']['output']>;
  company_number?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  credit_balances: Array<ContactCreditBalance>;
  credits: Array<ContactCredit>;
  id: Scalars['ID']['output'];
  legal_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisation?: Maybe<Organisation>;
  parentContact?: Maybe<Contact>;
  profilePicture?: Maybe<Media>;
  purchase_order_number?: Maybe<Scalars['String']['output']>;
  stripeCustomer?: Maybe<StripeCustomer>;
  type: ContactType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type ContactCredit = {
  /** Signed minor units: positive puts credit on the ledger, negative takes it off. */
  amount: Scalars['Int']['output'];
  attributedTo?: Maybe<ContactCreditAttributedTo>;
  attributed_to_id?: Maybe<Scalars['ID']['output']>;
  attributed_to_type?: Maybe<ModelType>;
  contact: Contact;
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoicePayment?: Maybe<InvoicePayment>;
  reference: Scalars['String']['output'];
  reversal?: Maybe<ContactCredit>;
  reverses?: Maybe<ContactCredit>;
  type: ContactCreditType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ContactCreditAttributedTo = Booking;

export type ContactCreditBalance = {
  amount: Scalars['Int']['output'];
  currency: Currency;
};

/** A paginated list of ContactCredit items. */
export type ContactCreditPaginator = {
  /** A list of ContactCredit items. */
  data: Array<ContactCredit>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum ContactCreditType {
  Applied = 'APPLIED',
  Issued = 'ISSUED',
  Reversed = 'REVERSED'
}

/** A paginated list of Contact items. */
export type ContactPaginator = {
  /** A list of Contact items. */
  data: Array<Contact>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum ContactType {
  Entity = 'ENTITY',
  Guest = 'GUEST',
  Organisation = 'ORGANISATION',
  System = 'SYSTEM',
  User = 'USER'
}

export type CreateAdminBookingPaymentIntentInput = {
  amount: Scalars['Int']['input'];
  currency: Currency;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBillingSessionInput = {
  cancel_url: Scalars['String']['input'];
  contact_id: Scalars['ID']['input'];
  success_url: Scalars['String']['input'];
};

export type CreateBlocklistInput = {
  email: Scalars['String']['input'];
  managed_by_id?: InputMaybe<Scalars['ID']['input']>;
  phone: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateBlogAuthorInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBlogPostInput = {
  audience?: InputMaybe<BlogAudience>;
  blog_author_id?: InputMaybe<Scalars['ID']['input']>;
  body_html?: InputMaybe<Scalars['String']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  reading_time_minutes?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateBlogPostTripArticle = {
  blog_post_id: Scalars['ID']['input'];
  destination_city_id: Scalars['ID']['input'];
  origin_city_id: Scalars['ID']['input'];
};

export type CreateBlogTagInput = {
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type CreateBookingChangeRequestInput = {
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  deliver_at?: InputMaybe<Scalars['DateTime']['input']>;
  depart_at?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number_of_travellers?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<Scalars['String']['input']>;
  type: BookingChangeRequestType;
};

export type CreateBookingInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  date_of_birth: Scalars['String']['input'];
  deliver_at: Scalars['DateTime']['input'];
  depart_at: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  metadata?: InputMaybe<CreateMetadataInput>;
  name: Scalars['String']['input'];
  number_of_travellers: Scalars['Int']['input'];
  phone: Scalars['String']['input'];
  preferred_ferry_date?: InputMaybe<Scalars['String']['input']>;
  purchasableExtras?: InputMaybe<UpsertBookingPurchasableExtraInput>;
  relocation: ConnectBelongsTo;
  user?: InputMaybe<ConnectBelongsTo>;
};

export type CreateBookingPaymentRequestInput = {
  amount: Scalars['Int']['input'];
  booking: ConnectBelongsTo;
  currency: Currency;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCallbackLeadInput = {
  call_back_at?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type CreateCityInput = {
  name: Scalars['String']['input'];
  region: Region;
  slug: Scalars['String']['input'];
  state: State;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactInput = {
  billingAddress?: InputMaybe<BelongsToAddress>;
  billing_cycle_day_of_month?: InputMaybe<Scalars['Int']['input']>;
  billing_email?: InputMaybe<Scalars['String']['input']>;
  billing_phone?: InputMaybe<Scalars['String']['input']>;
  company_number?: InputMaybe<Scalars['String']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  managedBy?: InputMaybe<ConnectBelongsTo>;
  name: Scalars['String']['input'];
  parentContact?: InputMaybe<ConnectBelongsTo>;
  purchase_order_number?: InputMaybe<Scalars['String']['input']>;
  type: ContactType;
};

export type CreateEntityInput = {
  name: Scalars['String']['input'];
};

export type CreateFaqInput = {
  answer: Scalars['String']['input'];
  display_on_relocation?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  question: Scalars['String']['input'];
};

export type CreateIntegrationInput = {
  supplier: ConnectBelongsTo;
  type: IntegrationType;
};

export type CreateIntegrationLinkInput = {
  external_id: Scalars['String']['input'];
  integration: ConnectBelongsTo;
  object: ConnectMorphTo;
};

export type CreateInvoiceInput = {
  currency: Currency;
  due_date?: InputMaybe<Scalars['String']['input']>;
  invoice_date?: InputMaybe<Scalars['String']['input']>;
  is_tax_included: Scalars['Boolean']['input'];
  lineItems: UpdatePayableLineItemInput;
  payee: ConnectBelongsTo;
  purchase_order_number?: InputMaybe<Scalars['String']['input']>;
  quote?: InputMaybe<ConnectBelongsTo>;
  workOrders?: InputMaybe<ConnectWorkOrderInvoiceBelongsToMany>;
};

export type CreateInvoicePaymentInput = {
  amount: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  invoice: ConnectBelongsTo;
  method: InvoicePaymentMethod;
  payment_date: Scalars['String']['input'];
  type: InvoicePaymentType;
};

export type CreateItineraryInput = {
  legs: Array<CreateItineraryLegInput>;
};

export type CreateItineraryLegInput = {
  delivery_date: Scalars['Date']['input'];
  delivery_time?: InputMaybe<Scalars['String']['input']>;
  departure_date: Scalars['Date']['input'];
  departure_time?: InputMaybe<Scalars['String']['input']>;
  relocation_id: Scalars['ID']['input'];
};

export type CreateJobOpeningOfferInput = {
  pro_driver_id: Scalars['ID']['input'];
};

export type CreateMediaInput = {
  collectionName: MediaCollection;
  file_name: Scalars['String']['input'];
  key: Scalars['String']['input'];
  objectId: Scalars['ID']['input'];
  objectType: ModelType;
};

export type CreateMetadataInput = {
  create: MetadataInput;
};

export type CreateOrganisationInput = {
  name: Scalars['String']['input'];
};

export type CreatePartnerInput = {
  logo_path?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaymentInput = {
  amount: Scalars['Int']['input'];
  attributedTo: ConnectMorphTo;
  currency: Currency;
  description?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['String']['input']>;
  is_tax_included: Scalars['Boolean']['input'];
  payee?: InputMaybe<ConnectBelongsTo>;
  tax_type: TaxType;
  type: PaymentType;
};

export type CreatePaymentIntentInput = {
  referral_code?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePayoutLineItemInput = {
  amount_inc_tax: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tax_type: TaxType;
};

export type CreatePopularTripInput = {
  allow_booking_requests: Scalars['Boolean']['input'];
  deliveryCity: ConnectBelongsTo;
  departureCity: ConnectBelongsTo;
  region: Region;
  standard_relocation_days_allowed: Scalars['Int']['input'];
};

export type CreateProDriverAgreementInput = {
  template_id: Scalars['ID']['input'];
  work_order_assignment_id: Scalars['ID']['input'];
};

export type CreateProDriverAgreementTemplateInput = {
  body: Scalars['String']['input'];
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateProDriverInput = {
  /** City where driver is based */
  basedIn: ConnectBelongsTo;
  /** Driver bio */
  bio?: InputMaybe<Scalars['String']['input']>;
  /** Business registration number (ABN, GST number, etc) */
  business_registration_number?: InputMaybe<Scalars['String']['input']>;
  /** Email for new user - required if user is not provided */
  email?: InputMaybe<Scalars['String']['input']>;
  /** License issuer (state/country) */
  license_issuer?: InputMaybe<Scalars['String']['input']>;
  /** License number */
  license_number?: InputMaybe<Scalars['String']['input']>;
  /** License type */
  license_type?: InputMaybe<ProDriverLicenseType>;
  /** Name for new user - required if user is not provided */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Phone for new user - optional */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Tax registration type */
  tax_registration?: InputMaybe<TaxRegistration>;
  /** Connect to an existing user - if provided, email/name/phone are ignored */
  user?: InputMaybe<ConnectBelongsTo>;
};

export type CreateQuoteInput = {
  additional_notations?: InputMaybe<Scalars['String']['input']>;
  currency: Currency;
  expiry_date: Scalars['String']['input'];
  lineItems: QuoteLineItemUpsertInput;
  payee: ConnectBelongsTo;
  quote_date: Scalars['String']['input'];
  tax_inclusion_type: TaxInclusionType;
  workOrders?: InputMaybe<ConnectWorkOrderQuoteBelongsToMany>;
};

export type CreateReceiptInput = {
  amount_inc_tax: Scalars['Int']['input'];
  amount_tax: Scalars['Int']['input'];
  currency: Currency;
  date: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  filePath: Scalars['String']['input'];
  objectId: Scalars['ID']['input'];
  objectType: ModelType;
  type: ReceiptType;
};

export type CreateRefundPaymentInput = {
  amount: Scalars['Int']['input'];
  currency: Currency;
  method: RefundPaymentMethod;
  refund_form_id: Scalars['ID']['input'];
  refunded_at?: InputMaybe<Scalars['String']['input']>;
  transaction_number?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRelocationHighlightInput = {
  deliveryCity?: InputMaybe<ConnectBelongsTo>;
  departureCity?: InputMaybe<ConnectBelongsTo>;
  order?: InputMaybe<Scalars['Int']['input']>;
  primary_text: Scalars['String']['input'];
  region?: InputMaybe<Region>;
  secondary_text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRelocationInput = {
  acknowledgements?: InputMaybe<UpsertRelocationAcknowledgements>;
  available_from_date: Scalars['String']['input'];
  available_to_date: Scalars['String']['input'];
  booking_fee_amount: Scalars['Int']['input'];
  charge_per_move_amount: Scalars['Int']['input'];
  /** Available relocations. Equal to quantity at creation (nothing booked yet). */
  count?: InputMaybe<Scalars['Int']['input']>;
  currency: Currency;
  deliveryOffice: ConnectBelongsTo;
  departureOffice: ConnectBelongsTo;
  discount_percent?: InputMaybe<Scalars['Int']['input']>;
  distance_allowed?: InputMaybe<Scalars['Int']['input']>;
  excess_distance_rate?: InputMaybe<Scalars['Int']['input']>;
  extra_distance_allowed_per_extra_hire_unit?: InputMaybe<Scalars['Int']['input']>;
  extra_hire_unit_deposit_rate: Scalars['Int']['input'];
  extra_hire_unit_rate: Scalars['Int']['input'];
  extra_hire_unit_supplier_net_rate?: InputMaybe<Scalars['Int']['input']>;
  extra_hire_units_allowed: Scalars['Int']['input'];
  fixed_latest_departure_date?: InputMaybe<Scalars['String']['input']>;
  hire_unit_rate: Scalars['Int']['input'];
  hire_unit_type: HireUnitType;
  hire_units_allowed: Scalars['Int']['input'];
  holding_deposit_amount: Scalars['Int']['input'];
  holding_deposit_refunded_at: DepositRefundedAt;
  holding_deposit_refunded_by: HoldingDepositRefundedBy;
  inclusions?: InputMaybe<UpsertRelocationInclusions>;
  is_ferry_required?: InputMaybe<Scalars['Boolean']['input']>;
  lines?: InputMaybe<UpsertRelocationLines>;
  measurement: Measurement;
  minimum_hire_units: Scalars['Int']['input'];
  open_delivery_dates?: InputMaybe<Array<Scalars['String']['input']>>;
  open_departure_dates?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Constant fleet size for the listing. One of quantity or count is required. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  retail_rate?: InputMaybe<Scalars['Int']['input']>;
  supplier: ConnectBelongsTo;
  supplierInsuranceOption: ConnectBelongsTo;
  type?: InputMaybe<RelocationType>;
  vehicle: ConnectBelongsTo;
};

export type CreateRelocationPageArticle = {
  dato_article_slug: Scalars['String']['input'];
  relocation_page_id: Scalars['ID']['input'];
};

export type CreateRelocationPageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  points: Scalars['Mixed']['input'];
  region: Region;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateSalesOrganisationAttributionInput = {
  organisation: ConnectBelongsTo;
  user: ConnectBelongsTo;
};

export type CreateSetupIntentInput = {
  contact_id: Scalars['ID']['input'];
};

export type CreateSupplierAcknowledgementInput = {
  acknowledgement: Scalars['String']['input'];
  name: Scalars['String']['input'];
  supplier_id: Scalars['String']['input'];
};

export type CreateSupplierAdminContactInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  supplier_id: Scalars['String']['input'];
};

export type CreateSupplierInput = {
  age_surcharge_amount?: InputMaybe<Scalars['Int']['input']>;
  age_surcharge_type?: InputMaybe<AgeSurchargeType>;
  billingEntity?: InputMaybe<ConnectBelongsTo>;
  billing_currency?: InputMaybe<Currency>;
  booking_fee_amount?: InputMaybe<Scalars['Int']['input']>;
  charge_per_move_amount?: InputMaybe<Scalars['Int']['input']>;
  closed_dates?: InputMaybe<Scalars['Mixed']['input']>;
  collect_address_on_bookings?: InputMaybe<Scalars['Boolean']['input']>;
  collect_gender_on_bookings?: InputMaybe<Scalars['Boolean']['input']>;
  currency: Currency;
  debit_card_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  default_extra_hire_units_allowed?: InputMaybe<Scalars['Int']['input']>;
  delivery_hours?: InputMaybe<Scalars['Mixed']['input']>;
  departure_hours?: InputMaybe<Scalars['Mixed']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_on_line_sold?: InputMaybe<Scalars['Boolean']['input']>;
  excess_distance_rate?: InputMaybe<Scalars['Int']['input']>;
  extra_distance_allowed_per_extra_hire_unit?: InputMaybe<Scalars['Int']['input']>;
  ferry_refund_fee?: InputMaybe<Scalars['Int']['input']>;
  fuel_refund_fee?: InputMaybe<Scalars['Int']['input']>;
  fuel_refund_instructions?: InputMaybe<Scalars['String']['input']>;
  gap_rentals_cancellation_policy?: InputMaybe<Scalars['String']['input']>;
  gap_rentals_standard_inclusions?: InputMaybe<Scalars['String']['input']>;
  has_age_surcharge?: InputMaybe<Scalars['Boolean']['input']>;
  hire_unit_type: HireUnitType;
  holding_deposit_amount?: InputMaybe<Scalars['Int']['input']>;
  holding_deposit_refunded_at?: InputMaybe<DepositRefundedAt>;
  holding_deposit_refunded_by?: InputMaybe<HoldingDepositRefundedBy>;
  imoova_refunds_ferry?: InputMaybe<Scalars['Boolean']['input']>;
  imoova_refunds_fuel?: InputMaybe<Scalars['Boolean']['input']>;
  import_template?: InputMaybe<Scalars['String']['input']>;
  is_holding_deposit_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_tax_included?: InputMaybe<Scalars['Boolean']['input']>;
  line_sold_email?: InputMaybe<Scalars['String']['input']>;
  line_sold_timezone?: InputMaybe<Scalars['String']['input']>;
  managed_by_id?: InputMaybe<Scalars['ID']['input']>;
  maximum_age?: InputMaybe<Scalars['Int']['input']>;
  maximum_no_surcharge_age?: InputMaybe<Scalars['Int']['input']>;
  measurement?: InputMaybe<Measurement>;
  minimum_age?: InputMaybe<Scalars['Int']['input']>;
  minimum_no_surcharge_age?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  payment_instructions?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pre_checkin_instructions?: InputMaybe<Scalars['String']['input']>;
  relist_on_cancellation?: InputMaybe<Scalars['Boolean']['input']>;
  relocation_lines_valid_until?: InputMaybe<Scalars['String']['input']>;
  standard_inclusions?: InputMaybe<Scalars['String']['input']>;
  tax_type?: InputMaybe<TaxType>;
};

export type CreateSupplierInsuranceOptionInput = {
  bond_amount?: InputMaybe<Scalars['Int']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  liability_reduction_options?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  standard_liability_amount?: InputMaybe<Scalars['Int']['input']>;
  supplier: ConnectBelongsTo;
};

export type CreateSupplierOfficeInput = {
  address: BelongsToAddress;
  billing_entity_id?: InputMaybe<Scalars['ID']['input']>;
  booking_email?: InputMaybe<Scalars['String']['input']>;
  cc_booking_to_departure_office?: InputMaybe<Scalars['Boolean']['input']>;
  city: ConnectBelongsTo;
  closed_dates?: InputMaybe<Scalars['Mixed']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  delivery_hours?: InputMaybe<Scalars['Mixed']['input']>;
  departure_hours?: InputMaybe<Scalars['Mixed']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  pickup_instructions?: InputMaybe<Scalars['String']['input']>;
  supplier: ConnectBelongsTo;
};

export type CreateSupplierPurchasableExtraInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  supplier: ConnectBelongsTo;
  /** Zero means the extra is offered free of charge */
  unit_price: Scalars['Int']['input'];
  units_purchasable: Scalars['Int']['input'];
};

export type CreateSupplierTripInput = {
  distance_allowed?: InputMaybe<Scalars['Int']['input']>;
  extra_hire_units_allowed: Scalars['Int']['input'];
  hire_units_allowed: Scalars['Int']['input'];
  inclusions?: InputMaybe<UpsertSupplierTripInclusion>;
  is_ferry_required?: InputMaybe<Scalars['Boolean']['input']>;
  minimum_hire_units: Scalars['Int']['input'];
  officeA: ConnectBelongsTo;
  officeB: ConnectBelongsTo;
  supplier: ConnectBelongsTo;
};

export type CreateThreadInput = {
  managed_by_id?: InputMaybe<Scalars['ID']['input']>;
  threadable_id: Scalars['ID']['input'];
  threadable_type: Scalars['String']['input'];
  user_ids: Array<Scalars['ID']['input']>;
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primary_phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVehicleInput = {
  approximate_age?: InputMaybe<VehicleApproximateAge>;
  brand?: InputMaybe<Scalars['String']['input']>;
  child_seat_anchor_points?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extra_hire_unit_deposit_rate?: InputMaybe<Scalars['Int']['input']>;
  extra_hire_unit_rate?: InputMaybe<Scalars['Int']['input']>;
  extra_hire_unit_supplier_net_rate?: InputMaybe<Scalars['Int']['input']>;
  fuel: Fuel;
  has_heating?: InputMaybe<Scalars['Boolean']['input']>;
  has_kitchen?: InputMaybe<Scalars['Boolean']['input']>;
  has_shower_and_toilet?: InputMaybe<Scalars['Boolean']['input']>;
  hire_unit_rate: Scalars['Int']['input'];
  hire_unit_type: HireUnitType;
  is_pet_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_self_contained?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pet_cleaning_fee?: InputMaybe<Scalars['Int']['input']>;
  seatbelts: Scalars['Int']['input'];
  sleeps?: InputMaybe<Scalars['Int']['input']>;
  supplier: ConnectBelongsTo;
  transmission: Transmission;
  type: VehicleType;
};

export type CreateWaitlistInput = {
  delivery_city_id?: InputMaybe<Scalars['String']['input']>;
  delivery_state?: InputMaybe<State>;
  departure_city_id?: InputMaybe<Scalars['String']['input']>;
  departure_state?: InputMaybe<State>;
  earliest_departure_date: Scalars['String']['input'];
  latest_departure_date: Scalars['String']['input'];
  number_of_travellers?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<WaitlistSource>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  vehicle_category?: InputMaybe<VehicleCategory>;
};

export type CreateWorkOrderAssignmentExpenseInput = {
  amount: Scalars['Int']['input'];
  currency: Currency;
  description?: InputMaybe<Scalars['String']['input']>;
  paid_by: ExpensePaidBy;
  paid_to: ExpensePaidTo;
  type: ExpenseType;
  workOrderAssignment: ConnectBelongsTo;
};

export type CreateWorkOrderAssignmentPayoutInput = {
  currency: Currency;
  lineItems: Array<CreatePayoutLineItemInput>;
  paid_at?: InputMaybe<Scalars['String']['input']>;
  send_email?: InputMaybe<Scalars['Boolean']['input']>;
  transaction_reference?: InputMaybe<Scalars['String']['input']>;
  workOrderAssignmentId: Scalars['ID']['input'];
};

export type CreateWorkOrderDriverExpenseInput = {
  amount: Scalars['Int']['input'];
  currency: Currency;
  description?: InputMaybe<Scalars['String']['input']>;
  paid_by: ExpensePaidBy;
  paid_to: ExpensePaidTo;
  type: ExpenseType;
};

export type CreateWorkOrderDriverInput = {
  agreement_template_id?: InputMaybe<Scalars['ID']['input']>;
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  delivery_time?: InputMaybe<Scalars['String']['input']>;
  driver_notes?: InputMaybe<Scalars['String']['input']>;
  driver_pay?: InputMaybe<Scalars['Int']['input']>;
  driver_pay_currency?: InputMaybe<Currency>;
  expenses?: InputMaybe<Array<CreateWorkOrderDriverExpenseInput>>;
  pickup_date?: InputMaybe<Scalars['String']['input']>;
  pickup_time?: InputMaybe<Scalars['String']['input']>;
  proDriver: ConnectBelongsTo;
  workOrder: ConnectBelongsTo;
};

export type CreateWorkOrderDriverReviewInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  pro_driver_id: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
  work_order_assignment_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateWorkOrderInput = {
  currency?: InputMaybe<Currency>;
  deliver_before?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress: BelongsToAddress;
  depart_after?: InputMaybe<Scalars['String']['input']>;
  departureAddress: BelongsToAddress;
  description?: InputMaybe<Scalars['String']['input']>;
  has_return_trip?: InputMaybe<Scalars['Boolean']['input']>;
  is_service_center?: InputMaybe<Scalars['Boolean']['input']>;
  notificationSettings?: InputMaybe<CreateWorkOrderNotificationSettingsManyInput>;
  number_of_drivers: Scalars['Int']['input'];
  relocation?: InputMaybe<ConnectBelongsTo>;
  supplier: ConnectBelongsTo;
  vehicle_type: VehicleType;
};

export type CreateWorkOrderJobOpeningInput = {
  deliver_at?: InputMaybe<Scalars['String']['input']>;
  depart_at?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  driver_filter?: InputMaybe<WorkOrderJobOpeningDriverFilterInput>;
  positions_available: Scalars['Int']['input'];
  pro_driver_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  work_order_id: Scalars['ID']['input'];
};

export type CreateWorkOrderJobOpeningOfferInput = {
  job_opening_id: Scalars['ID']['input'];
  pro_driver_id: Scalars['ID']['input'];
};

export type CreateWorkOrderJobOpeningOffersInput = {
  driver_filter?: InputMaybe<WorkOrderJobOpeningDriverFilterInput>;
  job_opening_id: Scalars['ID']['input'];
  pro_driver_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateWorkOrderNotificationSettingInput = {
  email: Scalars['String']['input'];
  type: SupplierNotificationSettingType;
};

export type CreateWorkOrderNotificationSettingsManyInput = {
  create?: InputMaybe<Array<CreateWorkOrderNotificationSettingInput>>;
};

export enum Currency {
  Aed = 'AED',
  Ars = 'ARS',
  Aud = 'AUD',
  Brl = 'BRL',
  Cad = 'CAD',
  Clp = 'CLP',
  Dkk = 'DKK',
  Eur = 'EUR',
  Fjd = 'FJD',
  Gbp = 'GBP',
  Idr = 'IDR',
  Jpy = 'JPY',
  Krw = 'KRW',
  Mxn = 'MXN',
  Nok = 'NOK',
  Nzd = 'NZD',
  Pgk = 'PGK',
  Sbd = 'SBD',
  Sek = 'SEK',
  Twd = 'TWD',
  Usd = 'USD',
  Vuv = 'VUV',
  Xpf = 'XPF',
  Zar = 'ZAR'
}

export type DashboardBookingStat = {
  count_cancelled: Scalars['Int']['output'];
  count_completed: Scalars['Int']['output'];
  count_confirmed: Scalars['Int']['output'];
  count_pending: Scalars['Int']['output'];
  count_vip: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type DashboardRegionStat = {
  bookings_cancelled_count: Scalars['Int']['output'];
  bookings_count: Scalars['Int']['output'];
  bookings_pending_count: Scalars['Int']['output'];
  pro_drivers_count: Scalars['Int']['output'];
  region: Region;
  relocations_count: Scalars['Int']['output'];
  relocations_original_count: Scalars['Int']['output'];
  waitlists_count: Scalars['Int']['output'];
  work_orders_count: Scalars['Int']['output'];
};

export type DashboardStats = {
  android_bookings_count: Scalars['Int']['output'];
  bookings: Array<DashboardBookingStat>;
  bookings_count: Scalars['Int']['output'];
  bookings_total_trend: Scalars['Float']['output'];
  bookings_trend: Scalars['Float']['output'];
  ios_bookings_count: Scalars['Int']['output'];
  pro_drivers_count: Scalars['Int']['output'];
  pro_drivers_trend: Scalars['Float']['output'];
  regions: Array<DashboardRegionStat>;
  relocations_trend: Scalars['Float']['output'];
  unknown_platform_bookings_count: Scalars['Int']['output'];
  waitlists_count: Scalars['Int']['output'];
  waitlists_trend: Scalars['Float']['output'];
  web_bookings_count: Scalars['Int']['output'];
  work_orders_trend: Scalars['Float']['output'];
};

/** Deprecated backwards-compat type for old mobile clients. The backing table was removed; queries always return empty. */
export type DatoTripArticle = {
  created_at: Scalars['DateTime']['output'];
  dato_article_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export enum DayOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type DefaultRate = {
  booking_fee_amount: Scalars['Int']['output'];
  charge_per_move_amount: Scalars['Int']['output'];
  currency: Currency;
  extra_hire_unit_deposit_rate: Scalars['Int']['output'];
  hire_unit_rate: Scalars['Int']['output'];
  holding_deposit_amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export enum DepositRefundedAt {
  Delivery = 'Delivery',
  Departure = 'Departure'
}

export type EmailEvent = {
  created_at: Scalars['DateTime']['output'];
  failure_code?: Maybe<Scalars['Int']['output']>;
  failure_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message_id: Scalars['String']['output'];
  object_id: Scalars['ID']['output'];
  object_type: Scalars['String']['output'];
  recipient: Scalars['String']['output'];
  status: EmailEventStatus;
  type: EmailType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of EmailEvent items. */
export type EmailEventPaginator = {
  /** A list of EmailEvent items. */
  data: Array<EmailEvent>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum EmailEventStatus {
  Accepted = 'ACCEPTED',
  Clicked = 'CLICKED',
  Complained = 'COMPLAINED',
  Delivered = 'DELIVERED',
  Opened = 'OPENED',
  PermanentFail = 'PERMANENT_FAIL',
  Rejected = 'REJECTED',
  Stored = 'STORED',
  TemporaryFail = 'TEMPORARY_FAIL',
  Unsubscribed = 'UNSUBSCRIBED'
}

export type EmailProDriversInput = {
  body: Scalars['String']['input'];
  driver_ids: Array<Scalars['String']['input']>;
  from_email: Scalars['String']['input'];
  from_name: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export enum EmailType {
  AdminBookingHoldingDepositReleaseFailed = 'ADMIN_BOOKING_HOLDING_DEPOSIT_RELEASE_FAILED',
  AdminBookingNoPayments = 'ADMIN_BOOKING_NO_PAYMENTS',
  AdminBookingSupplierCancelled = 'ADMIN_BOOKING_SUPPLIER_CANCELLED',
  BookingChangeRequestActioned = 'BOOKING_CHANGE_REQUEST_ACTIONED',
  BookingChangeRequestApproved = 'BOOKING_CHANGE_REQUEST_APPROVED',
  BookingChangeRequestDeclined = 'BOOKING_CHANGE_REQUEST_DECLINED',
  BookingChangeRequestPaymentRequest = 'BOOKING_CHANGE_REQUEST_PAYMENT_REQUEST',
  BookingChangeRequestPending = 'BOOKING_CHANGE_REQUEST_PENDING',
  BookingFerryRefundPaymentSent = 'BOOKING_FERRY_REFUND_PAYMENT_SENT',
  BookingFerryRefundPending = 'BOOKING_FERRY_REFUND_PENDING',
  BookingFuelRefundPaymentSent = 'BOOKING_FUEL_REFUND_PAYMENT_SENT',
  BookingFuelRefundPending = 'BOOKING_FUEL_REFUND_PENDING',
  BookingFuelRefundSubmitted = 'BOOKING_FUEL_REFUND_SUBMITTED',
  BookingPaymentRequestCancelled = 'BOOKING_PAYMENT_REQUEST_CANCELLED',
  BookingPaymentRequestCaptured = 'BOOKING_PAYMENT_REQUEST_CAPTURED',
  BookingPaymentRequestCreated = 'BOOKING_PAYMENT_REQUEST_CREATED',
  BookingPaymentRequestPending = 'BOOKING_PAYMENT_REQUEST_PENDING',
  BookingReport = 'BOOKING_REPORT',
  CompetitorReport = 'COMPETITOR_REPORT',
  CustomerBookingAbandonedCheckout = 'CUSTOMER_BOOKING_ABANDONED_CHECKOUT',
  CustomerBookingCancelled = 'CUSTOMER_BOOKING_CANCELLED',
  CustomerBookingConfirmed = 'CUSTOMER_BOOKING_CONFIRMED',
  CustomerBookingHoldingDepositReleased = 'CUSTOMER_BOOKING_HOLDING_DEPOSIT_RELEASED',
  CustomerBookingPending = 'CUSTOMER_BOOKING_PENDING',
  CustomerBookingPreDeparture = 'CUSTOMER_BOOKING_PRE_DEPARTURE',
  CustomerBookingReviewRequest = 'CUSTOMER_BOOKING_REVIEW_REQUEST',
  CustomerBookingTripStarted = 'CUSTOMER_BOOKING_TRIP_STARTED',
  CustomerBookingVip = 'CUSTOMER_BOOKING_VIP',
  CustomerItineraryAllLegsBooked = 'CUSTOMER_ITINERARY_ALL_LEGS_BOOKED',
  CustomerItineraryFirstLegBooked = 'CUSTOMER_ITINERARY_FIRST_LEG_BOOKED',
  CustomerItineraryLegConfirmed = 'CUSTOMER_ITINERARY_LEG_CONFIRMED',
  DriverAssignmentReviewRequest = 'DRIVER_ASSIGNMENT_REVIEW_REQUEST',
  IncidentReported = 'INCIDENT_REPORTED',
  IntegrationJucyExportFailed = 'INTEGRATION_JUCY_EXPORT_FAILED',
  IntegrationRcmPushFailed = 'INTEGRATION_RCM_PUSH_FAILED',
  IntegrationRcmPushSuccess = 'INTEGRATION_RCM_PUSH_SUCCESS',
  InvoiceIssued = 'INVOICE_ISSUED',
  InvoiceOverdue = 'INVOICE_OVERDUE',
  InvoicePaymentMjml = 'INVOICE_PAYMENT_MJML',
  InvoicePaymentReceived = 'INVOICE_PAYMENT_RECEIVED',
  NewMessageNotification = 'NEW_MESSAGE_NOTIFICATION',
  OnboardingOrganisationSignup = 'ONBOARDING_ORGANISATION_SIGNUP',
  OnboardingTradePartnerLead = 'ONBOARDING_TRADE_PARTNER_LEAD',
  ProDriverAgreementRequested = 'PRO_DRIVER_AGREEMENT_REQUESTED',
  ProDriverAgreementSigned = 'PRO_DRIVER_AGREEMENT_SIGNED',
  ProDriverAppDownloadReminder = 'PRO_DRIVER_APP_DOWNLOAD_REMINDER',
  ProDriverBroadcast = 'PRO_DRIVER_BROADCAST',
  ProDriverJobOpeningClosed = 'PRO_DRIVER_JOB_OPENING_CLOSED',
  ProDriverJobOpeningOffer = 'PRO_DRIVER_JOB_OPENING_OFFER',
  QuoteIssued = 'QUOTE_ISSUED',
  RelocationsExpireLapsed = 'RELOCATIONS_EXPIRE_LAPSED',
  RelocationsRemoveBookingFee = 'RELOCATIONS_REMOVE_BOOKING_FEE',
  RelocationAdded = 'RELOCATION_ADDED',
  RelocationLineReleased = 'RELOCATION_LINE_RELEASED',
  RelocationLineSold = 'RELOCATION_LINE_SOLD',
  RideshareListing = 'RIDESHARE_LISTING',
  SupplierBookingAccepted = 'SUPPLIER_BOOKING_ACCEPTED',
  SupplierBookingCancelledAfterConfirmation = 'SUPPLIER_BOOKING_CANCELLED_AFTER_CONFIRMATION',
  SupplierBookingCancelledBeforeConfirmation = 'SUPPLIER_BOOKING_CANCELLED_BEFORE_CONFIRMATION',
  SupplierBookingConfirmed = 'SUPPLIER_BOOKING_CONFIRMED',
  SupplierBookingPending = 'SUPPLIER_BOOKING_PENDING',
  SupplierBookingPendingReminder = 'SUPPLIER_BOOKING_PENDING_REMINDER',
  WaitlistCreated = 'WAITLIST_CREATED',
  WaitlistMatch = 'WAITLIST_MATCH',
  WorkOrderAssignmentReceiptsApproved = 'WORK_ORDER_ASSIGNMENT_RECEIPTS_APPROVED',
  WorkOrderAssignmentReceiptsUploaded = 'WORK_ORDER_ASSIGNMENT_RECEIPTS_UPLOADED',
  WorkOrderQuoteAccepted = 'WORK_ORDER_QUOTE_ACCEPTED',
  WorkOrderQuoteRejected = 'WORK_ORDER_QUOTE_REJECTED',
  WorkOrderRequested = 'WORK_ORDER_REQUESTED'
}

export enum EmailValidationResult {
  CatchAll = 'CATCH_ALL',
  Deliverable = 'DELIVERABLE',
  DoNotSend = 'DO_NOT_SEND',
  Undeliverable = 'UNDELIVERABLE',
  Unknown = 'UNKNOWN'
}

export type EmailValidationVerdict = {
  /** Suggested correction for a mistyped domain, e.g. gmail.com for gmial.com. */
  did_you_mean?: Maybe<Scalars['String']['output']>;
  result: EmailValidationResult;
  /** True when the address should be rejected rather than merely flagged. */
  should_block: Scalars['Boolean']['output'];
};

export enum ExpensePaidBy {
  Driver = 'DRIVER',
  Imoova = 'IMOOVA'
}

export enum ExpensePaidTo {
  Driver = 'DRIVER',
  ThirdParty = 'THIRD_PARTY'
}

export enum ExpenseType {
  Accommodation = 'ACCOMMODATION',
  DriverPay = 'DRIVER_PAY',
  Ferry = 'FERRY',
  Flight = 'FLIGHT',
  Fuel = 'FUEL',
  Other = 'OTHER',
  Toll = 'TOLL',
  Transportation = 'TRANSPORTATION'
}

export type Faq = {
  answer: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  display_on_relocation: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type FeatureFlag = {
  created_at: Scalars['DateTime']['output'];
  type: FeatureFlagType;
};

export enum FeatureFlagType {
  BlockWhenInvoiceOverdue = 'BLOCK_WHEN_INVOICE_OVERDUE',
  BookingAcceptedState = 'BOOKING_ACCEPTED_STATE',
  CampermanGapFillerIntegration = 'CAMPERMAN_GAP_FILLER_INTEGRATION',
  CampermanIntegration = 'CAMPERMAN_INTEGRATION',
  GapRentals = 'GAP_RENTALS',
  GoogleSheetsIntegration = 'GOOGLE_SHEETS_INTEGRATION',
  InvoiceOverdueBanner = 'INVOICE_OVERDUE_BANNER',
  JucyIntegration = 'JUCY_INTEGRATION',
  RcmIntegration = 'RCM_INTEGRATION',
  RoadsurferIntegration = 'ROADSURFER_INTEGRATION',
  VariableRelocationRate = 'VARIABLE_RELOCATION_RATE'
}

export enum Fuel {
  Diesel = 'DIESEL',
  Electric = 'ELECTRIC',
  Gasoline = 'GASOLINE',
  Hybrid = 'HYBRID'
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

export type GenerateStatementOfAccountsInput = {
  contactId: Scalars['ID']['input'];
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type GlobeArcLine = {
  endLat: Scalars['Float']['output'];
  endLng: Scalars['Float']['output'];
  startLat: Scalars['Float']['output'];
  startLng: Scalars['Float']['output'];
};

export type GoogleMapsAddressComponent = {
  longText: Scalars['String']['output'];
  shortText?: Maybe<Scalars['String']['output']>;
  types: Array<Scalars['String']['output']>;
};

export type GoogleMapsAutocompleteInput = {
  biasLat?: InputMaybe<Scalars['Float']['input']>;
  biasLng?: InputMaybe<Scalars['Float']['input']>;
  biasRadiusKm?: InputMaybe<Scalars['Float']['input']>;
  search: Scalars['String']['input'];
  sessiontoken?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<State>;
};

export type GoogleMapsDisplayName = {
  languageCode?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type GoogleMapsLocation = {
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GoogleMapsPlace = {
  placeId: Scalars['String']['output'];
  text: GoogleMapsText;
};

export type GoogleMapsPlaceDetails = {
  addressComponents: Array<GoogleMapsAddressComponent>;
  displayName: GoogleMapsDisplayName;
  formattedAddress: Scalars['String']['output'];
  id: Scalars['String']['output'];
  location: GoogleMapsLocation;
  /** The place's main type, e.g. `car_dealer`. Null when Google has no supported type for it. */
  primaryType?: Maybe<Scalars['String']['output']>;
  /** Google place types. A business includes `establishment`; a plain street address does not. */
  types: Array<Scalars['String']['output']>;
  /**
   * Locality verified against a national address dataset, which is more reliable
   * than the Google address components. Null unless the place is in Australia,
   * the only country covered so far.
   */
  verifiedLocality?: Maybe<VerifiedLocality>;
};

export type GoogleMapsText = {
  text: Scalars['String']['output'];
};

export type GoogleRouteData = {
  distance_kms: Scalars['Int']['output'];
  duration_seconds: Scalars['Int']['output'];
  image_url: Scalars['String']['output'];
  name: Scalars['String']['output'];
  polyline: Scalars['String']['output'];
};

export enum HireUnitType {
  Day = 'DAY',
  Night = 'NIGHT',
  TwentyFourHours = 'TWENTY_FOUR_HOURS'
}

export type HmacInputData = {
  requestBody: Scalars['String']['input'];
  supplierId: Scalars['ID']['input'];
};

export enum HoldingDepositRefundedBy {
  Imoova = 'IMOOVA',
  Supplier = 'SUPPLIER'
}

export type ImageGeneration = {
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image: Media;
  params: Scalars['Mixed']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum ImageGenerationModel {
  Gemini = 'GEMINI',
  Openai = 'OPENAI'
}

export enum ImportRelocationType {
  Append = 'APPEND',
  New = 'NEW'
}

export type ImportRelocationsInput = {
  relocations: Array<RelocationItemInput>;
  supplierId: Scalars['ID']['input'];
  type: ImportRelocationType;
};

export type ImportSetting = {
  date_format: Scalars['String']['output'];
  grid_state?: Maybe<Scalars['Mixed']['output']>;
  id: Scalars['ID']['output'];
  ignore_columns?: Maybe<Scalars['String']['output']>;
  ignore_fuel_if_has_ferry: Scalars['Boolean']['output'];
  ignore_header_row: Scalars['Boolean']['output'];
  ignore_missing_line: Scalars['Boolean']['output'];
  merge_duplicates: Scalars['Boolean']['output'];
};

export type ImportSettingInput = {
  date_format?: InputMaybe<Scalars['String']['input']>;
  grid_state?: InputMaybe<Scalars['Mixed']['input']>;
  ignore_columns?: InputMaybe<Scalars['String']['input']>;
  ignore_fuel_if_has_ferry?: InputMaybe<Scalars['Boolean']['input']>;
  ignore_header_row?: InputMaybe<Scalars['Boolean']['input']>;
  ignore_missing_line?: InputMaybe<Scalars['Boolean']['input']>;
  merge_duplicates?: InputMaybe<Scalars['Boolean']['input']>;
  supplier_id: Scalars['ID']['input'];
};

export type Incident = {
  claimDocuments?: Maybe<Array<Media>>;
  claim_opened_at?: Maybe<Scalars['DateTime']['output']>;
  claim_reference?: Maybe<Scalars['String']['output']>;
  closed_at?: Maybe<Scalars['DateTime']['output']>;
  closed_outcome?: Maybe<IncidentClosedOutcome>;
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  deliveryImages: Array<Media>;
  departureImages: Array<Media>;
  description: Scalars['String']['output'];
  excess_amount?: Maybe<Scalars['Int']['output']>;
  follow_up_contact?: Maybe<Scalars['String']['output']>;
  found_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  insurer?: Maybe<Scalars['String']['output']>;
  /** The supplier's photos of the damage. */
  photos: Array<Media>;
  proDriver: ProDriver;
  reference: Scalars['String']['output'];
  rejection_reason?: Maybe<Scalars['String']['output']>;
  reported_at: Scalars['DateTime']['output'];
  status: IncidentStatus;
  supplier: Supplier;
  type: IncidentType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  workOrder: WorkOrder;
  workOrderAssignment: WorkOrderAssignment;
  work_order_assignment_id: Scalars['ID']['output'];
};

export enum IncidentClosedOutcome {
  NoClaim = 'NO_CLAIM',
  Paid = 'PAID',
  Rejected = 'REJECTED'
}

/** A paginated list of Incident items. */
export type IncidentPaginator = {
  /** A list of Incident items. */
  data: Array<Incident>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum IncidentStatus {
  ClaimOpen = 'CLAIM_OPEN',
  Closed = 'CLOSED',
  Reported = 'REPORTED'
}

export enum IncidentType {
  ExteriorDamage = 'EXTERIOR_DAMAGE',
  InteriorDamage = 'INTERIOR_DAMAGE',
  MechanicalDamage = 'MECHANICAL_DAMAGE',
  Other = 'OTHER',
  Theft = 'THEFT'
}

export type Integration = {
  id: Scalars['ID']['output'];
  integrationLinks: Array<IntegrationLink>;
  metadata?: Maybe<Scalars['Mixed']['output']>;
  supplier: Supplier;
  type: IntegrationType;
};

export type IntegrationLink = {
  external_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  integration: Integration;
  object: IntegrationObject;
  object_id: Scalars['ID']['output'];
  object_type: ModelType;
};

/** A paginated list of IntegrationLink items. */
export type IntegrationLinkPaginator = {
  /** A list of IntegrationLink items. */
  data: Array<IntegrationLink>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type IntegrationObject = SupplierInsuranceOption | SupplierOffice | Vehicle;

/** A paginated list of Integration items. */
export type IntegrationPaginator = {
  /** A list of Integration items. */
  data: Array<Integration>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum IntegrationType {
  Camperman = 'CAMPERMAN',
  CampermanGapFiller = 'CAMPERMAN_GAP_FILLER',
  Click4Wheels = 'CLICK4WHEELS',
  GoogleSheets = 'GOOGLE_SHEETS',
  Jucy = 'JUCY',
  Rcm = 'RCM',
  Roadsurfer = 'ROADSURFER'
}

export enum IntercomPlatform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type IntercomUserToken = {
  token: Scalars['String']['output'];
};

export type Invitation = {
  accepted_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  expires_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invitedBy?: Maybe<User>;
  invited_by_id?: Maybe<Scalars['ID']['output']>;
  organisation: Organisation;
  organisation_id: Scalars['ID']['output'];
  token: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of Invitation items. */
export type InvitationPaginator = {
  /** A list of Invitation items. */
  data: Array<Invitation>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Invoice = {
  admin_url: Scalars['String']['output'];
  amount_credited: Scalars['Int']['output'];
  amount_due: Scalars['Int']['output'];
  amount_exc_tax: Scalars['Int']['output'];
  amount_inc_tax: Scalars['Int']['output'];
  amount_paid: Scalars['Int']['output'];
  amount_refunded: Scalars['Int']['output'];
  amount_tax: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  customer_url: Scalars['String']['output'];
  due_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoicePayments: Array<InvoicePayment>;
  invoice_date?: Maybe<Scalars['String']['output']>;
  is_tax_included: Scalars['Boolean']['output'];
  issuer: InvoiceIssuer;
  lineItems: Array<PayableLineItem>;
  managedBy?: Maybe<Organisation>;
  organisation_url: Scalars['String']['output'];
  payee: Contact;
  /** @deprecated Use customer_url */
  public_url: Scalars['String']['output'];
  purchase_order_number?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<Quote>;
  reference: Scalars['String']['output'];
  status: InvoiceStatus;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
  workOrders?: Maybe<Array<WorkOrder>>;
};

export type InvoiceIssuer = {
  abn: Scalars['String']['output'];
  address_line_1: Scalars['String']['output'];
  address_line_2: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

/** A paginated list of Invoice items. */
export type InvoicePaginator = {
  /** A list of Invoice items. */
  data: Array<Invoice>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type InvoicePayment = {
  amount: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice: Invoice;
  method: InvoicePaymentMethod;
  payment_date: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  stripePayment?: Maybe<StripePayment>;
  type: InvoicePaymentType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum InvoicePaymentMethod {
  CreditNote = 'CREDIT_NOTE',
  DirectDeposit = 'DIRECT_DEPOSIT',
  Stripe = 'STRIPE'
}

/** A paginated list of InvoicePayment items. */
export type InvoicePaymentPaginator = {
  /** A list of InvoicePayment items. */
  data: Array<InvoicePayment>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum InvoicePaymentType {
  Credit = 'CREDIT',
  Payment = 'PAYMENT',
  Refund = 'REFUND'
}

export enum InvoiceStatus {
  Draft = 'DRAFT',
  Issued = 'ISSUED',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Voided = 'VOIDED'
}

export type InvoiceStatusStat = {
  count: Scalars['Int']['output'];
  status: InvoiceStatus;
};

export type IssueContactCreditInput = {
  amount: Scalars['Int']['input'];
  attributedTo?: InputMaybe<ConnectMorphToInput>;
  contactId: Scalars['ID']['input'];
  currency: Currency;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type Itinerary = {
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  legs: Array<ItineraryLeg>;
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  uuid: Scalars['String']['output'];
};

export type ItineraryLeg = {
  booking?: Maybe<Booking>;
  deliveryCity?: Maybe<City>;
  delivery_date: Scalars['Date']['output'];
  delivery_time?: Maybe<Scalars['String']['output']>;
  departureCity?: Maybe<City>;
  departure_date: Scalars['Date']['output'];
  departure_time?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  relocation: Relocation;
};

export type JoinProDriverInput = {
  basedIn: ConnectBelongsTo;
  bio: Scalars['String']['input'];
  license_type: ProDriverLicenseType;
};

export type LocationPointInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  recordedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LogActivityInput = {
  data?: InputMaybe<Scalars['Mixed']['input']>;
  description: Scalars['String']['input'];
  event: ActivityLogEvent;
  model_id: Scalars['ID']['input'];
  model_type: ModelType;
};

export type LogCallbackLeadOutcomeInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  outcome: CallbackLeadOutcome;
  snoozed_until?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum MailboxEmailStatus {
  Failed = 'FAILED',
  NeedsAttention = 'NEEDS_ATTENTION',
  NotRelevant = 'NOT_RELEVANT',
  Processing = 'PROCESSING',
  Settled = 'SETTLED'
}

export type MailchimpCustomerJourney = {
  id: Scalars['ID']['output'];
  journey_name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type MailchimpCustomerJourneyStep = {
  display_text: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  step_type: Scalars['String']['output'];
  trigger_type?: Maybe<Scalars['String']['output']>;
};

export type MarkPaymentPaidInput = {
  amount_fee: Scalars['Int']['input'];
  amount_paid: Scalars['Int']['input'];
  amount_refunded: Scalars['Int']['input'];
};

export enum Measurement {
  Imperial = 'IMPERIAL',
  Metric = 'METRIC'
}

export type Media = {
  alt?: Maybe<Scalars['String']['output']>;
  collection_name: Scalars['String']['output'];
  /**
   * types filters to the given conversion types; maxWidth trims srcset to real
   * image URLs at or below the given width (drops the inline blur placeholder).
   */
  conversions?: Maybe<Array<MediaConversion>>;
  created_at: Scalars['DateTime']['output'];
  file_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_system_generated: Scalars['Boolean']['output'];
  mime_type: Scalars['String']['output'];
  model?: Maybe<MorphToModel>;
  name: Scalars['String']['output'];
  order_column: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};


export type MediaConversionsArgs = {
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<MediaConversionType>>;
};

export enum MediaCollection {
  AgreementPdf = 'AGREEMENT_PDF',
  AgreementSignedPdf = 'AGREEMENT_SIGNED_PDF',
  AgreementTemplatePdf = 'AGREEMENT_TEMPLATE_PDF',
  AssignmentFile = 'ASSIGNMENT_FILE',
  BlogBodyImages = 'BLOG_BODY_IMAGES',
  BlogHeroImage = 'BLOG_HERO_IMAGE',
  BlogSeoImage = 'BLOG_SEO_IMAGE',
  BookingMonthlyReport = 'BOOKING_MONTHLY_REPORT',
  BookingMonthlyReportExcel = 'BOOKING_MONTHLY_REPORT_EXCEL',
  DeliveryImage = 'DELIVERY_IMAGE',
  DepartureImage = 'DEPARTURE_IMAGE',
  DriverInvoicePdf = 'DRIVER_INVOICE_PDF',
  Documents = 'Documents',
  Icon = 'ICON',
  Images = 'IMAGES',
  IncidentClaimDocument = 'INCIDENT_CLAIM_DOCUMENT',
  IncidentPhoto = 'INCIDENT_PHOTO',
  Location = 'LOCATION',
  Logo = 'Logo',
  MessageAttachments = 'MESSAGE_ATTACHMENTS',
  OgImage = 'OG_IMAGE',
  Pdf = 'PDF',
  ProfilePicture = 'PROFILE_PICTURE',
  PurchasableExtraImage = 'PURCHASABLE_EXTRA_IMAGE',
  StatementOfAccountsPdf = 'STATEMENT_OF_ACCOUNTS_PDF',
  TermsAndConditionsPdf = 'TERMS_AND_CONDITIONS_PDF',
  TripImage = 'TRIP_IMAGE',
  WorkOrderRouteImage = 'WORK_ORDER_ROUTE_IMAGE'
}

export type MediaConversion = {
  srcset: Scalars['String']['output'];
  type: MediaConversionType;
  url: Scalars['String']['output'];
};

export enum MediaConversionType {
  Large = 'LARGE',
  Small = 'SMALL',
  Thumbnail = 'THUMBNAIL'
}

/** A paginated list of Media items. */
export type MediaPaginator = {
  /** A list of Media items. */
  data: Array<Media>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Meta = {
  default_rates: Array<DefaultRate>;
  feature_flags: Array<MetaFeatureFlag>;
  is_verified: Scalars['Boolean']['output'];
  overdue_invoice_count: Scalars['Int']['output'];
  pending_change_request_count: Scalars['Int']['output'];
  pending_payment_request_count: Scalars['Int']['output'];
  pending_task_count: Scalars['Int']['output'];
  primary_billing_entity: Contact;
};

export type MetaFeatureFlag = {
  enabled: Scalars['Boolean']['output'];
  type: FeatureFlagType;
};

export type MetadataInput = {
  advertising_id?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  fbc?: InputMaybe<Scalars['String']['input']>;
  fbp?: InputMaybe<Scalars['String']['input']>;
  feature_flags?: InputMaybe<Scalars['Mixed']['input']>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  msclkid?: InputMaybe<Scalars['String']['input']>;
  oppref?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Platform>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  qclid?: InputMaybe<Scalars['String']['input']>;
  rdt_cid?: InputMaybe<Scalars['String']['input']>;
  sccid?: InputMaybe<Scalars['String']['input']>;
  subscribe_to_newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  ttclid?: InputMaybe<Scalars['String']['input']>;
  ttp?: InputMaybe<Scalars['String']['input']>;
  wbraid?: InputMaybe<Scalars['String']['input']>;
};

export enum MobileNotificationType {
  Message = 'MESSAGE'
}

/** Model types in the application */
export enum ModelType {
  /** ACTIVITY_LOG model */
  ActivityLog = 'ACTIVITY_LOG',
  /** ADDRESS model */
  Address = 'ADDRESS',
  /** BLOCKLIST model */
  Blocklist = 'BLOCKLIST',
  /** BLOG_AUTHOR model */
  BlogAuthor = 'BLOG_AUTHOR',
  /** BLOG_POST model */
  BlogPost = 'BLOG_POST',
  /** BOOKING model */
  Booking = 'BOOKING',
  /** BOOKING_CHANGE_REQUEST model */
  BookingChangeRequest = 'BOOKING_CHANGE_REQUEST',
  /** BOOKING_PAYMENT_REQUEST model */
  BookingPaymentRequest = 'BOOKING_PAYMENT_REQUEST',
  /** BOOKING_SUPPLIER_CONFIRMATION model */
  BookingSupplierConfirmation = 'BOOKING_SUPPLIER_CONFIRMATION',
  /** CITY model */
  City = 'CITY',
  /** CONTACT model */
  Contact = 'CONTACT',
  /** CONTACT_CREDIT model */
  ContactCredit = 'CONTACT_CREDIT',
  /** IMAGE_GENERATION model */
  ImageGeneration = 'IMAGE_GENERATION',
  /** IMPORT_RUN model */
  ImportRun = 'IMPORT_RUN',
  /** INCIDENT model */
  Incident = 'INCIDENT',
  /** INTEGRATION model */
  Integration = 'INTEGRATION',
  /** INVOICE model */
  Invoice = 'INVOICE',
  /** INVOICE_PAYMENT model */
  InvoicePayment = 'INVOICE_PAYMENT',
  /** MAILBOX_EMAIL model */
  MailboxEmail = 'MAILBOX_EMAIL',
  /** PAYABLE_LINE_ITEM model */
  PayableLineItem = 'PAYABLE_LINE_ITEM',
  /** PAYMENT model */
  Payment = 'PAYMENT',
  /** PRO_DRIVER model */
  ProDriver = 'PRO_DRIVER',
  /** PRO_DRIVER_AGREEMENT model */
  ProDriverAgreement = 'PRO_DRIVER_AGREEMENT',
  /** PRO_DRIVER_AGREEMENT_TEMPLATE model */
  ProDriverAgreementTemplate = 'PRO_DRIVER_AGREEMENT_TEMPLATE',
  /** QUOTE model */
  Quote = 'QUOTE',
  /** QUOTE_LINE_ITEM model */
  QuoteLineItem = 'QUOTE_LINE_ITEM',
  /** REFUND model */
  Refund = 'REFUND',
  /** REFUND_PAYMENT model */
  RefundPayment = 'REFUND_PAYMENT',
  /** REFUND_RECEIPT model */
  RefundReceipt = 'REFUND_RECEIPT',
  /** RELOCATION model */
  Relocation = 'RELOCATION',
  /** RELOCATION_LINE model */
  RelocationLine = 'RELOCATION_LINE',
  /** RELOCATION_LINE_EMAIL model */
  RelocationLineEmail = 'RELOCATION_LINE_EMAIL',
  /** RELOCATION_PAGE model */
  RelocationPage = 'RELOCATION_PAGE',
  /** STRIPE_PAYMENT model */
  StripePayment = 'STRIPE_PAYMENT',
  /** SUPPLIER model */
  Supplier = 'SUPPLIER',
  /** SUPPLIER_BOOKING_REPORT model */
  SupplierBookingReport = 'SUPPLIER_BOOKING_REPORT',
  /** SUPPLIER_INSURANCE_OPTION model */
  SupplierInsuranceOption = 'SUPPLIER_INSURANCE_OPTION',
  /** SUPPLIER_OFFICE model */
  SupplierOffice = 'SUPPLIER_OFFICE',
  /** SUPPLIER_PURCHASABLE_EXTRA model */
  SupplierPurchasableExtra = 'SUPPLIER_PURCHASABLE_EXTRA',
  /** SUPPLIER_TERMS_AND_CONDITIONS model */
  SupplierTermsAndConditions = 'SUPPLIER_TERMS_AND_CONDITIONS',
  /** SUPPLIER_TRIP model */
  SupplierTrip = 'SUPPLIER_TRIP',
  /** TASK model */
  Task = 'TASK',
  /** TENANT model */
  Tenant = 'TENANT',
  /** THREAD model */
  Thread = 'THREAD',
  /** THREAD_MESSAGE model */
  ThreadMessage = 'THREAD_MESSAGE',
  /** TRIP model */
  Trip = 'TRIP',
  /** USER model */
  User = 'USER',
  /** VEHICLE model */
  Vehicle = 'VEHICLE',
  /** VEHICLE_TYPE_IMAGE model */
  VehicleTypeImage = 'VEHICLE_TYPE_IMAGE',
  /** WAITLIST model */
  Waitlist = 'WAITLIST',
  /** WORK_ORDER model */
  WorkOrder = 'WORK_ORDER',
  /** WORK_ORDER_ASSIGNMENT model */
  WorkOrderAssignment = 'WORK_ORDER_ASSIGNMENT',
  /** WORK_ORDER_ASSIGNMENT_EXPENSE model */
  WorkOrderAssignmentExpense = 'WORK_ORDER_ASSIGNMENT_EXPENSE',
  /** WORK_ORDER_ASSIGNMENT_PAYOUT model */
  WorkOrderAssignmentPayout = 'WORK_ORDER_ASSIGNMENT_PAYOUT'
}

export type MorphToModel = Booking | Vehicle;

export type MultiLegTrip = {
  /**
   * The build this trip came from. Stock turns over, so trips are found afresh
   * each day.
   */
  built_on: Scalars['Date']['output'];
  created_at: Scalars['DateTime']['output'];
  endCity: City;
  highlights: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legs: Array<MultiLegTripLeg>;
  region: Region;
  /**
   * How the build rated the chain: the deals it is made of, less what waiting
   * around and finding your own way between vehicles cost it.
   */
  score: Scalars['Float']['output'];
  startCity: City;
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** Pick-up of the first leg to hand-back of the last, transfers included. */
  total_days: Scalars['Int']['output'];
};

export type MultiLegTripLeg = {
  deliveryCity: City;
  departureCity: City;
  dropoff_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  kind: MultiLegTripLegKind;
  /**
   * Bookable dates, from the same open hours checkout enforces. Null on a
   * transfer.
   */
  pickup_date?: Maybe<Scalars['Date']['output']>;
  position: Scalars['Int']['output'];
  /**
   * The vehicle to drive. Null on a transfer, which the traveller makes their own
   * way.
   */
  relocation?: Maybe<Relocation>;
  transfer_cost_estimate?: Maybe<Scalars['String']['output']>;
  transfer_description?: Maybe<Scalars['String']['output']>;
  transfer_duration_hours?: Maybe<Scalars['Float']['output']>;
  transfer_mode?: Maybe<TransferMode>;
};

export enum MultiLegTripLegKind {
  /** A relocation the traveller drives. */
  Relocation = 'RELOCATION',
  /** The traveller's own way from one drop-off city to the next pick-up city. */
  Transfer = 'TRANSFER'
}

/** A paginated list of MultiLegTrip items. */
export type MultiLegTripPaginator = {
  /** A list of MultiLegTrip items. */
  data: Array<MultiLegTrip>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type MultiLegTripsByRegionCount = {
  count: Scalars['Int']['output'];
  region: Region;
};

export type Mutation = {
  acceptBooking: Booking;
  acceptPublicQuote: PublicQuote;
  acceptQuote: Quote;
  addIncidentPhotos: Incident;
  addOrganisationMember: OrganisationUser;
  addPushToken: Scalars['Boolean']['output'];
  addReceiptByUuid: Receipt;
  addRelocationDestinations: Relocation;
  addSubscribersToThread: Thread;
  addThreadNote: ThreadMessage;
  adminResetUserPassword: Scalars['Boolean']['output'];
  analyzeReceiptByUuid: ReceiptAnalysis;
  analyzeReceiptImage: ReceiptAnalysis;
  applySupplierAgeRequirementsToVehicles: Supplier;
  applyVehiclePurchasableExtra?: Maybe<Scalars['Boolean']['output']>;
  approveReceiptsWorkOrderAssignment: WorkOrderAssignment;
  archiveProDriverAgreementTemplate: ProDriverAgreementTemplate;
  archiveSupplier: Supplier;
  archiveSupplierOffice: SupplierOffice;
  archiveVehicle: Vehicle;
  /** Puts an Imoova staff member on the work order. Only admin staff are assignable. */
  assignAdminToWorkOrder: WorkOrder;
  assignInvoiceToWorkOrder: WorkOrder;
  assignSupplierToTenant?: Maybe<Scalars['Boolean']['output']>;
  associateBooking: Scalars['Boolean']['output'];
  billingCreateOffSessionPaymentMethodCheckoutUrl: Scalars['String']['output'];
  blockBookingCustomer: Blocklist;
  blogPostReaction: Scalars['Boolean']['output'];
  bookingChangeRelocation: Booking;
  bookingPaymentRequestPaymentIntent: StripePayment;
  bookingReleaseLineReference: Booking;
  cancelBooking: Booking;
  cancelEmailChange: User;
  /** Admin staff pay or reject an open claim, or close a report that never became one. Rejecting needs a reason, which the supplier sees. */
  closeIncident: Incident;
  closeRefund: Refund;
  confirmBooking: Booking;
  confirmBookingSupplierConfirmation: BookingSupplierConfirmation;
  createActivityLog: ActivityLog;
  createAdminBookingPaymentIntent: StripePayment;
  createAndAddOrganisationMember: OrganisationUser;
  createBlocklist: Blocklist;
  createBlogAuthor: BlogAuthor;
  createBlogPost: BlogPost;
  createBlogPostTripArticle: BlogPostTripArticle;
  createBlogTag: BlogTag;
  createBooking: Booking;
  createBookingChangeRequest: BookingChangeRequest;
  createBookingPaymentIntent: PaymentIntent;
  createBookingPaymentRequest: BookingPaymentRequest;
  createBookingSignedStorageUrl: SignedStorageUrl;
  createCallbackLead: CallbackLead;
  createCity: City;
  createContact: Contact;
  /**
   * Opens a driver's conversation about a job, with the message that prompted it.
   * Both land or neither does. The message arguments are nullable only for the
   * shipped mobile builds that open the thread and send separately; every caller
   * should send one.
   */
  createDriverWorkOrderAssignmentThread: Thread;
  createEntity: Contact;
  createFaq: Faq;
  createIntegration: Integration;
  createIntegrationLink: IntegrationLink;
  createInvitation: Invitation;
  createInvoice: Invoice;
  createInvoiceCheckoutSession: StripeCheckoutSession;
  createInvoiceCheckoutSessionByUuid: StripeCheckoutSession;
  createInvoicePayment: InvoicePayment;
  createInvoicePdf: Scalars['String']['output'];
  createItinerary: Itinerary;
  createItineraryLegBooking: Booking;
  createMedia: Media;
  createOrganisation: Organisation;
  createPartner: Partner;
  createPayment: Payment;
  createPopularTrip: PopularTrip;
  createProDriver: ProDriver;
  createProDriverAgreement: ProDriverAgreement;
  createProDriverAgreementTemplate: ProDriverAgreementTemplate;
  createProDriverReview: ProDriverReview;
  createQuote: Quote;
  createQuotePdf: Scalars['String']['output'];
  createReceipt: Receipt;
  createRefund: Refund;
  createRefundPayment: RefundPayment;
  createRefundSignedStorageUrl: SignedStorageUrl;
  createRelocation: Relocation;
  createRelocationHighlight: RelocationHighlight;
  createRelocationPage: RelocationPage;
  createRelocationPageArticle: RelocationPageArticle;
  createSalesOrganisationAttribution: SalesOrganisationAttribution;
  createSetupIntent: Scalars['String']['output'];
  createSignedStorageUrl: SignedStorageUrl;
  createSupplier: Supplier;
  createSupplierAcknowledgement: SupplierAcknowledgement;
  createSupplierAdminContact: SupplierAdminContact;
  createSupplierCity: City;
  createSupplierInsuranceOption: SupplierInsuranceOption;
  createSupplierOffice: SupplierOffice;
  createSupplierPurchasableExtra: SupplierPurchasableExtra;
  createSupplierTrip: SupplierTrip;
  createSupplierWorkOrderThread: Thread;
  createThread: Thread;
  createUser: User;
  createVehicle: Vehicle;
  createWaitlist: Waitlist;
  /**
   * Deal alerts without an account. The address becomes a passwordless account,
   * so requesting a sign in code later turns it into a full one.
   */
  createWaitlistForEmail: Waitlist;
  createWorkOrder: WorkOrder;
  createWorkOrderAssignment: WorkOrderAssignment;
  createWorkOrderAssignmentExpense: WorkOrderAssignmentExpense;
  createWorkOrderAssignmentPayout: WorkOrderAssignmentPayout;
  createWorkOrderJobOpening: WorkOrderJobOpening;
  createWorkOrderJobOpeningOffer: WorkOrderJobOpeningOffer;
  createWorkOrderJobOpeningOffers?: Maybe<Scalars['Boolean']['output']>;
  declineProDriverAgreement: ProDriverAgreement;
  declinePublicQuote: PublicQuote;
  declineQuote: Quote;
  deleteAssignmentPhoto: Scalars['Boolean']['output'];
  deleteBillingEntity: Scalars['Boolean']['output'];
  deleteBlocklist: Blocklist;
  deleteBlogAuthor: BlogAuthor;
  deleteBlogPost: BlogPost;
  deleteBlogPostTripArticle: BlogPostTripArticle;
  deleteBlogTag: BlogTag;
  deleteBookingPaymentRequest?: Maybe<BookingPaymentRequest>;
  deleteCity: City;
  deleteFaq: Faq;
  deleteIntegration: Integration;
  deleteIntegrationLink: IntegrationLink;
  deleteInvoice: Invoice;
  deleteInvoicePayment: InvoicePayment;
  deleteMe: Scalars['Boolean']['output'];
  deleteMedia: Media;
  deleteOrganisation: Scalars['Boolean']['output'];
  deletePartner: Partner;
  deletePayment: Payment;
  deletePopularTrip: PopularTrip;
  deleteProDriver: ProDriver;
  deleteProDriverAgreement: ProDriverAgreement;
  deleteQuote: Quote;
  deleteReceipt: Receipt;
  deleteReceiptByUuid: Scalars['Boolean']['output'];
  deleteRefundPayment?: Maybe<RefundPayment>;
  deleteRelocationHighlight: RelocationHighlight;
  deleteRelocationPage: RelocationPage;
  deleteRelocationPageArticle: RelocationPageArticle;
  deleteSalesOrganisationAttribution: SalesOrganisationAttribution;
  deleteStripePaymentMethod: StripePaymentMethod;
  deleteSupplier: Supplier;
  deleteSupplierAcknowledgement: SupplierAcknowledgement;
  deleteSupplierAdminContact: SupplierAdminContact;
  deleteSupplierInsuranceOption: SupplierInsuranceOption;
  deleteSupplierOffice: SupplierOffice;
  deleteSupplierPurchasableExtra: SupplierPurchasableExtra;
  deleteSupplierTrip: SupplierTrip;
  deleteThread?: Maybe<Thread>;
  deleteUser: Scalars['Boolean']['output'];
  deleteVehicle: Vehicle;
  deleteWaitlist: Waitlist;
  deleteWorkOrderAssignment: WorkOrderAssignment;
  deleteWorkOrderAssignmentExpense: WorkOrderAssignmentExpense;
  deleteWorkOrderAssignmentPayout: WorkOrderAssignmentPayout;
  deleteWorkOrderJobOpeningOffer: WorkOrderJobOpeningOffer;
  deleteWorkOrderNotificationSetting?: Maybe<WorkOrderNotificationSetting>;
  deleteWorkOrderReview: ProDriverReview;
  dismissBookingSupplierConfirmation: BookingSupplierConfirmation;
  dismissCallbackLead: CallbackLead;
  duplicateRelocation: Relocation;
  duplicateSupplier: Scalars['Boolean']['output'];
  emailProDrivers?: Maybe<Scalars['Boolean']['output']>;
  flushMeilisearch?: Maybe<Scalars['Boolean']['output']>;
  generateCityDescription: City;
  generateCityHeroImage: Scalars['Boolean']['output'];
  generateDriverInvoicePdf: Media;
  generateImportTemplate: Scalars['String']['output'];
  generateIncidentPdf: Media;
  generateInvoicesForContact: Array<Invoice>;
  generateProDriverAgreementTemplatePdf: Media;
  generateQRCode: Scalars['String']['output'];
  generateStatementOfAccounts: Scalars['String']['output'];
  generateSupplierBookingReport: Scalars['Boolean']['output'];
  generateWorkOrderManifestPdf: Media;
  importRelocations: Scalars['Boolean']['output'];
  invoiceQuote: Invoice;
  invoiceWorkOrder: WorkOrder;
  issueContactCredit: ContactCredit;
  issueInvoice: Invoice;
  issueQuote: Quote;
  joinProDriverProgram: ProDriver;
  /**
   * Map a Zoom user to a staff account, or hand the Zoom user back with no
   * mapping when user_id is null.
   */
  linkZoomPhoneUser: Scalars['Boolean']['output'];
  logCallbackLeadOutcome: CallbackLead;
  mailBookingToAdmin: Booking;
  mailBookingToCustomer: Booking;
  mailBookingToSupplier: Booking;
  markCompletedWorkOrderAssignment: WorkOrderAssignment;
  markDeliveredWorkOrderAssignment: WorkOrderAssignment;
  markPaymentAsPaid: Payment;
  markPickedUpWorkOrderAssignment: WorkOrderAssignment;
  markProDriverAgreementViewed: ProDriverAgreement;
  markReceiptsUploadedWorkOrderAssignment: WorkOrderAssignment;
  markThreadAsRead: Thread;
  markThreadAsUnread: Thread;
  markWorkOrderAsArchived: WorkOrder;
  /** Map every Zoom user whose email matches a staff account. */
  matchZoomPhoneUsersByEmail: ZoomPhoneUserMatchResult;
  mediaSetNewOrder: Scalars['Boolean']['output'];
  newsletterSubscribe: Scalars['Boolean']['output'];
  onboardingCreateOrganisation: OnboardingCreateOrganisation;
  /** A supplier opens the claim once they know the excess for Imoova to pay. */
  openIncidentClaim: Incident;
  pendingBooking: Booking;
  promoteRelocation: RelocationPromotion;
  pushIntegrationToSheet: Scalars['Boolean']['output'];
  pushJucyBooking: Booking;
  reanalyzeReceipt: Receipt;
  recordAssignmentLocations: Array<WorkOrderAssignmentLocation>;
  /** Stores the score from the newest analysis on this deal's thread. */
  refreshRelocationDealScore: Relocation;
  refundPayment: Payment;
  regenerateOGImage: Scalars['Boolean']['output'];
  relocationLineSold: RelocationLine;
  removeOrganisationMember: Scalars['Boolean']['output'];
  reopenIncident: Incident;
  /** A supplier flags damage within 48 hours of delivery, or admin staff log it on the supplier's behalf. */
  reportIncident: Incident;
  requestEmailChange: User;
  resendEmailVerificationCode: User;
  resendInvoice: Invoice;
  resendPayoutEmail: WorkOrderAssignmentPayout;
  resendRefundEmail: Refund;
  resendSupplierBookingReport: Scalars['Boolean']['output'];
  resetWorkOrderAssignment: WorkOrderAssignment;
  resolveBookingChangeRequest: BookingChangeRequest;
  resolveBookingPaymentRequest: BookingPaymentRequest;
  resolveRelocationLineEmail: RelocationLineEmail;
  respondToWorkOrderJobOpening: WorkOrderJobOpening;
  reverseContactCredit: ContactCredit;
  revokeInvitation: Scalars['Boolean']['output'];
  sendBookingChangeRequestPaymentRequest: BookingChangeRequest;
  sendBookingPaymentRequestToCustomer: BookingPaymentRequest;
  sendInvoicePayment: InvoicePayment;
  sendJobOpeningOfferNotifications?: Maybe<Scalars['Boolean']['output']>;
  sendMessage: ThreadMessage;
  sendProDriverAgreement: ProDriverAgreement;
  sendQuote: Quote;
  setBlogPostTripArticleSortOrder: Scalars['Boolean']['output'];
  setDefaultImageGeneration: ImageGeneration;
  setRelocationPageArticleSortOrder?: Maybe<Scalars['Boolean']['output']>;
  setRelocationPriority: Scalars['Boolean']['output'];
  setThreadClosed: Thread;
  setThreadNotifications: Thread;
  setWorkOrderInvoiceNotRequired: WorkOrder;
  signProDriverAgreement: ProDriverAgreement;
  snoozeCallbackLead: CallbackLead;
  startCallbackLeadCall: CallbackLeadCall;
  submitRefundByUuid: PublicRefund;
  syncBlogPostTags: BlogPost;
  syncPromotionChannel: PromotionChannel;
  translateBlogPost: BlogPost;
  unblockBookingCustomer: Scalars['Boolean']['output'];
  updateBlogAuthor: BlogAuthor;
  updateBlogPost: BlogPost;
  updateBlogTag: BlogTag;
  updateBooking: Booking;
  updateBookingChangeRequest: BookingChangeRequest;
  updateBookingDates: Booking;
  updateCity: City;
  updateContact: Contact;
  updateCurrentOrganisation: Organisation;
  updateDefaultRate: DefaultRate;
  updateFaq: Faq;
  updateFeatureFlag?: Maybe<Scalars['Boolean']['output']>;
  updateIncident: Incident;
  updateIntegration: Integration;
  updateIntegrationLink: IntegrationLink;
  updateInvoice: Invoice;
  updateInvoicePayment: InvoicePayment;
  updateMe: User;
  updateMedia: Media;
  updateMyNotificationSettings: UserNotificationSetting;
  updateMyProDriverProfile: ProDriver;
  updateMyProfilePicture: User;
  updateMyWaitlistPreference: WaitlistPreference;
  updatePartner: Partner;
  updatePayment: Payment;
  updatePopularTrip?: Maybe<PopularTrip>;
  updateProDriver: ProDriver;
  updateProDriverAgreement: ProDriverAgreement;
  updateProDriverAgreementTemplate: ProDriverAgreementTemplate;
  updatePromotionChannel: PromotionChannel;
  updateQuote: Quote;
  updateReceipt: Receipt;
  updateRefund: Refund;
  updateRefundBankDetailsByUuid: PublicRefund;
  updateRefundPayment: RefundPayment;
  updateRelocation: Relocation;
  updateRelocationCompletedTask: Task;
  updateRelocationHighlight: RelocationHighlight;
  updateRelocationPage: RelocationPage;
  updateRelocationStatuses: Scalars['Boolean']['output'];
  updateStripePaymentMethod: StripePaymentMethod;
  updateSupplier: Supplier;
  updateSupplierAcknowledgement: SupplierAcknowledgement;
  updateSupplierAdminContact: SupplierAdminContact;
  updateSupplierInsuranceOption: SupplierInsuranceOption;
  updateSupplierOffice: SupplierOffice;
  updateSupplierPurchasableExtra: SupplierPurchasableExtra;
  updateSupplierTermsAndConditions: SupplierTermsAndConditions;
  updateSupplierTrip: SupplierTrip;
  updateTask: Task;
  updateTenant: Organisation;
  updateTrip: Trip;
  updateTripFaqs: Trip;
  updateUser: User;
  /** Admin-side toggle, e.g. to resubscribe someone who unsubscribed by mistake. */
  updateUserNotificationSettings: UserNotificationSetting;
  updateVehicle: Vehicle;
  updateWaitlist: Waitlist;
  updateWaitlistPreference: WaitlistPreference;
  updateWorkOrder: WorkOrder;
  updateWorkOrderAssignment: WorkOrderAssignment;
  updateWorkOrderAssignmentExpense: WorkOrderAssignmentExpense;
  updateWorkOrderAssignmentPayout: WorkOrderAssignmentPayout;
  updateWorkOrderJobOpening: WorkOrderJobOpening;
  updateWorkOrderJobOpeningOffer: WorkOrderJobOpeningOffer;
  updateWorkOrderReview: ProDriverReview;
  uploadAssignmentPhotos: Array<Media>;
  uploadDriverReceipts: Array<WorkOrderAssignmentExpense>;
  uploadExpenseReceipts: WorkOrderAssignmentExpense;
  upsertImportSetting?: Maybe<ImportSetting>;
  upsertIntegrationLink: IntegrationLink;
  verifyEmailChange: User;
  vipBooking: Booking;
  voidInvoice: Invoice;
  voidProDriverAgreement: ProDriverAgreement;
};


export type MutationAcceptBookingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAcceptPublicQuoteArgs = {
  purchase_order_number?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};


export type MutationAcceptQuoteArgs = {
  id: Scalars['ID']['input'];
  purchase_order_number?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddIncidentPhotosArgs = {
  filePaths: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAddOrganisationMemberArgs = {
  organisation_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};


export type MutationAddPushTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationAddReceiptByUuidArgs = {
  filePath: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};


export type MutationAddRelocationDestinationsArgs = {
  destinationOfficeIds: Array<Scalars['ID']['input']>;
  relocationId: Scalars['ID']['input'];
};


export type MutationAddSubscribersToThreadArgs = {
  thread_id: Scalars['ID']['input'];
  user_ids: Array<Scalars['ID']['input']>;
};


export type MutationAddThreadNoteArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  file_paths?: InputMaybe<Array<Scalars['String']['input']>>;
  thread_id: Scalars['String']['input'];
};


export type MutationAdminResetUserPasswordArgs = {
  id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
};


export type MutationAnalyzeReceiptByUuidArgs = {
  filePath: Scalars['String']['input'];
  refundUuid: Scalars['String']['input'];
};


export type MutationAnalyzeReceiptImageArgs = {
  filePath: Scalars['String']['input'];
};


export type MutationApplySupplierAgeRequirementsToVehiclesArgs = {
  supplierId: Scalars['ID']['input'];
};


export type MutationApplyVehiclePurchasableExtraArgs = {
  enabled: Scalars['Boolean']['input'];
  relocationType?: InputMaybe<RelocationType>;
  supplierPurchasableExtraId: Scalars['ID']['input'];
  vehicleId: Scalars['ID']['input'];
};


export type MutationApproveReceiptsWorkOrderAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveProDriverAgreementTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveSupplierArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveSupplierOfficeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveVehicleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAssignAdminToWorkOrderArgs = {
  user_id: Scalars['ID']['input'];
  work_order_id: Scalars['ID']['input'];
};


export type MutationAssignInvoiceToWorkOrderArgs = {
  invoiceId: Scalars['ID']['input'];
  workOrderId: Scalars['ID']['input'];
};


export type MutationAssignSupplierToTenantArgs = {
  input: AssignSupplierToTenantInput;
};


export type MutationAssociateBookingArgs = {
  reference: Scalars['String']['input'];
};


export type MutationBillingCreateOffSessionPaymentMethodCheckoutUrlArgs = {
  input: CreateBillingSessionInput;
};


export type MutationBlockBookingCustomerArgs = {
  input: BlockBookingCustomerInput;
};


export type MutationBlogPostReactionArgs = {
  liked?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
};


export type MutationBookingChangeRelocationArgs = {
  id: Scalars['ID']['input'];
  input: BookingChangeRelocationInput;
};


export type MutationBookingPaymentRequestPaymentIntentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationBookingReleaseLineReferenceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelBookingArgs = {
  id: Scalars['ID']['input'];
  input: CancelBookingStatusInput;
};


export type MutationCloseIncidentArgs = {
  id: Scalars['ID']['input'];
  outcome: IncidentClosedOutcome;
  rejection_reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCloseRefundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConfirmBookingArgs = {
  id: Scalars['ID']['input'];
  input: ConfirmBookingInput;
};


export type MutationConfirmBookingSupplierConfirmationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateActivityLogArgs = {
  input: LogActivityInput;
};


export type MutationCreateAdminBookingPaymentIntentArgs = {
  id: Scalars['ID']['input'];
  input: CreateAdminBookingPaymentIntentInput;
};


export type MutationCreateAndAddOrganisationMemberArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organisation_id: Scalars['ID']['input'];
};


export type MutationCreateBlocklistArgs = {
  input: CreateBlocklistInput;
};


export type MutationCreateBlogAuthorArgs = {
  input: CreateBlogAuthorInput;
};


export type MutationCreateBlogPostArgs = {
  input: CreateBlogPostInput;
};


export type MutationCreateBlogPostTripArticleArgs = {
  input: CreateBlogPostTripArticle;
};


export type MutationCreateBlogTagArgs = {
  input: CreateBlogTagInput;
};


export type MutationCreateBookingArgs = {
  input: CreateBookingInput;
};


export type MutationCreateBookingChangeRequestArgs = {
  bookingUuid: Scalars['String']['input'];
  input?: InputMaybe<CreateBookingChangeRequestInput>;
};


export type MutationCreateBookingPaymentIntentArgs = {
  id: Scalars['ID']['input'];
  input: CreatePaymentIntentInput;
};


export type MutationCreateBookingPaymentRequestArgs = {
  input: CreateBookingPaymentRequestInput;
};


export type MutationCreateBookingSignedStorageUrlArgs = {
  bookingUuid: Scalars['String']['input'];
  input: SignedStorageUrlInput;
};


export type MutationCreateCallbackLeadArgs = {
  input: CreateCallbackLeadInput;
};


export type MutationCreateCityArgs = {
  input: CreateCityInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateDriverWorkOrderAssignmentThreadArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  file_paths?: InputMaybe<Array<Scalars['String']['input']>>;
  work_order_assignment_id: Scalars['ID']['input'];
};


export type MutationCreateEntityArgs = {
  contactId: Scalars['ID']['input'];
  input: CreateEntityInput;
};


export type MutationCreateFaqArgs = {
  input: CreateFaqInput;
};


export type MutationCreateIntegrationArgs = {
  input: CreateIntegrationInput;
};


export type MutationCreateIntegrationLinkArgs = {
  input: CreateIntegrationLinkInput;
};


export type MutationCreateInvitationArgs = {
  email: Scalars['String']['input'];
  organisation_id: Scalars['ID']['input'];
};


export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
};


export type MutationCreateInvoiceCheckoutSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateInvoiceCheckoutSessionByUuidArgs = {
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  successUrl?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};


export type MutationCreateInvoicePaymentArgs = {
  input: CreateInvoicePaymentInput;
};


export type MutationCreateInvoicePdfArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateItineraryArgs = {
  input: CreateItineraryInput;
};


export type MutationCreateItineraryLegBookingArgs = {
  input: CreateBookingInput;
  itinerary_leg_id: Scalars['ID']['input'];
  itinerary_uuid: Scalars['String']['input'];
};


export type MutationCreateMediaArgs = {
  input: CreateMediaInput;
};


export type MutationCreateOrganisationArgs = {
  input: CreateOrganisationInput;
};


export type MutationCreatePartnerArgs = {
  input: CreatePartnerInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreatePopularTripArgs = {
  input: CreatePopularTripInput;
};


export type MutationCreateProDriverArgs = {
  input: CreateProDriverInput;
};


export type MutationCreateProDriverAgreementArgs = {
  input: CreateProDriverAgreementInput;
};


export type MutationCreateProDriverAgreementTemplateArgs = {
  input: CreateProDriverAgreementTemplateInput;
};


export type MutationCreateProDriverReviewArgs = {
  input: CreateWorkOrderDriverReviewInput;
};


export type MutationCreateQuoteArgs = {
  input: CreateQuoteInput;
};


export type MutationCreateQuotePdfArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateReceiptArgs = {
  input: CreateReceiptInput;
};


export type MutationCreateRefundArgs = {
  input?: InputMaybe<UpdateRefundInput>;
  object: ConnectMorphToInput;
  type: RefundType;
};


export type MutationCreateRefundPaymentArgs = {
  input: CreateRefundPaymentInput;
};


export type MutationCreateRefundSignedStorageUrlArgs = {
  input: SignedStorageUrlInput;
  refundUuid: Scalars['String']['input'];
};


export type MutationCreateRelocationArgs = {
  input: CreateRelocationInput;
};


export type MutationCreateRelocationHighlightArgs = {
  input: CreateRelocationHighlightInput;
};


export type MutationCreateRelocationPageArgs = {
  input: CreateRelocationPageInput;
};


export type MutationCreateRelocationPageArticleArgs = {
  input: CreateRelocationPageArticle;
};


export type MutationCreateSalesOrganisationAttributionArgs = {
  input: CreateSalesOrganisationAttributionInput;
};


export type MutationCreateSetupIntentArgs = {
  input: CreateSetupIntentInput;
};


export type MutationCreateSignedStorageUrlArgs = {
  input?: InputMaybe<SignedStorageUrlInput>;
};


export type MutationCreateSupplierArgs = {
  input: CreateSupplierInput;
};


export type MutationCreateSupplierAcknowledgementArgs = {
  input: CreateSupplierAcknowledgementInput;
};


export type MutationCreateSupplierAdminContactArgs = {
  input: CreateSupplierAdminContactInput;
};


export type MutationCreateSupplierCityArgs = {
  name: Scalars['String']['input'];
  state: State;
};


export type MutationCreateSupplierInsuranceOptionArgs = {
  input: CreateSupplierInsuranceOptionInput;
};


export type MutationCreateSupplierOfficeArgs = {
  input: CreateSupplierOfficeInput;
};


export type MutationCreateSupplierPurchasableExtraArgs = {
  input?: InputMaybe<CreateSupplierPurchasableExtraInput>;
};


export type MutationCreateSupplierTripArgs = {
  input: CreateSupplierTripInput;
};


export type MutationCreateSupplierWorkOrderThreadArgs = {
  work_order_id: Scalars['ID']['input'];
};


export type MutationCreateThreadArgs = {
  input: CreateThreadInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateVehicleArgs = {
  input: CreateVehicleInput;
};


export type MutationCreateWaitlistArgs = {
  input: CreateWaitlistInput;
};


export type MutationCreateWaitlistForEmailArgs = {
  email: Scalars['String']['input'];
  input: CreateWaitlistInput;
};


export type MutationCreateWorkOrderArgs = {
  input?: InputMaybe<CreateWorkOrderInput>;
};


export type MutationCreateWorkOrderAssignmentArgs = {
  input: CreateWorkOrderDriverInput;
};


export type MutationCreateWorkOrderAssignmentExpenseArgs = {
  input: CreateWorkOrderAssignmentExpenseInput;
};


export type MutationCreateWorkOrderAssignmentPayoutArgs = {
  input: CreateWorkOrderAssignmentPayoutInput;
};


export type MutationCreateWorkOrderJobOpeningArgs = {
  input: CreateWorkOrderJobOpeningInput;
};


export type MutationCreateWorkOrderJobOpeningOfferArgs = {
  input: CreateWorkOrderJobOpeningOfferInput;
};


export type MutationCreateWorkOrderJobOpeningOffersArgs = {
  input: CreateWorkOrderJobOpeningOffersInput;
};


export type MutationDeclineProDriverAgreementArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeclinePublicQuoteArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<QuoteDeclinedReason>;
  uuid: Scalars['String']['input'];
};


export type MutationDeclineQuoteArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reason?: InputMaybe<QuoteDeclinedReason>;
};


export type MutationDeleteAssignmentPhotoArgs = {
  mediaId: Scalars['ID']['input'];
  workOrderAssignmentId: Scalars['ID']['input'];
};


export type MutationDeleteBillingEntityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBlocklistArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBlogAuthorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBlogPostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBlogPostTripArticleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBlogTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBookingPaymentRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFaqArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIntegrationLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInvoicePaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMediaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganisationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePartnerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePopularTripArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProDriverArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProDriverAgreementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReceiptArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReceiptByUuidArgs = {
  receiptId: Scalars['ID']['input'];
  refundUuid: Scalars['String']['input'];
};


export type MutationDeleteRefundPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRelocationHighlightArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRelocationPageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRelocationPageArticleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSalesOrganisationAttributionArgs = {
  organisation_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};


export type MutationDeleteStripePaymentMethodArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSupplierArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSupplierAcknowledgementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSupplierAdminContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSupplierInsuranceOptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSupplierOfficeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSupplierPurchasableExtraArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSupplierTripArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteThreadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVehicleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWaitlistArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkOrderAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkOrderAssignmentExpenseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkOrderAssignmentPayoutArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkOrderJobOpeningOfferArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkOrderNotificationSettingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkOrderReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDismissBookingSupplierConfirmationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDismissCallbackLeadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateRelocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateSupplierArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationEmailProDriversArgs = {
  input: EmailProDriversInput;
};


export type MutationFlushMeilisearchArgs = {
  modelClass: Scalars['String']['input'];
};


export type MutationGenerateCityDescriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateCityHeroImageArgs = {
  id: Scalars['ID']['input'];
  model?: InputMaybe<ImageGenerationModel>;
  prompt?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateDriverInvoicePdfArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateImportTemplateArgs = {
  supplierId: Scalars['ID']['input'];
};


export type MutationGenerateIncidentPdfArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateInvoicesForContactArgs = {
  asDraft?: InputMaybe<Scalars['Boolean']['input']>;
  contactId: Scalars['ID']['input'];
};


export type MutationGenerateProDriverAgreementTemplatePdfArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateQrCodeArgs = {
  text: Scalars['String']['input'];
};


export type MutationGenerateStatementOfAccountsArgs = {
  input: GenerateStatementOfAccountsInput;
};


export type MutationGenerateSupplierBookingReportArgs = {
  month: Scalars['Int']['input'];
  supplier_id: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type MutationGenerateWorkOrderManifestPdfArgs = {
  id: Scalars['ID']['input'];
};


export type MutationImportRelocationsArgs = {
  input: ImportRelocationsInput;
};


export type MutationInvoiceQuoteArgs = {
  quoteId: Scalars['ID']['input'];
};


export type MutationInvoiceWorkOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationIssueContactCreditArgs = {
  input: IssueContactCreditInput;
};


export type MutationIssueInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationIssueQuoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationJoinProDriverProgramArgs = {
  input: JoinProDriverInput;
};


export type MutationLinkZoomPhoneUserArgs = {
  extension_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  zoom_user_id: Scalars['String']['input'];
};


export type MutationLogCallbackLeadOutcomeArgs = {
  id: Scalars['ID']['input'];
  input: LogCallbackLeadOutcomeInput;
};


export type MutationMailBookingToAdminArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMailBookingToCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMailBookingToSupplierArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  event?: InputMaybe<SupplierNotificationSettingEvent>;
  id: Scalars['ID']['input'];
};


export type MutationMarkCompletedWorkOrderAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkDeliveredWorkOrderAssignmentArgs = {
  filePaths?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
};


export type MutationMarkPaymentAsPaidArgs = {
  id: Scalars['ID']['input'];
  input: MarkPaymentPaidInput;
};


export type MutationMarkPickedUpWorkOrderAssignmentArgs = {
  filePaths?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
};


export type MutationMarkProDriverAgreementViewedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkReceiptsUploadedWorkOrderAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkThreadAsReadArgs = {
  thread_id: Scalars['ID']['input'];
};


export type MutationMarkThreadAsUnreadArgs = {
  thread_id: Scalars['ID']['input'];
};


export type MutationMarkWorkOrderAsArchivedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMediaSetNewOrderArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationNewsletterSubscribeArgs = {
  email: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationOnboardingCreateOrganisationArgs = {
  input: OnboardingCreateOrganisationInput;
};


export type MutationOpenIncidentClaimArgs = {
  id: Scalars['ID']['input'];
  input: OpenIncidentClaimInput;
};


export type MutationPendingBookingArgs = {
  id: Scalars['ID']['input'];
  input: PendingBookingStatusInput;
};


export type MutationPromoteRelocationArgs = {
  budget_amount: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  platforms: Array<PromotionPlatform>;
};


export type MutationPushIntegrationToSheetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPushJucyBookingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReanalyzeReceiptArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRecordAssignmentLocationsArgs = {
  input: RecordLocationsInput;
};


export type MutationRefreshRelocationDealScoreArgs = {
  relocation_id: Scalars['ID']['input'];
};


export type MutationRefundPaymentArgs = {
  amount: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRegenerateOgImageArgs = {
  id: Scalars['ID']['input'];
  model?: InputMaybe<ImageGenerationModel>;
  prompt?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRelocationLineSoldArgs = {
  id: Scalars['ID']['input'];
  sold: Scalars['Boolean']['input'];
  soldBy?: InputMaybe<Competitor>;
};


export type MutationRemoveOrganisationMemberArgs = {
  organisation_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};


export type MutationReopenIncidentArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationReportIncidentArgs = {
  input: ReportIncidentInput;
};


export type MutationRequestEmailChangeArgs = {
  email: Scalars['String']['input'];
};


export type MutationResendInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResendPayoutEmailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResendRefundEmailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResendSupplierBookingReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetWorkOrderAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResolveBookingChangeRequestArgs = {
  id: Scalars['ID']['input'];
  input: ResolveBookingChangeRequestInput;
};


export type MutationResolveBookingPaymentRequestArgs = {
  id: Scalars['ID']['input'];
  input: ResolveBookingPaymentRequestInput;
};


export type MutationResolveRelocationLineEmailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRespondToWorkOrderJobOpeningArgs = {
  accept: Scalars['Boolean']['input'];
  job_opening_id: Scalars['ID']['input'];
};


export type MutationReverseContactCreditArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationRevokeInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendBookingChangeRequestPaymentRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendBookingPaymentRequestToCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendInvoicePaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendJobOpeningOfferNotificationsArgs = {
  id: Scalars['ID']['input'];
  offerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationSendMessageArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  file_paths?: InputMaybe<Array<Scalars['String']['input']>>;
  thread_id: Scalars['String']['input'];
};


export type MutationSendProDriverAgreementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendQuoteArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationSetBlogPostTripArticleSortOrderArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationSetDefaultImageGenerationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetRelocationPageArticleSortOrderArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationSetRelocationPriorityArgs = {
  id: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetThreadClosedArgs = {
  closed: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetThreadNotificationsArgs = {
  enabled: Scalars['Boolean']['input'];
  thread_id: Scalars['ID']['input'];
};


export type MutationSetWorkOrderInvoiceNotRequiredArgs = {
  id: Scalars['ID']['input'];
  invoice_not_required: Scalars['Boolean']['input'];
};


export type MutationSignProDriverAgreementArgs = {
  id: Scalars['ID']['input'];
  input: SignProDriverAgreementInput;
};


export type MutationSnoozeCallbackLeadArgs = {
  id: Scalars['ID']['input'];
  input: SnoozeCallbackLeadInput;
};


export type MutationStartCallbackLeadCallArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitRefundByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationSyncBlogPostTagsArgs = {
  id: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']>;
};


export type MutationSyncPromotionChannelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTranslateBlogPostArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnblockBookingCustomerArgs = {
  booking_id: Scalars['ID']['input'];
};


export type MutationUpdateBlogAuthorArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBlogAuthorInput;
};


export type MutationUpdateBlogPostArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBlogPostInput;
};


export type MutationUpdateBlogTagArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBlogTagInput;
};


export type MutationUpdateBookingArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBookingInput;
};


export type MutationUpdateBookingChangeRequestArgs = {
  input: UpdateBookingChangeRequestInput;
  uuid: Scalars['String']['input'];
};


export type MutationUpdateBookingDatesArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBookingDatesInput;
};


export type MutationUpdateCityArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCityInput;
};


export type MutationUpdateContactArgs = {
  id: Scalars['ID']['input'];
  input: UpdateContactInput;
};


export type MutationUpdateCurrentOrganisationArgs = {
  input: UpdateCurrentOrganisationInput;
};


export type MutationUpdateDefaultRateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDefaultRateInput;
};


export type MutationUpdateFaqArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFaqInput;
};


export type MutationUpdateFeatureFlagArgs = {
  input: UpdateFeatureFlagInput;
};


export type MutationUpdateIncidentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateIncidentInput;
};


export type MutationUpdateIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateIntegrationInput;
};


export type MutationUpdateIntegrationLinkArgs = {
  id: Scalars['ID']['input'];
  input: UpdateIntegrationLinkInput;
};


export type MutationUpdateInvoiceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateInvoiceInput;
};


export type MutationUpdateInvoicePaymentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateInvoicePaymentInput;
};


export type MutationUpdateMeArgs = {
  input: UpdateMeInput;
};


export type MutationUpdateMediaArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMediaInput;
};


export type MutationUpdateMyNotificationSettingsArgs = {
  gets_email_notifications: Scalars['Boolean']['input'];
};


export type MutationUpdateMyProDriverProfileArgs = {
  input: UpdateMyProDriverProfileInput;
};


export type MutationUpdateMyProfilePictureArgs = {
  key: Scalars['String']['input'];
};


export type MutationUpdateMyWaitlistPreferenceArgs = {
  input: UpdateWaitlistPreferenceInput;
};


export type MutationUpdatePartnerArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePartnerInput;
};


export type MutationUpdatePaymentArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePaymentInput;
};


export type MutationUpdatePopularTripArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePopularTripInput;
};


export type MutationUpdateProDriverArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProDriverInput;
};


export type MutationUpdateProDriverAgreementArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProDriverAgreementInput;
};


export type MutationUpdateProDriverAgreementTemplateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProDriverAgreementTemplateInput;
};


export type MutationUpdatePromotionChannelArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePromotionChannelInput;
};


export type MutationUpdateQuoteArgs = {
  id: Scalars['ID']['input'];
  input: UpdateQuoteInput;
};


export type MutationUpdateReceiptArgs = {
  id: Scalars['ID']['input'];
  input: UpdateReceiptInput;
};


export type MutationUpdateRefundArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRefundInput;
};


export type MutationUpdateRefundBankDetailsByUuidArgs = {
  input: UpdateRefundBankDetailsInput;
  uuid: Scalars['String']['input'];
};


export type MutationUpdateRefundPaymentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRefundPaymentInput;
};


export type MutationUpdateRelocationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRelocationInput;
};


export type MutationUpdateRelocationCompletedTaskArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRelocationCompletedTaskInput;
};


export type MutationUpdateRelocationHighlightArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRelocationHighlightInput;
};


export type MutationUpdateRelocationPageArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRelocationPageInput;
};


export type MutationUpdateRelocationStatusesArgs = {
  ids: Array<Scalars['ID']['input']>;
  status: RelocationStatus;
};


export type MutationUpdateStripePaymentMethodArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStripePaymentMethodInput;
};


export type MutationUpdateSupplierArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSupplierInput;
};


export type MutationUpdateSupplierAcknowledgementArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSupplierAcknowledgementInput;
};


export type MutationUpdateSupplierAdminContactArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSupplierAdminContactInput;
};


export type MutationUpdateSupplierInsuranceOptionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSupplierInsuranceOptionInput;
};


export type MutationUpdateSupplierOfficeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSupplierOfficeInput;
};


export type MutationUpdateSupplierPurchasableExtraArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateSupplierPurchasableExtraInput>;
};


export type MutationUpdateSupplierTermsAndConditionsArgs = {
  input: UpdateSupplierTermsAndConditionsInput;
};


export type MutationUpdateSupplierTripArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSupplierTripInput;
};


export type MutationUpdateTaskArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTaskInput;
};


export type MutationUpdateTenantArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTenantInput;
};


export type MutationUpdateTripArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTripInput;
};


export type MutationUpdateTripFaqsArgs = {
  faqs: Array<TripFaqInput>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
};


export type MutationUpdateUserNotificationSettingsArgs = {
  gets_email_notifications: Scalars['Boolean']['input'];
  user_id: Scalars['ID']['input'];
};


export type MutationUpdateVehicleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateVehicleInput;
};


export type MutationUpdateWaitlistArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWaitlistInput;
};


export type MutationUpdateWaitlistPreferenceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWaitlistPreferenceInput;
};


export type MutationUpdateWorkOrderArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkOrderInput;
};


export type MutationUpdateWorkOrderAssignmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkOrderAssignmentInput;
};


export type MutationUpdateWorkOrderAssignmentExpenseArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkOrderAssignmentExpenseInput;
};


export type MutationUpdateWorkOrderAssignmentPayoutArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkOrderAssignmentPayoutInput;
};


export type MutationUpdateWorkOrderJobOpeningArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkOrderJobOpeningInput;
};


export type MutationUpdateWorkOrderJobOpeningOfferArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkOrderJobOpeningOfferInput;
};


export type MutationUpdateWorkOrderReviewArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkOrderDriverReviewInput;
};


export type MutationUploadAssignmentPhotosArgs = {
  collectionName: MediaCollection;
  filePaths: Array<Scalars['String']['input']>;
  workOrderAssignmentId: Scalars['ID']['input'];
};


export type MutationUploadDriverReceiptsArgs = {
  filePaths: Array<Scalars['String']['input']>;
  workOrderAssignmentId: Scalars['ID']['input'];
};


export type MutationUploadExpenseReceiptsArgs = {
  filePaths: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpsertImportSettingArgs = {
  input: ImportSettingInput;
};


export type MutationUpsertIntegrationLinkArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: CreateIntegrationLinkInput;
};


export type MutationVerifyEmailChangeArgs = {
  code: Scalars['String']['input'];
};


export type MutationVipBookingArgs = {
  id: Scalars['ID']['input'];
  input: VipBookingStatusInput;
};


export type MutationVoidInvoiceArgs = {
  id: Scalars['ID']['input'];
  voidPayments: Scalars['Boolean']['input'];
};


export type MutationVoidProDriverAgreementArgs = {
  id: Scalars['ID']['input'];
};

export type OnboardingCreateOrganisation = {
  organisation_id: Scalars['ID']['output'];
  supplier_id: Scalars['ID']['output'];
};

export type OnboardingCreateOrganisationInput = {
  currency: Currency;
  description: Scalars['String']['input'];
  fleet_size: Scalars['Int']['input'];
  hire_unit_type: HireUnitType;
  name: Scalars['String']['input'];
  recaptcha_token: Scalars['String']['input'];
  region: Region;
};

export type OpenIncidentClaimInput = {
  claim_reference?: InputMaybe<Scalars['String']['input']>;
  /** At least one, such as the insurer's claim form or a repair invoice. */
  document_file_paths: Array<Scalars['String']['input']>;
  /** What Imoova pays the supplier, in the work order's currency. */
  excess_amount: Scalars['Int']['input'];
  insurer?: InputMaybe<Scalars['String']['input']>;
};

export type OpeningHours = {
  date: Scalars['String']['output'];
  ranges: Array<OpeningHoursRange>;
};

export type OpeningHoursRange = {
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type Organisation = {
  contact?: Maybe<Contact>;
  created_at: Scalars['DateTime']['output'];
  featureFlags: Array<FeatureFlag>;
  id: Scalars['ID']['output'];
  is_verified: Scalars['Boolean']['output'];
  /** When this organisation last listed a relocation. */
  last_relocation_created_at?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  profilePicture?: Maybe<Media>;
  salesAgent?: Maybe<User>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  users: Array<User>;
};

export type OrganisationCommissionData = {
  bookingCount: Scalars['Int']['output'];
  commissionAmount: Scalars['Int']['output'];
  organisation: Organisation;
  revenue: Scalars['Int']['output'];
};

export type OrganisationDashboardStatsPeriod = {
  successful_bookings_count: Scalars['Int']['output'];
};

/** A paginated list of Organisation items. */
export type OrganisationPaginator = {
  /** A list of Organisation items. */
  data: Array<Organisation>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type OrganisationSalesData = {
  bookingsByDate: Array<BookingsSalesData>;
  organisation: Organisation;
};

export type OrganisationUser = {
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  organisation: Organisation;
  organisation_id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  user_id: Scalars['ID']['output'];
};

/** A paginated list of OrganisationUser items. */
export type OrganisationUserPaginator = {
  /** A list of OrganisationUser items. */
  data: Array<OrganisationUser>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/**
 * One rep's outgoing calls over a period. A call Zoom could not pin to anyone is
 * reported with no user rather than dropped from the totals.
 */
export type OutgoingCallTally = {
  calls: Scalars['Int']['output'];
  /** Calls made per hour of the working window the period has had so far. */
  calls_per_hour: Scalars['Float']['output'];
  connected: Scalars['Int']['output'];
  /** How many separate callback leads those calls reached. */
  leads: Scalars['Int']['output'];
  talk_seconds: Scalars['Int']['output'];
  user?: Maybe<User>;
  /** Hours of that window in the period, which is what the rate is over. */
  working_hours: Scalars['Float']['output'];
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

export type Partner = {
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  logo_path?: Maybe<Scalars['String']['output']>;
  logo_url?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type PayableAttributedTo = Booking;

export type PayableLineItem = {
  amount: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fulfills?: Maybe<Payment>;
  id: Scalars['ID']['output'];
  object_id: Scalars['ID']['output'];
  object_type: ModelType;
  quantity: Scalars['Int']['output'];
  tax_type: TaxType;
  unit_amount: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type PayableLineItemFulfilledByInput = {
  connect?: InputMaybe<Scalars['ID']['input']>;
  update?: InputMaybe<PayableLineItemFulfilledByUpdateInput>;
};

export type PayableLineItemFulfilledByUpdateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Payee = Organisation | User;

export type Payment = {
  amount: Scalars['Int']['output'];
  amount_exc_tax: Scalars['Int']['output'];
  amount_fee: Scalars['Int']['output'];
  amount_inc_tax: Scalars['Int']['output'];
  amount_paid: Scalars['Int']['output'];
  amount_refunded: Scalars['Int']['output'];
  amount_tax: Scalars['Int']['output'];
  attributedTo?: Maybe<PaymentAttributedTo>;
  attributed_to_id?: Maybe<Scalars['ID']['output']>;
  attributed_to_type?: Maybe<ModelType>;
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['String']['output']>;
  fulfilledBy?: Maybe<PaymentFulfilledBy>;
  id: Scalars['ID']['output'];
  is_tax_included: Scalars['Boolean']['output'];
  payee?: Maybe<Contact>;
  status: PaymentStatus;
  tax_type: TaxType;
  type: PaymentType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentAttributedTo = Booking;

export type PaymentFulfilledBy = PayableLineItem | StripePayment;

export type PaymentIntent = {
  client_secret: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** A paginated list of Payment items. */
export type PaymentPaginator = {
  /** A list of Payment items. */
  data: Array<Payment>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum PaymentStatus {
  Disputed = 'DISPUTED',
  Paid = 'PAID',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Unpaid = 'UNPAID',
  Voided = 'VOIDED'
}

export enum PaymentType {
  CustomerPayment = 'CUSTOMER_PAYMENT',
  SupplierPayment = 'SUPPLIER_PAYMENT'
}

export enum PayoutStatus {
  Paid = 'PAID',
  Pending = 'PENDING',
  Voided = 'VOIDED'
}

export type PendingBookingStatusInput = {
  customer_note?: InputMaybe<Scalars['String']['input']>;
};

export enum PersonalAccessTokenSource {
  Admin = 'ADMIN',
  Android = 'ANDROID',
  Ios = 'IOS',
  Marketplace = 'MARKETPLACE'
}

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type PopularTrip = {
  allow_booking_requests: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  deliveryCity: City;
  departureCity: City;
  id: Scalars['ID']['output'];
  region: Region;
  standard_relocation_days_allowed: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of PopularTrip items. */
export type PopularTripPaginator = {
  /** A list of PopularTrip items. */
  data: Array<PopularTrip>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ProDriver = {
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  bank_account_name?: Maybe<Scalars['String']['output']>;
  bank_account_number?: Maybe<Scalars['String']['output']>;
  bank_identifier_code?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  basedIn: City;
  bio?: Maybe<Scalars['String']['output']>;
  business_registration_number?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  currentAssignment?: Maybe<WorkOrderAssignment>;
  date_of_birth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hasPushToken: Scalars['Int']['output'];
  has_tow_vehicle: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  incidentCount?: Maybe<Scalars['Int']['output']>;
  license_issuer?: Maybe<Scalars['String']['output']>;
  license_number?: Maybe<Scalars['String']['output']>;
  license_type: ProDriverLicenseType;
  name?: Maybe<Scalars['String']['output']>;
  numberOfCompletedAssignments: Scalars['Int']['output'];
  numberOfReviews: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  status: ProDriverStatus;
  tax_registration: TaxRegistration;
  tow_capacity_kg?: Maybe<Scalars['Int']['output']>;
  tow_vehicle_type?: Maybe<ProDriverTowVehicleType>;
  tow_vehicle_year?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type ProDriverAgreement = {
  body: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  created_at: Scalars['DateTime']['output'];
  decline_reason?: Maybe<Scalars['String']['output']>;
  declined_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  pdf?: Maybe<Media>;
  sent_at?: Maybe<Scalars['DateTime']['output']>;
  signature_svg?: Maybe<Scalars['String']['output']>;
  signedPdf?: Maybe<Media>;
  signed_at?: Maybe<Scalars['DateTime']['output']>;
  signer_name?: Maybe<Scalars['String']['output']>;
  status: ProDriverAgreementStatus;
  template?: Maybe<ProDriverAgreementTemplate>;
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
  viewed_at?: Maybe<Scalars['DateTime']['output']>;
  voided_at?: Maybe<Scalars['DateTime']['output']>;
  workOrderAssignment: WorkOrderAssignment;
  work_order_assignment_id: Scalars['ID']['output'];
};

export type ProDriverAgreementMergeField = {
  group: Scalars['String']['output'];
  label: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type ProDriverAgreementPreviewInput = {
  agreement_id?: InputMaybe<Scalars['ID']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum ProDriverAgreementStatus {
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Sent = 'SENT',
  Signed = 'SIGNED',
  Viewed = 'VIEWED',
  Voided = 'VOIDED'
}

export type ProDriverAgreementTemplate = {
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  body: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pdf?: Maybe<Media>;
  revision: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum ProDriverLicenseType {
  Heavy = 'HEAVY',
  Standard = 'STANDARD'
}

/** A paginated list of ProDriver items. */
export type ProDriverPaginator = {
  /** A list of ProDriver items. */
  data: Array<ProDriver>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ProDriverReview = {
  comment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  proDriver: ProDriver;
  rating: Scalars['Int']['output'];
  reviewedBy: User;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  workOrderAssignment?: Maybe<WorkOrderAssignment>;
};

/** A paginated list of ProDriverReview items. */
export type ProDriverReviewPaginator = {
  /** A list of ProDriverReview items. */
  data: Array<ProDriverReview>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum ProDriverStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ProDriverSupplierCityMovement = {
  count: Scalars['Int']['output'];
  delivery_city: Scalars['String']['output'];
  departure_city: Scalars['String']['output'];
};

export type ProDriverSupplierReport = {
  avg_payout_per_driver_aud: Scalars['Int']['output'];
  avg_profit_per_work_order_aud: Scalars['Int']['output'];
  lost_count: Scalars['Int']['output'];
  supplier_id: Scalars['ID']['output'];
  supplier_name: Scalars['String']['output'];
  total_assignments: Scalars['Int']['output'];
  total_claimed_expenses_aud: Scalars['Int']['output'];
  total_expected_payout_aud: Scalars['Int']['output'];
  total_invoice_amount_aud: Scalars['Int']['output'];
  total_payouts_aud: Scalars['Int']['output'];
  total_profit_aud: Scalars['Int']['output'];
  total_work_orders: Scalars['Int']['output'];
  won_count: Scalars['Int']['output'];
};

export enum ProDriverTowVehicleType {
  Car = 'CAR',
  FourWheelDrive = 'FOUR_WHEEL_DRIVE',
  Other = 'OTHER',
  Suv = 'SUV',
  Truck = 'TRUCK',
  Ute = 'UTE',
  Van = 'VAN'
}

export type PromotionChannel = {
  budget_amount: Scalars['Int']['output'];
  clicks: Scalars['Int']['output'];
  conversions: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  external_ad_group_id?: Maybe<Scalars['String']['output']>;
  external_ad_id?: Maybe<Scalars['String']['output']>;
  external_campaign_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  impressions: Scalars['Int']['output'];
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  /** Deep link to the campaign in the platform's own ads manager. */
  manager_url?: Maybe<Scalars['String']['output']>;
  platform: PromotionPlatform;
  promotion: RelocationPromotion;
  spend_amount: Scalars['Int']['output'];
  status: PromotionStatus;
};

/** A paginated list of PromotionChannel items. */
export type PromotionChannelPaginator = {
  /** A list of PromotionChannel items. */
  data: Array<PromotionChannel>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/**
 * How many promotions are still delivering on at least one channel, and how many
 * are not. Counts promotions rather than channels, because that is what the ads
 * list shows a row per.
 */
export type PromotionCounts = {
  active: Scalars['Int']['output'];
  inactive: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PromotionCreative = {
  body: Scalars['String']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  target_url: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum PromotionPlatform {
  Google = 'GOOGLE',
  Meta = 'META',
  Openai = 'OPENAI',
  Tiktok = 'TIKTOK'
}

/**
 * Performance totals over a window, summed from the per-day rows the sync
 * stores, plus the day-by-day series behind them.
 */
export type PromotionStats = {
  clicks: Scalars['Int']['output'];
  conversions: Scalars['Int']['output'];
  days: Array<PromotionStatsDay>;
  impressions: Scalars['Int']['output'];
  spend_amount: Scalars['Int']['output'];
};

export type PromotionStatsDay = {
  clicks: Scalars['Int']['output'];
  conversions: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
  impressions: Scalars['Int']['output'];
  spend_amount: Scalars['Int']['output'];
};

export enum PromotionStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Paused = 'PAUSED'
}

/**
 * Customer-facing booking view exposed via UUID lookup. Limited to fields
 * the public refund/receipts flow needs — does not surface PII or pricing.
 */
export type PublicBooking = {
  id: Scalars['ID']['output'];
  reference: Scalars['String']['output'];
  refund?: Maybe<PublicRefund>;
  status: BookingStatus;
  uuid: Scalars['String']['output'];
};

export type PublicOrganisation = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profilePicture?: Maybe<Media>;
};

export type PublicQuote = {
  additional_notations?: Maybe<Scalars['String']['output']>;
  amount_exc_tax: Scalars['Int']['output'];
  amount_inc_tax: Scalars['Int']['output'];
  amount_tax: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  expiry_date?: Maybe<Scalars['String']['output']>;
  lineItems: Array<QuoteLineItem>;
  payee?: Maybe<PublicQuoteContact>;
  pdf_url: Scalars['String']['output'];
  purchase_order_number?: Maybe<Scalars['String']['output']>;
  quote_date?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  status: QuoteStatus;
  tax_inclusion_type: TaxInclusionType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type PublicQuoteAddress = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  formatted_address_line_1: Scalars['String']['output'];
  formatted_address_line_2: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type PublicQuoteContact = {
  billingAddress?: Maybe<PublicQuoteAddress>;
  billing_email?: Maybe<Scalars['String']['output']>;
  billing_phone?: Maybe<Scalars['String']['output']>;
  company_number?: Maybe<Scalars['String']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * Customer-facing refund view exposed via UUID lookup. Drops sensitive bank
 * fields (full account number, identifier code) so a leaked UUID cannot be
 * used to harvest payout details. Submission still works because writes go
 * through `updateRefundBankDetailsByUuid`.
 */
export type PublicRefund = {
  bank_account_name?: Maybe<Scalars['String']['output']>;
  bank_account_number_last4?: Maybe<Scalars['String']['output']>;
  bank_country?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  booking_deliver_at?: Maybe<Scalars['DateTime']['output']>;
  booking_depart_at?: Maybe<Scalars['DateTime']['output']>;
  currency: Currency;
  has_bank_details: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  maximum_refund_amount?: Maybe<Scalars['Int']['output']>;
  receipts: Array<Receipt>;
  recipient_address?: Maybe<Scalars['String']['output']>;
  refund_amount: Scalars['Int']['output'];
  status: RefundStatus;
  type: RefundType;
  uuid: Scalars['String']['output'];
};

export type PurchasableExtrasInput = {
  quantity: Scalars['Int']['input'];
  supplier_purchasable_extra_id: Scalars['ID']['input'];
};

export type PushToken = {
  notification_count?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Query = {
  activityLogs: ActivityLogPaginator;
  adminDashboardStats: DashboardStats;
  agentRun: AgentRunDetail;
  agentRuns: AgentRunPaginator;
  allCities: Array<AllCity>;
  allCitiesWithDeals: Array<CitiesWithDealsByRegion>;
  allEmailEvents: EmailEventPaginator;
  allSupplierDashboardBookingStats: Array<AllSupplierDashboardBookingStats>;
  allUsers: UserPaginator;
  assignmentLocations: Array<AssignmentLocationData>;
  billingEntities: Array<Contact>;
  blocklists: BlocklistPaginator;
  blogAuthor?: Maybe<BlogAuthor>;
  blogAuthors: Array<BlogAuthor>;
  blogPost?: Maybe<BlogPost>;
  blogPostRating?: Maybe<BlogPostRating>;
  blogPostSlugAvailable: Scalars['Boolean']['output'];
  blogPostTripArticles: Array<BlogPostTripArticle>;
  blogPosts: BlogPostPaginator;
  blogTag?: Maybe<BlogTag>;
  blogTags: Array<BlogTag>;
  booking: Booking;
  bookingByUuid: Booking;
  bookingChangeRequestByUuid: BookingChangeRequest;
  bookingChangeRequestQuote: BookingChangeRequestQuote;
  bookingChangeRequests: BookingChangeRequestPaginator;
  bookingPaymentRequestByUuid: BookingPaymentRequest;
  bookingPaymentRequests: BookingPaymentRequestPaginator;
  bookingStatusCounts: Array<BookingStatusStat>;
  bookingSupplierConfirmation: BookingSupplierConfirmation;
  bookings: BookingPaginator;
  callLogCount?: Maybe<Array<CallLogStat>>;
  callbackLead?: Maybe<CallbackLead>;
  callbackLeadCounts: CallbackLeadCounts;
  callbackLeads: CallbackLeadPaginator;
  cities: CityPaginator;
  citiesWithDealsForRegion: Array<CityWithDeals>;
  city: City;
  cityBySlug?: Maybe<City>;
  closestCity: ClosestCityResult;
  contact: Contact;
  contactCredits: ContactCreditPaginator;
  contacts: ContactPaginator;
  currentOrganisation: Organisation;
  emailEvents: EmailEventPaginator;
  faqs: Array<Faq>;
  gapRentalsCount: Scalars['Int']['output'];
  getHmac?: Maybe<Scalars['String']['output']>;
  googleMapsAutocomplete: Array<GoogleMapsPlace>;
  googleMapsPlace: GoogleMapsPlaceDetails;
  importSetting?: Maybe<ImportSetting>;
  incident: Incident;
  incidents: IncidentPaginator;
  integration: Integration;
  integrationLink: IntegrationLink;
  integrationLinks: IntegrationLinkPaginator;
  integrations: IntegrationPaginator;
  intercomUserToken: IntercomUserToken;
  invoice: Invoice;
  invoiceByUuid: Invoice;
  invoicePayments: InvoicePaymentPaginator;
  invoiceStatusCount: Array<InvoiceStatusStat>;
  invoices: InvoicePaginator;
  /** Whether the picked pickup place looks like a dealership or workshop rather than one of the supplier's offices. */
  isServiceCenterPickup: Scalars['Boolean']['output'];
  itineraryByUuid?: Maybe<Itinerary>;
  mailchimpCustomerJourneySteps: Array<MailchimpCustomerJourneyStep>;
  mailchimpCustomerJourneys: Array<MailchimpCustomerJourney>;
  /** @deprecated Use the REST endpoint GET /api/auth/me. No client queries this field any more; it is kept only for in-flight app builds. */
  me: User;
  media: MediaPaginator;
  mediaRecord: Media;
  meta: Meta;
  multiLegTrip?: Maybe<MultiLegTrip>;
  /**
   * The multi-leg trips the latest build found, with any whose vehicles have since
   * sold left out.
   */
  multiLegTrips: MultiLegTripPaginator;
  /**
   * How many trips each region has to show, counted off the same set the list
   * returns. A region on zero has no trips page worth linking to.
   */
  multiLegTripsByRegion: Array<MultiLegTripsByRegionCount>;
  myBookings: Array<Booking>;
  myItineraries: Array<Itinerary>;
  myProDriverAgreements: Array<ProDriverAgreement>;
  myProDriverRecord?: Maybe<ProDriver>;
  myWaitlists: WaitlistPaginator;
  /**
   * The signed-in driver's own assignments, a page at a time, newest job first.
   * `current` splits them the way the driver thinks of them: the jobs still in
   * play, or the ones already finished or archived.
   */
  myWorkOrderAssignmentList: WorkOrderAssignmentPaginator;
  myWorkOrderAssignments: Array<WorkOrderAssignment>;
  myWorkOrderJobOpenings: WorkOrderJobOpeningPaginator;
  organisation: Organisation;
  organisationInvitations: InvitationPaginator;
  organisationMembers: OrganisationUserPaginator;
  organisationUsers: OrganisationUserPaginator;
  organisations: OrganisationPaginator;
  /**
   * What each rep rang out between two dates, most calls first. Counts only calls
   * made on a weekday inside the 8am to 4pm window the team works.
   */
  outgoingCallTally: Array<OutgoingCallTally>;
  partners: Array<Partner>;
  payment: Payment;
  payments: PaymentPaginator;
  popularTrip?: Maybe<PopularTrip>;
  popularTrips: PopularTripPaginator;
  proDriver: ProDriver;
  proDriverAgreement?: Maybe<ProDriverAgreement>;
  proDriverAgreementMergeFields: Array<ProDriverAgreementMergeField>;
  proDriverAgreementPreview: Scalars['String']['output'];
  proDriverAgreementTemplate?: Maybe<ProDriverAgreementTemplate>;
  proDriverAgreementTemplates: Array<ProDriverAgreementTemplate>;
  proDriverAgreements: Array<ProDriverAgreement>;
  proDriverReviews: ProDriverReviewPaginator;
  proDriverSupplierCityMatrix: Array<ProDriverSupplierCityMovement>;
  proDriverSupplierReport: Array<ProDriverSupplierReport>;
  proDrivers: ProDriverPaginator;
  promotionChannels: PromotionChannelPaginator;
  promotionCounts: PromotionCounts;
  promotionStats: PromotionStats;
  publicBooking?: Maybe<PublicBooking>;
  publicQuote: PublicQuote;
  quote: Quote;
  quoteByUuid: Quote;
  quoteStatusCount: Array<QuoteStatusStat>;
  quotes: QuotePaginator;
  receipt?: Maybe<Receipt>;
  receivablesReconciliation: Array<ReceivablesReconciliationItem>;
  receivablesReconciliationSummary: Array<ReceivablesReconciliationSummary>;
  refundByUuid?: Maybe<PublicRefund>;
  refunds: Array<Refund>;
  relocation?: Maybe<Relocation>;
  relocationAvailable: Scalars['Boolean']['output'];
  relocationCost: RelocationCost;
  /** The deal analysis conversation shared by everyone viewing the relocation. */
  relocationDealChat?: Maybe<Array<RelocationDealChatMessage>>;
  relocationDeliveryOpenHours: Array<OpeningHours>;
  relocationDepartureDates: RelocationDepartureDatesResponse;
  relocationFerryDates: Array<Scalars['Date']['output']>;
  relocationFlowReport: RelocationFlowReport;
  relocationGroups: RelocationGroupPaginator;
  relocationHighlights: RelocationHighlightPaginator;
  relocationImageGenerations: Array<ImageGeneration>;
  relocationLineEmail: RelocationLineEmail;
  relocationLines: RelocationLinePaginator;
  relocationPage?: Maybe<RelocationPage>;
  relocationPageById?: Maybe<RelocationPage>;
  relocationPages: RelocationPagePaginator;
  relocationPoints: Array<RelocationPoint>;
  relocationPromotionCreative: PromotionCreative;
  relocationPromotions: RelocationPromotionPaginator;
  relocationStatusCounts: Array<RelocationStatusStat>;
  relocationViews: RelocationViews;
  relocations: RelocationPaginator;
  relocationsByCity: Array<WorldMapPointData>;
  relocationsByRegion: Array<RelocationByRegionCount>;
  relocationsTable: Array<RelocationTableItem>;
  reportBookings: Array<ReportBooking>;
  reportInvoices: Array<ReportInvoice>;
  reportReceipts: ReportReceiptsResult;
  reportRelocations: Array<ReportRelocation>;
  reportWorkOrderAssignments: Array<ReportWorkOrderAssignment>;
  reportWorkOrders: Array<ReportWorkOrder>;
  salesCommissionReport?: Maybe<SalesCommissionData>;
  salesReport: Array<UserSalesData>;
  salesUsers: Array<User>;
  similarWorkOrders: WorkOrderPaginator;
  suggestedRelocations: SuggestedRelocations;
  supplier: Supplier;
  supplierAcknowledgement: SupplierAcknowledgement;
  supplierAcknowledgements: SupplierAcknowledgementPaginator;
  supplierActiveLineStats: SupplierActiveLineStats;
  supplierAdminContact: SupplierAdminContact;
  supplierAdminContacts: SupplierAdminContactPaginator;
  supplierBookingReports: SupplierBookingReportPaginator;
  supplierBookingStatBlock?: Maybe<SupplierBookingStatBlock>;
  supplierInsuranceOption: SupplierInsuranceOption;
  supplierInsuranceOptions: SupplierInsuranceOptionPaginator;
  supplierOffice: SupplierOffice;
  supplierOffices: SupplierOfficePaginator;
  supplierPurchasableExtra?: Maybe<SupplierPurchasableExtra>;
  supplierPurchasableExtras: SupplierPurchasableExtraPaginator;
  supplierReport: Array<SupplierReport>;
  supplierTermsAndConditions?: Maybe<SupplierTermsAndConditions>;
  supplierTrip: SupplierTrip;
  supplierTripByOffices?: Maybe<SupplierTrip>;
  supplierTrips: SupplierTripPaginator;
  suppliers: SupplierPaginator;
  tasks: TaskPaginator;
  thread: Thread;
  threadMessages: ThreadMessagePaginator;
  threads: ThreadPaginator;
  trip: Trip;
  tripByCities: Trip;
  /**
   * Resolves a multi-leg trip into a concrete itinerary: which relocations can
   * serve each hop once the hops before it have run their course, and the dates
   * that follow. Every date comes from the same open hours the checkout date
   * pickers enforce, so anything returned here is bookable as-is.
   */
  tripDraft: TripDraft;
  tripFaqs: Array<TripFaq>;
  tripRoutes: Array<GoogleRouteData>;
  trips: TripPaginator;
  unreadThreadCount: Scalars['Int']['output'];
  user: User;
  userOrganisations: OrganisationUserPaginator;
  users: UserPaginator;
  validateEmailAddress: EmailValidationVerdict;
  vehicle: Vehicle;
  vehicles: VehiclePaginator;
  waitlists: WaitlistPaginator;
  workOrder?: Maybe<WorkOrder>;
  workOrderAssignment: WorkOrderAssignment;
  workOrderAssignmentPayout?: Maybe<WorkOrderAssignmentPayout>;
  workOrderAssignments: WorkOrderAssignmentPaginator;
  workOrderJobOpening?: Maybe<WorkOrderJobOpening>;
  workOrderJobOpeningOffers: WorkOrderJobOpeningOfferPaginator;
  workOrderJobOpenings: WorkOrderJobOpeningPaginator;
  workOrderRegionalCounts: Array<WorkOrderRegionalCount>;
  workOrderStatusCount: Array<WorkOrderStatusCount>;
  workOrders: WorkOrderPaginator;
  zoomPhoneUsers: Array<ZoomPhoneUser>;
};


export type QueryActivityLogsArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryActivityLogsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryActivityLogsWhereWhereConditions>;
};


export type QueryAdminDashboardStatsArgs = {
  comparisonMode: ComparisonMode;
  end: Scalars['DateTimeTz']['input'];
  start: Scalars['DateTimeTz']['input'];
};


export type QueryAgentRunArgs = {
  id: Scalars['ID']['input'];
  kind: AgentRunKind;
};


export type QueryAgentRunsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Array<AgentRunKind>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Array<AgentRunState>>;
};


export type QueryAllCitiesWithDealsArgs = {
  excludeCityId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllEmailEventsArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryAllEmailEventsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  recipient?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<EmailEventStatus>>;
  type?: InputMaybe<Array<EmailType>>;
};


export type QueryAllSupplierDashboardBookingStatsArgs = {
  comparisonMode: ComparisonMode;
  end: Scalars['DateTimeTz']['input'];
  start: Scalars['DateTimeTz']['input'];
};


export type QueryAllUsersArgs = {
  first?: Scalars['Int']['input'];
  hasPhone?: InputMaybe<Scalars['Boolean']['input']>;
  hasWaitlistMatches?: InputMaybe<Scalars['Boolean']['input']>;
  hrsSinceLastCall?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueryAllUsersOrderByRelationOrderByClause>>;
  orderByWaitlistNotification?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  waitlistRegions?: InputMaybe<Array<Region>>;
};


export type QueryAssignmentLocationsArgs = {
  assignmentIds: Array<Scalars['ID']['input']>;
};


export type QueryBillingEntitiesArgs = {
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBlocklistsArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryBlocklistsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBlogAuthorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBlogPostArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBlogPostRatingArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBlogPostSlugAvailableArgs = {
  excludeId?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryBlogPostTripArticlesArgs = {
  destinationCityId: Scalars['ID']['input'];
  originCityId: Scalars['ID']['input'];
};


export type QueryBlogPostsArgs = {
  audience?: InputMaybe<BlogAudience>;
  authorId?: InputMaybe<Scalars['ID']['input']>;
  excludeId?: InputMaybe<Scalars['ID']['input']>;
  first?: Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<QueryBlogPostsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  publishedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BlogPostStatus>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBlogTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookingByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryBookingChangeRequestByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryBookingChangeRequestQuoteArgs = {
  bookingUuid: Scalars['String']['input'];
  input: BookingChangeRequestQuoteInput;
};


export type QueryBookingChangeRequestsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryBookingChangeRequestsWhereWhereConditions>;
};


export type QueryBookingPaymentRequestByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryBookingPaymentRequestsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryBookingPaymentRequestsWhereWhereConditions>;
};


export type QueryBookingStatusCountsArgs = {
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBookingSupplierConfirmationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookingsArgs = {
  delivery_city_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  delivery_office_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  departure_city_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  departure_office_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: Scalars['Int']['input'];
  hasMatches?: InputMaybe<BookingRelocationMatchType>;
  hasNoCustomerPayments?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<QueryBookingsOrderByRelationOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  relocation_id?: InputMaybe<Scalars['ID']['input']>;
  relocation_type?: InputMaybe<Array<RelocationType>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<BookingStatus>>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
  vehicle_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  where?: InputMaybe<QueryBookingsWhereWhereConditions>;
  whereRelocation?: InputMaybe<QueryBookingsWhereRelocationWhereHasConditions>;
};


export type QueryCallLogCountArgs = {
  end?: InputMaybe<Scalars['DateTimeTz']['input']>;
  start?: InputMaybe<Scalars['DateTimeTz']['input']>;
  user_id: Scalars['ID']['input'];
};


export type QueryCallbackLeadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCallbackLeadsArgs = {
  abandonedFirst?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryCallbackLeadsOrderByRelationOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  regions?: InputMaybe<Array<Region>>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Array<CallbackLeadSource>>;
  status?: InputMaybe<Array<CallbackLeadStatus>>;
};


export type QueryCitiesArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryCitiesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Region>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<State>;
};


export type QueryCitiesWithDealsForRegionArgs = {
  excludeCityId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  region: Region;
};


export type QueryCityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCityBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryClosestCityArgs = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  maxDistanceKm?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactCreditsArgs = {
  contact_id?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Array<Currency>>;
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryContactCreditsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Array<ContactCreditType>>;
};


export type QueryContactsArgs = {
  first?: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  managed_by_id?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<Array<QueryContactsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  parent_contact_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<ContactType>>;
  where?: InputMaybe<QueryContactsWhereWhereConditions>;
};


export type QueryEmailEventsArgs = {
  first?: Scalars['Int']['input'];
  object_id: Scalars['ID']['input'];
  object_type: ModelType;
  orderBy?: InputMaybe<Array<QueryEmailEventsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFaqsArgs = {
  displayOnRelocation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetHmacArgs = {
  hmacInput?: InputMaybe<HmacInputData>;
};


export type QueryGoogleMapsAutocompleteArgs = {
  input: GoogleMapsAutocompleteInput;
};


export type QueryGoogleMapsPlaceArgs = {
  placeId: Scalars['ID']['input'];
};


export type QueryImportSettingArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryIncidentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIncidentsArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryIncidentsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pro_driver_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<IncidentStatus>>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
  work_order_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIntegrationLinkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIntegrationLinksArgs = {
  first?: Scalars['Int']['input'];
  integration_id: Scalars['ID']['input'];
  orderBy?: InputMaybe<Array<QueryIntegrationLinksOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIntegrationsArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryIntegrationsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  supplier_id: Scalars['ID']['input'];
  type?: InputMaybe<IntegrationType>;
};


export type QueryIntercomUserTokenArgs = {
  platform: IntercomPlatform;
};


export type QueryInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoiceByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryInvoicePaymentsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvoiceStatusCountArgs = {
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInvoicesArgs = {
  first?: Scalars['Int']['input'];
  managed_by_id?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<Array<QueryInvoicesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  payee_contact_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InvoiceStatus>>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<QueryInvoicesWhereWhereConditions>;
  whereWorkOrder?: InputMaybe<QueryInvoicesWhereWorkOrderWhereHasConditions>;
};


export type QueryIsServiceCenterPickupArgs = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  place_types: Array<Scalars['String']['input']>;
  primary_type?: InputMaybe<Scalars['String']['input']>;
  supplier_id: Scalars['ID']['input'];
};


export type QueryItineraryByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryMailchimpCustomerJourneyStepsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMediaArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMediaRecordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMultiLegTripArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMultiLegTripsArgs = {
  end_city_id?: InputMaybe<Scalars['ID']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Region>;
  start_city_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMyProDriverAgreementsArgs = {
  statuses?: InputMaybe<Array<ProDriverAgreementStatus>>;
  work_order_assignment_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMyWaitlistsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyWorkOrderAssignmentListArgs = {
  current: Scalars['Boolean']['input'];
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyWorkOrderAssignmentsArgs = {
  statuses: Array<WorkOrderAssignmentStatus>;
};


export type QueryMyWorkOrderJobOpeningsArgs = {
  first?: Scalars['Int']['input'];
  opening_statuses?: InputMaybe<Array<WorkOrderJobOpeningStatus>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  statuses: Array<WorkOrderJobOpeningOfferStatus>;
};


export type QueryOrganisationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganisationInvitationsArgs = {
  first?: Scalars['Int']['input'];
  organisation_id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganisationMembersArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganisationUsersArgs = {
  first?: Scalars['Int']['input'];
  organisation_id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganisationsArgs = {
  first?: Scalars['Int']['input'];
  is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<QueryOrganisationsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sales_agent_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOutgoingCallTallyArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};


export type QueryPartnersArgs = {
  region?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentsArgs = {
  currency?: InputMaybe<Array<Currency>>;
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<Array<QueryPaymentsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  payee_contact_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<PaymentStatus>>;
  type?: InputMaybe<Array<PaymentType>>;
  where?: InputMaybe<QueryPaymentsWhereWhereConditions>;
};


export type QueryPopularTripArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPopularTripsArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryPopularTripsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<QueryPopularTripsWhereWhereConditions>;
};


export type QueryProDriverArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProDriverAgreementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProDriverAgreementPreviewArgs = {
  input: ProDriverAgreementPreviewInput;
};


export type QueryProDriverAgreementTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProDriverAgreementsArgs = {
  status?: InputMaybe<Array<ProDriverAgreementStatus>>;
  work_order_assignment_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProDriverReviewsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pro_driver_id?: InputMaybe<Scalars['ID']['input']>;
  work_order_assignment_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProDriverSupplierCityMatrixArgs = {
  range_end_date: Scalars['String']['input'];
  range_start_date: Scalars['String']['input'];
  supplier_id: Scalars['ID']['input'];
};


export type QueryProDriverSupplierReportArgs = {
  range_end_date: Scalars['String']['input'];
  range_start_date: Scalars['String']['input'];
};


export type QueryProDriversArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeJobOpeningId?: InputMaybe<Scalars['ID']['input']>;
  first?: Scalars['Int']['input'];
  hasTowVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  licenseType?: InputMaybe<Array<ProDriverLicenseType>>;
  orderBy?: InputMaybe<Array<QueryProDriversOrderByRelationOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  radiusAround?: InputMaybe<RadiusAround>;
  region?: InputMaybe<Array<Region>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortByMoves?: InputMaybe<SortOrder>;
  sortByPushToken?: InputMaybe<SortOrder>;
  sortByRating?: InputMaybe<SortOrder>;
};


export type QueryPromotionChannelsArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryPromotionChannelsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<PromotionPlatform>;
  status?: InputMaybe<Array<PromotionStatus>>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
  wherePromotion?: InputMaybe<QueryPromotionChannelsWherePromotionWhereHasConditions>;
};


export type QueryPromotionCountsArgs = {
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPromotionStatsArgs = {
  days?: Scalars['Int']['input'];
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPublicBookingArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPublicQuoteArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryQuoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuoteByUuidArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryQuotesArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<QuoteStatus>>;
  where?: InputMaybe<QueryQuotesWhereWhereConditions>;
  whereWorkOrder?: InputMaybe<QueryQuotesWhereWorkOrderWhereHasConditions>;
};


export type QueryReceiptArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReceivablesReconciliationArgs = {
  as_of_date: Scalars['String']['input'];
};


export type QueryReceivablesReconciliationSummaryArgs = {
  as_of_date: Scalars['String']['input'];
};


export type QueryRefundByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryRefundsArgs = {
  object_id: Scalars['ID']['input'];
  object_type: ModelType;
};


export type QueryRelocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRelocationAvailableArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRelocationCostArgs = {
  input: RelocationCostInput;
};


export type QueryRelocationDealChatArgs = {
  relocation_id: Scalars['ID']['input'];
};


export type QueryRelocationDeliveryOpenHoursArgs = {
  departureDate: Scalars['String']['input'];
  departureTime: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type QueryRelocationDepartureDatesArgs = {
  available_from_date: Scalars['String']['input'];
  available_to_date: Scalars['String']['input'];
  delivery_office_id: Scalars['ID']['input'];
  departure_office_id: Scalars['ID']['input'];
  extra_hire_units_allowed: Scalars['Int']['input'];
  fixed_latest_departure_date?: InputMaybe<Scalars['String']['input']>;
  hire_unit_type: HireUnitType;
  hire_units_allowed: Scalars['Int']['input'];
  minimum_hire_units: Scalars['Int']['input'];
  supplier_id: Scalars['ID']['input'];
  vehicle_id: Scalars['ID']['input'];
};


export type QueryRelocationFerryDatesArgs = {
  relocation_id: Scalars['ID']['input'];
};


export type QueryRelocationFlowReportArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryRelocationGroupsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryRelocationGroupsWhereWhereConditions>;
};


export type QueryRelocationHighlightsArgs = {
  first?: Scalars['Int']['input'];
  order?: InputMaybe<Array<QueryRelocationHighlightsOrderOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryRelocationHighlightsWhereWhereConditions>;
};


export type QueryRelocationImageGenerationsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRelocationLineEmailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRelocationLinesArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryRelocationLinesOrderByOrderByClause>>;
  orderByReference?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryRelocationLinesWhereWhereConditions>;
  whereGroup?: InputMaybe<QueryRelocationLinesWhereGroupWhereHasConditions>;
};


export type QueryRelocationPageArgs = {
  slug: Scalars['String']['input'];
};


export type QueryRelocationPageByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRelocationPagesArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryRelocationPagesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRelocationPointsArgs = {
  input: RelocationPointInput;
};


export type QueryRelocationPromotionCreativeArgs = {
  relocation_id: Scalars['ID']['input'];
};


export type QueryRelocationPromotionsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryRelocationPromotionsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  relocation_id?: InputMaybe<Scalars['ID']['input']>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRelocationStatusCountsArgs = {
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Array<RelocationType>>;
};


export type QueryRelocationViewsArgs = {
  end: Scalars['DateTimeTz']['input'];
  id: Scalars['ID']['input'];
  start: Scalars['DateTimeTz']['input'];
};


export type QueryRelocationsArgs = {
  city_slug?: InputMaybe<Scalars['String']['input']>;
  defaultOrder?: InputMaybe<Scalars['Boolean']['input']>;
  delivery_city_id?: InputMaybe<Scalars['ID']['input']>;
  depart_after?: InputMaybe<Scalars['String']['input']>;
  departure_city_id?: InputMaybe<Scalars['ID']['input']>;
  first?: Scalars['Int']['input'];
  hasFerry?: InputMaybe<Scalars['Boolean']['input']>;
  hasFuel?: InputMaybe<Scalars['Boolean']['input']>;
  is_linked?: InputMaybe<Scalars['Boolean']['input']>;
  near?: InputMaybe<RelocationNearInput>;
  orderBy?: InputMaybe<Array<QueryRelocationsOrderByRelationOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  priceOrder?: InputMaybe<Scalars['Boolean']['input']>;
  regions?: InputMaybe<Array<Region>>;
  relevanceOrder?: InputMaybe<Scalars['Boolean']['input']>;
  relocation_page_slug?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seatbelts?: InputMaybe<Scalars['Int']['input']>;
  similar_to?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Array<RelocationStatus>>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Array<RelocationType>>;
  where?: InputMaybe<QueryRelocationsWhereWhereConditions>;
  whereDeliveryCity?: InputMaybe<QueryRelocationsWhereDeliveryCityWhereHasConditions>;
  whereDepartureCity?: InputMaybe<QueryRelocationsWhereDepartureCityWhereHasConditions>;
  whereSupplier?: InputMaybe<QueryRelocationsWhereSupplierWhereHasConditions>;
  whereVehicle?: InputMaybe<QueryRelocationsWhereVehicleWhereHasConditions>;
};


export type QueryRelocationsByCityArgs = {
  supplierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryRelocationsTableArgs = {
  relocation_type?: InputMaybe<RelocationType>;
};


export type QueryReportBookingsArgs = {
  date_basis?: InputMaybe<BookingReportDateBasis>;
  range_end_date: Scalars['String']['input'];
  range_start_date: Scalars['String']['input'];
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryReportInvoicesArgs = {
  range_end_date: Scalars['String']['input'];
  range_start_date: Scalars['String']['input'];
};


export type QueryReportReceiptsArgs = {
  range_end_date: Scalars['String']['input'];
  range_start_date: Scalars['String']['input'];
};


export type QueryReportRelocationsArgs = {
  range_end_date: Scalars['String']['input'];
  range_start_date: Scalars['String']['input'];
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryReportWorkOrderAssignmentsArgs = {
  range_end_date: Scalars['String']['input'];
  range_start_date: Scalars['String']['input'];
};


export type QueryReportWorkOrdersArgs = {
  range_end_date: Scalars['String']['input'];
  range_start_date: Scalars['String']['input'];
};


export type QuerySalesCommissionReportArgs = {
  quarter: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
  year: Scalars['Int']['input'];
};


export type QuerySalesReportArgs = {
  end: Scalars['DateTimeTz']['input'];
  start: Scalars['DateTimeTz']['input'];
};


export type QuerySimilarWorkOrdersArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  work_order_id: Scalars['ID']['input'];
};


export type QuerySuggestedRelocationsArgs = {
  lat: Scalars['Float']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  lng: Scalars['Float']['input'];
};


export type QuerySupplierArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierAcknowledgementArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierAcknowledgementsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  supplier_id: Scalars['ID']['input'];
};


export type QuerySupplierActiveLineStatsArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QuerySupplierAdminContactArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierAdminContactsArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QuerySupplierAdminContactsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  supplier_id: Scalars['ID']['input'];
};


export type QuerySupplierBookingReportsArgs = {
  first?: Scalars['Int']['input'];
  month?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierBookingStatBlockArgs = {
  comparisonMode: ComparisonMode;
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
  supplierId: Scalars['ID']['input'];
};


export type QuerySupplierInsuranceOptionArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierInsuranceOptionsArgs = {
  first?: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<Array<QuerySupplierInsuranceOptionsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySupplierOfficeArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierOfficesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QuerySupplierOfficesOrderByRelationOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySupplierPurchasableExtraArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierPurchasableExtrasArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySupplierReportArgs = {
  range_end_date: Scalars['String']['input'];
  range_start_date: Scalars['String']['input'];
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySupplierTermsAndConditionsArgs = {
  relocationType?: InputMaybe<RelocationType>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySupplierTripArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierTripByOfficesArgs = {
  officeAId: Scalars['ID']['input'];
  officeBId: Scalars['ID']['input'];
};


export type QuerySupplierTripsArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QuerySupplierTripsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuerySupplierTripsWhereWhereConditions>;
};


export type QuerySuppliersArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  managed_by_id?: InputMaybe<Scalars['ID']['input']>;
  managed_by_me?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<QuerySuppliersOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTasksArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryTasksOrderByOrderByClause>>;
  orgOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<TaskStatus>>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Array<TaskType>>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<QueryTasksWhereWhereConditions>;
};


export type QueryThreadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryThreadMessagesArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryThreadMessagesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  thread_id: Scalars['String']['input'];
};


export type QueryThreadsArgs = {
  defaultOrder?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ThreadSort>;
  status?: InputMaybe<ThreadStatusFilter>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
  threadable_id?: InputMaybe<Scalars['ID']['input']>;
  threadable_type?: InputMaybe<ModelType>;
};


export type QueryTripArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTripByCitiesArgs = {
  cityAId: Scalars['ID']['input'];
  cityBId: Scalars['ID']['input'];
};


export type QueryTripDraftArgs = {
  input: TripDraftInput;
};


export type QueryTripFaqsArgs = {
  cityAId: Scalars['ID']['input'];
  cityBId: Scalars['ID']['input'];
};


export type QueryTripRoutesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTripsArgs = {
  city_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: Scalars['Int']['input'];
  order?: InputMaybe<Array<QueryTripsOrderRelationOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUnreadThreadCountArgs = {
  status?: InputMaybe<ThreadStatusFilter>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserOrganisationsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  user_id: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryUsersOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateEmailAddressArgs = {
  email: Scalars['String']['input'];
};


export type QueryVehicleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVehiclesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryVehiclesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWaitlistsArgs = {
  first?: Scalars['Int']['input'];
  hasMatches?: InputMaybe<Scalars['Boolean']['input']>;
  hasPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  hrsSinceLastCall?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<QueryWaitlistsOrderRelationOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  relocation_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<QueryWaitlistsWhereWhereConditions>;
};


export type QueryWorkOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkOrderAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkOrderAssignmentPayoutArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkOrderAssignmentsArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryWorkOrderAssignmentsOrderByRelationOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pro_driver_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<WorkOrderAssignmentStatus>>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<QueryWorkOrderAssignmentsWhereWhereConditions>;
};


export type QueryWorkOrderJobOpeningArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkOrderJobOpeningOffersArgs = {
  city?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: Scalars['Int']['input'];
  job_opening_id?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<Array<QueryWorkOrderJobOpeningOffersOrderByOrderByClause>>;
  orderByStatus?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<WorkOrderJobOpeningOfferStatus>>;
};


export type QueryWorkOrderJobOpeningsArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryWorkOrderJobOpeningsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  work_order_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkOrderRegionalCountsArgs = {
  end: Scalars['DateTimeTz']['input'];
  start: Scalars['DateTimeTz']['input'];
};


export type QueryWorkOrderStatusCountArgs = {
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkOrdersArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryWorkOrdersOrderByRelationOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  relocation_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<WorkOrderStatus>>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<QueryWorkOrdersWhereWhereConditions>;
  whereAssignments?: InputMaybe<QueryWorkOrdersWhereAssignmentsWhereHasConditions>;
};

/** Allowed column names for Query.activityLogs.orderBy. */
export enum QueryActivityLogsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

/** Order by clause for Query.activityLogs.orderBy. */
export type QueryActivityLogsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryActivityLogsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.activityLogs.where. */
export enum QueryActivityLogsWhereColumn {
  Event = 'EVENT',
  SubjectId = 'SUBJECT_ID',
  SubjectType = 'SUBJECT_TYPE'
}

/** Dynamic WHERE conditions for the `where` argument of the query `activityLogs`. */
export type QueryActivityLogsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryActivityLogsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryActivityLogsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryActivityLogsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryActivityLogsWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `activityLogs`. */
export type QueryActivityLogsWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryActivityLogsWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryActivityLogsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryActivityLogsWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `activityLogs`. */
export type QueryActivityLogsWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryActivityLogsWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.allEmailEvents.orderBy. */
export enum QueryAllEmailEventsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

/** Order by clause for Query.allEmailEvents.orderBy. */
export type QueryAllEmailEventsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryAllEmailEventsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.allUsers.orderBy. */
export enum QueryAllUsersOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME'
}

/** Order by clause for Query.allUsers.orderBy. */
export type QueryAllUsersOrderByRelationOrderByClause = {
  /** The column that is used for ordering. */
  column?: InputMaybe<QueryAllUsersOrderByColumn>;
  /** The direction that is used for ordering. */
  order: SortOrder;
  /** Aggregate specification. */
  waitlists?: InputMaybe<QueryAllUsersOrderByWaitlists>;
};

/** Aggregate specification for Query.allUsers.orderBy.waitlists. */
export type QueryAllUsersOrderByWaitlists = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAllUsersOrderByWaitlistsColumn>;
};

/** Allowed column names for Query.allUsers.orderBy. */
export enum QueryAllUsersOrderByWaitlistsColumn {
  CreatedAt = 'CREATED_AT',
  LastSentAt = 'LAST_SENT_AT'
}

/** Allowed column names for Query.blocklists.orderBy. */
export enum QueryBlocklistsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL',
  Id = 'ID',
  Phone = 'PHONE'
}

/** Order by clause for Query.blocklists.orderBy. */
export type QueryBlocklistsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryBlocklistsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.blogPosts.orderBy. */
export enum QueryBlogPostsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  PublishedAt = 'PUBLISHED_AT',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

/** Order by clause for Query.blogPosts.orderBy. */
export type QueryBlogPostsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryBlogPostsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.bookingChangeRequests.where. */
export enum QueryBookingChangeRequestsWhereColumn {
  BookingId = 'BOOKING_ID',
  Status = 'STATUS'
}

/** Dynamic WHERE conditions for the `where` argument of the query `bookingChangeRequests`. */
export type QueryBookingChangeRequestsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryBookingChangeRequestsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryBookingChangeRequestsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryBookingChangeRequestsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryBookingChangeRequestsWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `bookingChangeRequests`. */
export type QueryBookingChangeRequestsWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryBookingChangeRequestsWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryBookingChangeRequestsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryBookingChangeRequestsWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `bookingChangeRequests`. */
export type QueryBookingChangeRequestsWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryBookingChangeRequestsWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.bookingPaymentRequests.where. */
export enum QueryBookingPaymentRequestsWhereColumn {
  BookingId = 'BOOKING_ID',
  Status = 'STATUS'
}

/** Dynamic WHERE conditions for the `where` argument of the query `bookingPaymentRequests`. */
export type QueryBookingPaymentRequestsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryBookingPaymentRequestsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryBookingPaymentRequestsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryBookingPaymentRequestsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryBookingPaymentRequestsWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `bookingPaymentRequests`. */
export type QueryBookingPaymentRequestsWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryBookingPaymentRequestsWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryBookingPaymentRequestsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryBookingPaymentRequestsWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `bookingPaymentRequests`. */
export type QueryBookingPaymentRequestsWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryBookingPaymentRequestsWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Aggregate specification for Query.bookings.orderBy.cancelledByActivity. */
export type QueryBookingsOrderByCancelledByActivity = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryBookingsOrderByCancelledByActivityColumn>;
};

/** Allowed column names for Query.bookings.orderBy. */
export enum QueryBookingsOrderByCancelledByActivityColumn {
  CreatedAt = 'CREATED_AT'
}

/** Allowed column names for Query.bookings.orderBy. */
export enum QueryBookingsOrderByColumn {
  ConfirmedAt = 'CONFIRMED_AT',
  CreatedAt = 'CREATED_AT',
  DateOfBirth = 'DATE_OF_BIRTH',
  DeliverAt = 'DELIVER_AT',
  DepartAt = 'DEPART_AT',
  DiscountedUnits = 'DISCOUNTED_UNITS',
  Email = 'EMAIL',
  FullPriceUnits = 'FULL_PRICE_UNITS',
  Id = 'ID',
  Name = 'NAME',
  Phone = 'PHONE',
  Reference = 'REFERENCE',
  Status = 'STATUS',
  SupplierReference = 'SUPPLIER_REFERENCE'
}

/** Aggregate specification for Query.bookings.orderBy.deliveryOffice. */
export type QueryBookingsOrderByDeliveryOffice = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryBookingsOrderByDeliveryOfficeColumn>;
};

/** Allowed column names for Query.bookings.orderBy. */
export enum QueryBookingsOrderByDeliveryOfficeColumn {
  Id = 'ID',
  Name = 'NAME'
}

/** Aggregate specification for Query.bookings.orderBy.departureOffice. */
export type QueryBookingsOrderByDepartureOffice = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryBookingsOrderByDepartureOfficeColumn>;
};

/** Allowed column names for Query.bookings.orderBy. */
export enum QueryBookingsOrderByDepartureOfficeColumn {
  Id = 'ID',
  Name = 'NAME'
}

/** Order by clause for Query.bookings.orderBy. */
export type QueryBookingsOrderByRelationOrderByClause = {
  /** Aggregate specification. */
  cancelledByActivity?: InputMaybe<QueryBookingsOrderByCancelledByActivity>;
  /** The column that is used for ordering. */
  column?: InputMaybe<QueryBookingsOrderByColumn>;
  /** Aggregate specification. */
  deliveryOffice?: InputMaybe<QueryBookingsOrderByDeliveryOffice>;
  /** Aggregate specification. */
  departureOffice?: InputMaybe<QueryBookingsOrderByDepartureOffice>;
  /** The direction that is used for ordering. */
  order: SortOrder;
  /** Aggregate specification. */
  relocation?: InputMaybe<QueryBookingsOrderByRelocation>;
};

/** Aggregate specification for Query.bookings.orderBy.relocation. */
export type QueryBookingsOrderByRelocation = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryBookingsOrderByRelocationColumn>;
};

/** Allowed column names for Query.bookings.orderBy. */
export enum QueryBookingsOrderByRelocationColumn {
  Id = 'ID'
}

/** Allowed column names for Query.bookings.where. */
export enum QueryBookingsWhereColumn {
  CreatedAt = 'CREATED_AT',
  DeliverAt = 'DELIVER_AT',
  DepartAt = 'DEPART_AT',
  Status = 'STATUS'
}

/** Allowed column names for Query.bookings.whereRelocation. */
export enum QueryBookingsWhereRelocationColumn {
  DeliveryOfficeId = 'DELIVERY_OFFICE_ID',
  DepartureOfficeId = 'DEPARTURE_OFFICE_ID',
  Id = 'ID',
  Reference = 'REFERENCE',
  Region = 'REGION',
  SupplierId = 'SUPPLIER_ID',
  VehicleId = 'VEHICLE_ID'
}

/** Dynamic WHERE conditions for the `whereRelocation` argument of the query `bookings`. */
export type QueryBookingsWhereRelocationWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryBookingsWhereRelocationWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryBookingsWhereRelocationWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryBookingsWhereRelocationWhereHasConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryBookingsWhereRelocationColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `whereRelocation` argument of the query `bookings`. */
export type QueryBookingsWhereRelocationWhereHasConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryBookingsWhereRelocationWhereHasConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryBookingsWhereRelocationWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryBookingsWhereRelocationWhereHasConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `whereRelocation` argument of the query `bookings`. */
export type QueryBookingsWhereRelocationWhereHasConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryBookingsWhereRelocationWhereHasConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Dynamic WHERE conditions for the `where` argument of the query `bookings`. */
export type QueryBookingsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryBookingsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryBookingsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryBookingsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryBookingsWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `bookings`. */
export type QueryBookingsWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryBookingsWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryBookingsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryBookingsWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `bookings`. */
export type QueryBookingsWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryBookingsWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Aggregate specification for Query.callbackLeads.orderBy.booking. */
export type QueryCallbackLeadsOrderByBooking = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryCallbackLeadsOrderByBookingColumn>;
};

/** Allowed column names for Query.callbackLeads.orderBy. */
export enum QueryCallbackLeadsOrderByBookingColumn {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

/** Aggregate specification for Query.callbackLeads.orderBy.bookings. */
export type QueryCallbackLeadsOrderByBookings = {
  /** Always COUNT. */
  aggregate: OrderByRelationAggregateFunction;
};

/** Allowed column names for Query.callbackLeads.orderBy. */
export enum QueryCallbackLeadsOrderByColumn {
  BecameCallableAt = 'BECAME_CALLABLE_AT',
  ContactAttempts = 'CONTACT_ATTEMPTS',
  CreatedAt = 'CREATED_AT',
  ExpiresAt = 'EXPIRES_AT',
  LastContactedAt = 'LAST_CONTACTED_AT',
  SnoozedUntil = 'SNOOZED_UNTIL',
  Status = 'STATUS'
}

/** Order by clause for Query.callbackLeads.orderBy. */
export type QueryCallbackLeadsOrderByRelationOrderByClause = {
  /** Aggregate specification. */
  booking?: InputMaybe<QueryCallbackLeadsOrderByBooking>;
  /** Aggregate specification. */
  bookings?: InputMaybe<QueryCallbackLeadsOrderByBookings>;
  /** The column that is used for ordering. */
  column?: InputMaybe<QueryCallbackLeadsOrderByColumn>;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.cities.orderBy. */
export enum QueryCitiesOrderByColumn {
  Id = 'ID',
  Name = 'NAME',
  Region = 'REGION',
  Slug = 'SLUG',
  State = 'STATE'
}

/** Order by clause for Query.cities.orderBy. */
export type QueryCitiesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryCitiesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.contactCredits.orderBy. */
export enum QueryContactCreditsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

/** Order by clause for Query.contactCredits.orderBy. */
export type QueryContactCreditsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryContactCreditsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.contacts.orderBy. */
export enum QueryContactsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

/** Order by clause for Query.contacts.orderBy. */
export type QueryContactsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryContactsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.contacts.where. */
export enum QueryContactsWhereColumn {
  Type = 'TYPE'
}

/** Dynamic WHERE conditions for the `where` argument of the query `contacts`. */
export type QueryContactsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryContactsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryContactsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryContactsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryContactsWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `contacts`. */
export type QueryContactsWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryContactsWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryContactsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryContactsWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `contacts`. */
export type QueryContactsWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryContactsWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.emailEvents.orderBy. */
export enum QueryEmailEventsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

/** Order by clause for Query.emailEvents.orderBy. */
export type QueryEmailEventsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryEmailEventsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.incidents.orderBy. */
export enum QueryIncidentsOrderByColumn {
  FoundAt = 'FOUND_AT',
  Reference = 'REFERENCE',
  Status = 'STATUS'
}

/** Order by clause for Query.incidents.orderBy. */
export type QueryIncidentsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryIncidentsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.integrationLinks.orderBy. */
export enum QueryIntegrationLinksOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

/** Order by clause for Query.integrationLinks.orderBy. */
export type QueryIntegrationLinksOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryIntegrationLinksOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.integrations.orderBy. */
export enum QueryIntegrationsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

/** Order by clause for Query.integrations.orderBy. */
export type QueryIntegrationsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryIntegrationsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.invoices.orderBy. */
export enum QueryInvoicesOrderByColumn {
  AmountIncTax = 'AMOUNT_INC_TAX',
  CreatedAt = 'CREATED_AT',
  Currency = 'CURRENCY',
  DueDate = 'DUE_DATE',
  Id = 'ID',
  InvoiceDate = 'INVOICE_DATE',
  Reference = 'REFERENCE',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT'
}

/** Order by clause for Query.invoices.orderBy. */
export type QueryInvoicesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryInvoicesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.invoices.where. */
export enum QueryInvoicesWhereColumn {
  AmountIncTax = 'AMOUNT_INC_TAX',
  CreatedAt = 'CREATED_AT',
  Currency = 'CURRENCY',
  DueDate = 'DUE_DATE',
  Id = 'ID',
  InvoiceDate = 'INVOICE_DATE',
  ManagedById = 'MANAGED_BY_ID',
  PayeeContactId = 'PAYEE_CONTACT_ID',
  QuoteId = 'QUOTE_ID',
  Reference = 'REFERENCE',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT'
}

/** Dynamic WHERE conditions for the `where` argument of the query `invoices`. */
export type QueryInvoicesWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryInvoicesWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryInvoicesWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryInvoicesWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryInvoicesWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `invoices`. */
export type QueryInvoicesWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryInvoicesWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryInvoicesWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryInvoicesWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `invoices`. */
export type QueryInvoicesWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryInvoicesWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.invoices.whereWorkOrder. */
export enum QueryInvoicesWhereWorkOrderColumn {
  Id = 'ID'
}

/** Dynamic WHERE conditions for the `whereWorkOrder` argument of the query `invoices`. */
export type QueryInvoicesWhereWorkOrderWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryInvoicesWhereWorkOrderWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryInvoicesWhereWorkOrderWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryInvoicesWhereWorkOrderWhereHasConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryInvoicesWhereWorkOrderColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `whereWorkOrder` argument of the query `invoices`. */
export type QueryInvoicesWhereWorkOrderWhereHasConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryInvoicesWhereWorkOrderWhereHasConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryInvoicesWhereWorkOrderWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryInvoicesWhereWorkOrderWhereHasConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `whereWorkOrder` argument of the query `invoices`. */
export type QueryInvoicesWhereWorkOrderWhereHasConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryInvoicesWhereWorkOrderWhereHasConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.organisations.orderBy. */
export enum QueryOrganisationsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  IsVerified = 'IS_VERIFIED',
  LastRelocationCreatedAt = 'LAST_RELOCATION_CREATED_AT',
  Name = 'NAME',
  SalesAgentName = 'SALES_AGENT_NAME',
  UpdatedAt = 'UPDATED_AT'
}

/** Order by clause for Query.organisations.orderBy. */
export type QueryOrganisationsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryOrganisationsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.payments.orderBy. */
export enum QueryPaymentsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT'
}

/** Order by clause for Query.payments.orderBy. */
export type QueryPaymentsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryPaymentsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.payments.where. */
export enum QueryPaymentsWhereColumn {
  Amount = 'AMOUNT',
  AttributedToId = 'ATTRIBUTED_TO_ID',
  AttributedToType = 'ATTRIBUTED_TO_TYPE',
  CreatedAt = 'CREATED_AT',
  Currency = 'CURRENCY',
  Id = 'ID',
  IsTaxIncluded = 'IS_TAX_INCLUDED',
  PayeeContactId = 'PAYEE_CONTACT_ID',
  Status = 'STATUS',
  TaxType = 'TAX_TYPE',
  Type = 'TYPE'
}

/** Dynamic WHERE conditions for the `where` argument of the query `payments`. */
export type QueryPaymentsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryPaymentsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryPaymentsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryPaymentsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryPaymentsWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `payments`. */
export type QueryPaymentsWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryPaymentsWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryPaymentsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryPaymentsWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `payments`. */
export type QueryPaymentsWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryPaymentsWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.popularTrips.orderBy. */
export enum QueryPopularTripsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Region = 'REGION'
}

/** Order by clause for Query.popularTrips.orderBy. */
export type QueryPopularTripsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryPopularTripsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.popularTrips.where. */
export enum QueryPopularTripsWhereColumn {
  AllowBookingRequests = 'ALLOW_BOOKING_REQUESTS',
  Region = 'REGION'
}

/** Dynamic WHERE conditions for the `where` argument of the query `popularTrips`. */
export type QueryPopularTripsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryPopularTripsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryPopularTripsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryPopularTripsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryPopularTripsWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `popularTrips`. */
export type QueryPopularTripsWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryPopularTripsWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryPopularTripsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryPopularTripsWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `popularTrips`. */
export type QueryPopularTripsWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryPopularTripsWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Aggregate specification for Query.proDrivers.orderBy.basedIn. */
export type QueryProDriversOrderByBasedIn = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryProDriversOrderByBasedInColumn>;
};

/** Allowed column names for Query.proDrivers.orderBy. */
export enum QueryProDriversOrderByBasedInColumn {
  Name = 'NAME'
}

/** Allowed column names for Query.proDrivers.orderBy. */
export enum QueryProDriversOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  LicenseType = 'LICENSE_TYPE',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

/** Order by clause for Query.proDrivers.orderBy. */
export type QueryProDriversOrderByRelationOrderByClause = {
  /** Aggregate specification. */
  basedIn?: InputMaybe<QueryProDriversOrderByBasedIn>;
  /** The column that is used for ordering. */
  column?: InputMaybe<QueryProDriversOrderByColumn>;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.promotionChannels.orderBy. */
export enum QueryPromotionChannelsOrderByColumn {
  Clicks = 'CLICKS',
  Conversions = 'CONVERSIONS',
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Impressions = 'IMPRESSIONS',
  SpendAmount = 'SPEND_AMOUNT'
}

/** Order by clause for Query.promotionChannels.orderBy. */
export type QueryPromotionChannelsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryPromotionChannelsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.promotionChannels.wherePromotion. */
export enum QueryPromotionChannelsWherePromotionColumn {
  RelocationId = 'RELOCATION_ID'
}

/** Dynamic WHERE conditions for the `wherePromotion` argument of the query `promotionChannels`. */
export type QueryPromotionChannelsWherePromotionWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryPromotionChannelsWherePromotionWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryPromotionChannelsWherePromotionWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryPromotionChannelsWherePromotionWhereHasConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryPromotionChannelsWherePromotionColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `wherePromotion` argument of the query `promotionChannels`. */
export type QueryPromotionChannelsWherePromotionWhereHasConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryPromotionChannelsWherePromotionWhereHasConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryPromotionChannelsWherePromotionWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryPromotionChannelsWherePromotionWhereHasConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `wherePromotion` argument of the query `promotionChannels`. */
export type QueryPromotionChannelsWherePromotionWhereHasConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryPromotionChannelsWherePromotionWhereHasConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.quotes.where. */
export enum QueryQuotesWhereColumn {
  Status = 'STATUS',
  SupplierId = 'SUPPLIER_ID'
}

/** Dynamic WHERE conditions for the `where` argument of the query `quotes`. */
export type QueryQuotesWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryQuotesWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryQuotesWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryQuotesWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryQuotesWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `quotes`. */
export type QueryQuotesWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryQuotesWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryQuotesWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryQuotesWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `quotes`. */
export type QueryQuotesWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryQuotesWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.quotes.whereWorkOrder. */
export enum QueryQuotesWhereWorkOrderColumn {
  Id = 'ID'
}

/** Dynamic WHERE conditions for the `whereWorkOrder` argument of the query `quotes`. */
export type QueryQuotesWhereWorkOrderWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryQuotesWhereWorkOrderWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryQuotesWhereWorkOrderWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryQuotesWhereWorkOrderWhereHasConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryQuotesWhereWorkOrderColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `whereWorkOrder` argument of the query `quotes`. */
export type QueryQuotesWhereWorkOrderWhereHasConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryQuotesWhereWorkOrderWhereHasConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryQuotesWhereWorkOrderWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryQuotesWhereWorkOrderWhereHasConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `whereWorkOrder` argument of the query `quotes`. */
export type QueryQuotesWhereWorkOrderWhereHasConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryQuotesWhereWorkOrderWhereHasConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.relocationGroups.where. */
export enum QueryRelocationGroupsWhereColumn {
  ExpiresAt = 'EXPIRES_AT',
  SupplierId = 'SUPPLIER_ID'
}

/** Dynamic WHERE conditions for the `where` argument of the query `relocationGroups`. */
export type QueryRelocationGroupsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationGroupsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationGroupsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationGroupsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryRelocationGroupsWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `relocationGroups`. */
export type QueryRelocationGroupsWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationGroupsWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationGroupsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationGroupsWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `relocationGroups`. */
export type QueryRelocationGroupsWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryRelocationGroupsWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.relocationHighlights.order. */
export enum QueryRelocationHighlightsOrderColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Order = 'ORDER'
}

/** Order by clause for Query.relocationHighlights.order. */
export type QueryRelocationHighlightsOrderOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryRelocationHighlightsOrderColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.relocationHighlights.where. */
export enum QueryRelocationHighlightsWhereColumn {
  Region = 'REGION'
}

/** Dynamic WHERE conditions for the `where` argument of the query `relocationHighlights`. */
export type QueryRelocationHighlightsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationHighlightsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationHighlightsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationHighlightsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryRelocationHighlightsWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `relocationHighlights`. */
export type QueryRelocationHighlightsWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationHighlightsWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationHighlightsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationHighlightsWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `relocationHighlights`. */
export type QueryRelocationHighlightsWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryRelocationHighlightsWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.relocationLines.orderBy. */
export enum QueryRelocationLinesOrderByColumn {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

/** Order by clause for Query.relocationLines.orderBy. */
export type QueryRelocationLinesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryRelocationLinesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.relocationLines.where. */
export enum QueryRelocationLinesWhereColumn {
  GroupId = 'GROUP_ID'
}

/** Allowed column names for Query.relocationLines.whereGroup. */
export enum QueryRelocationLinesWhereGroupColumn {
  ExpiresAt = 'EXPIRES_AT',
  SupplierId = 'SUPPLIER_ID'
}

/** Dynamic WHERE conditions for the `whereGroup` argument of the query `relocationLines`. */
export type QueryRelocationLinesWhereGroupWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationLinesWhereGroupWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationLinesWhereGroupWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationLinesWhereGroupWhereHasConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryRelocationLinesWhereGroupColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `whereGroup` argument of the query `relocationLines`. */
export type QueryRelocationLinesWhereGroupWhereHasConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationLinesWhereGroupWhereHasConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationLinesWhereGroupWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationLinesWhereGroupWhereHasConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `whereGroup` argument of the query `relocationLines`. */
export type QueryRelocationLinesWhereGroupWhereHasConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryRelocationLinesWhereGroupWhereHasConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Dynamic WHERE conditions for the `where` argument of the query `relocationLines`. */
export type QueryRelocationLinesWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationLinesWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationLinesWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationLinesWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryRelocationLinesWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `relocationLines`. */
export type QueryRelocationLinesWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationLinesWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationLinesWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationLinesWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `relocationLines`. */
export type QueryRelocationLinesWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryRelocationLinesWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.relocationPages.orderBy. */
export enum QueryRelocationPagesOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Slug = 'SLUG',
  Title = 'TITLE'
}

/** Order by clause for Query.relocationPages.orderBy. */
export type QueryRelocationPagesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryRelocationPagesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.relocationPromotions.orderBy. */
export enum QueryRelocationPromotionsOrderByColumn {
  BudgetAmount = 'BUDGET_AMOUNT',
  Clicks = 'CLICKS',
  Conversions = 'CONVERSIONS',
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Impressions = 'IMPRESSIONS',
  SpendAmount = 'SPEND_AMOUNT'
}

/** Order by clause for Query.relocationPromotions.orderBy. */
export type QueryRelocationPromotionsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryRelocationPromotionsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.relocations.orderBy. */
export enum QueryRelocationsOrderByColumn {
  AvailableFromDate = 'AVAILABLE_FROM_DATE',
  CreatedAt = 'CREATED_AT',
  DealScore = 'DEAL_SCORE',
  ExtraHireUnitRate = 'EXTRA_HIRE_UNIT_RATE',
  HireUnitRate = 'HIRE_UNIT_RATE',
  Id = 'ID',
  LatestDepartureDate = 'LATEST_DEPARTURE_DATE',
  Status = 'STATUS'
}

/** Aggregate specification for Query.relocations.orderBy.deliveryCity. */
export type QueryRelocationsOrderByDeliveryCity = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryRelocationsOrderByDeliveryCityColumn>;
};

/** Allowed column names for Query.relocations.orderBy. */
export enum QueryRelocationsOrderByDeliveryCityColumn {
  Name = 'NAME'
}

/** Aggregate specification for Query.relocations.orderBy.departureCity. */
export type QueryRelocationsOrderByDepartureCity = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryRelocationsOrderByDepartureCityColumn>;
};

/** Allowed column names for Query.relocations.orderBy. */
export enum QueryRelocationsOrderByDepartureCityColumn {
  Name = 'NAME'
}

/** Aggregate specification for Query.relocations.orderBy.inclusions. */
export type QueryRelocationsOrderByInclusions = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryRelocationsOrderByInclusionsColumn>;
};

/** Allowed column names for Query.relocations.orderBy. */
export enum QueryRelocationsOrderByInclusionsColumn {
  Value = 'VALUE'
}

/** Order by clause for Query.relocations.orderBy. */
export type QueryRelocationsOrderByRelationOrderByClause = {
  /** The column that is used for ordering. */
  column?: InputMaybe<QueryRelocationsOrderByColumn>;
  /** Aggregate specification. */
  deliveryCity?: InputMaybe<QueryRelocationsOrderByDeliveryCity>;
  /** Aggregate specification. */
  departureCity?: InputMaybe<QueryRelocationsOrderByDepartureCity>;
  /** Aggregate specification. */
  inclusions?: InputMaybe<QueryRelocationsOrderByInclusions>;
  /** The direction that is used for ordering. */
  order: SortOrder;
  /** Aggregate specification. */
  vehicle?: InputMaybe<QueryRelocationsOrderByVehicle>;
};

/** Aggregate specification for Query.relocations.orderBy.vehicle. */
export type QueryRelocationsOrderByVehicle = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryRelocationsOrderByVehicleColumn>;
};

/** Allowed column names for Query.relocations.orderBy. */
export enum QueryRelocationsOrderByVehicleColumn {
  Name = 'NAME'
}

/** Allowed column names for Query.relocations.where. */
export enum QueryRelocationsWhereColumn {
  AvailableFromDate = 'AVAILABLE_FROM_DATE',
  AvailableToDate = 'AVAILABLE_TO_DATE',
  DeliveryCityId = 'DELIVERY_CITY_ID',
  DeliveryOfficeId = 'DELIVERY_OFFICE_ID',
  DepartureCityId = 'DEPARTURE_CITY_ID',
  DepartureOfficeId = 'DEPARTURE_OFFICE_ID',
  GroupId = 'GROUP_ID',
  Id = 'ID',
  LatestDepartureDate = 'LATEST_DEPARTURE_DATE',
  Status = 'STATUS'
}

/** Allowed column names for Query.relocations.whereDeliveryCity. */
export enum QueryRelocationsWhereDeliveryCityColumn {
  Id = 'ID',
  Slug = 'SLUG',
  State = 'STATE'
}

/** Dynamic WHERE conditions for the `whereDeliveryCity` argument of the query `relocations`. */
export type QueryRelocationsWhereDeliveryCityWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationsWhereDeliveryCityWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationsWhereDeliveryCityWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationsWhereDeliveryCityWhereHasConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryRelocationsWhereDeliveryCityColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `whereDeliveryCity` argument of the query `relocations`. */
export type QueryRelocationsWhereDeliveryCityWhereHasConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationsWhereDeliveryCityWhereHasConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationsWhereDeliveryCityWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationsWhereDeliveryCityWhereHasConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `whereDeliveryCity` argument of the query `relocations`. */
export type QueryRelocationsWhereDeliveryCityWhereHasConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryRelocationsWhereDeliveryCityWhereHasConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.relocations.whereDepartureCity. */
export enum QueryRelocationsWhereDepartureCityColumn {
  Id = 'ID',
  Slug = 'SLUG',
  State = 'STATE'
}

/** Dynamic WHERE conditions for the `whereDepartureCity` argument of the query `relocations`. */
export type QueryRelocationsWhereDepartureCityWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationsWhereDepartureCityWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationsWhereDepartureCityWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationsWhereDepartureCityWhereHasConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryRelocationsWhereDepartureCityColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `whereDepartureCity` argument of the query `relocations`. */
export type QueryRelocationsWhereDepartureCityWhereHasConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationsWhereDepartureCityWhereHasConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationsWhereDepartureCityWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationsWhereDepartureCityWhereHasConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `whereDepartureCity` argument of the query `relocations`. */
export type QueryRelocationsWhereDepartureCityWhereHasConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryRelocationsWhereDepartureCityWhereHasConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.relocations.whereSupplier. */
export enum QueryRelocationsWhereSupplierColumn {
  Id = 'ID'
}

/** Dynamic WHERE conditions for the `whereSupplier` argument of the query `relocations`. */
export type QueryRelocationsWhereSupplierWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationsWhereSupplierWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationsWhereSupplierWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationsWhereSupplierWhereHasConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryRelocationsWhereSupplierColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `whereSupplier` argument of the query `relocations`. */
export type QueryRelocationsWhereSupplierWhereHasConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationsWhereSupplierWhereHasConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationsWhereSupplierWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationsWhereSupplierWhereHasConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `whereSupplier` argument of the query `relocations`. */
export type QueryRelocationsWhereSupplierWhereHasConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryRelocationsWhereSupplierWhereHasConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.relocations.whereVehicle. */
export enum QueryRelocationsWhereVehicleColumn {
  MaximumAge = 'MAXIMUM_AGE',
  MinimumAge = 'MINIMUM_AGE',
  Seatbelts = 'SEATBELTS',
  Type = 'TYPE'
}

/** Dynamic WHERE conditions for the `whereVehicle` argument of the query `relocations`. */
export type QueryRelocationsWhereVehicleWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationsWhereVehicleWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationsWhereVehicleWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationsWhereVehicleWhereHasConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryRelocationsWhereVehicleColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `whereVehicle` argument of the query `relocations`. */
export type QueryRelocationsWhereVehicleWhereHasConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationsWhereVehicleWhereHasConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationsWhereVehicleWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationsWhereVehicleWhereHasConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `whereVehicle` argument of the query `relocations`. */
export type QueryRelocationsWhereVehicleWhereHasConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryRelocationsWhereVehicleWhereHasConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Dynamic WHERE conditions for the `where` argument of the query `relocations`. */
export type QueryRelocationsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryRelocationsWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `relocations`. */
export type QueryRelocationsWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryRelocationsWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryRelocationsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryRelocationsWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `relocations`. */
export type QueryRelocationsWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryRelocationsWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.supplierAdminContacts.orderBy. */
export enum QuerySupplierAdminContactsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

/** Order by clause for Query.supplierAdminContacts.orderBy. */
export type QuerySupplierAdminContactsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QuerySupplierAdminContactsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.supplierInsuranceOptions.orderBy. */
export enum QuerySupplierInsuranceOptionsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

/** Order by clause for Query.supplierInsuranceOptions.orderBy. */
export type QuerySupplierInsuranceOptionsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QuerySupplierInsuranceOptionsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate specification for Query.supplierOffices.orderBy.city. */
export type QuerySupplierOfficesOrderByCity = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QuerySupplierOfficesOrderByCityColumn>;
};

/** Allowed column names for Query.supplierOffices.orderBy. */
export enum QuerySupplierOfficesOrderByCityColumn {
  Name = 'NAME'
}

/** Allowed column names for Query.supplierOffices.orderBy. */
export enum QuerySupplierOfficesOrderByColumn {
  Code = 'CODE',
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

/** Order by clause for Query.supplierOffices.orderBy. */
export type QuerySupplierOfficesOrderByRelationOrderByClause = {
  /** Aggregate specification. */
  city?: InputMaybe<QuerySupplierOfficesOrderByCity>;
  /** The column that is used for ordering. */
  column?: InputMaybe<QuerySupplierOfficesOrderByColumn>;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.supplierTrips.orderBy. */
export enum QuerySupplierTripsOrderByColumn {
  DistanceAllowed = 'DISTANCE_ALLOWED',
  HireUnitsAllowed = 'HIRE_UNITS_ALLOWED'
}

/** Order by clause for Query.supplierTrips.orderBy. */
export type QuerySupplierTripsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QuerySupplierTripsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.supplierTrips.where. */
export enum QuerySupplierTripsWhereColumn {
  OfficeAId = 'OFFICE_A_ID',
  OfficeBId = 'OFFICE_B_ID',
  SupplierId = 'SUPPLIER_ID'
}

/** Dynamic WHERE conditions for the `where` argument of the query `supplierTrips`. */
export type QuerySupplierTripsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QuerySupplierTripsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QuerySupplierTripsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QuerySupplierTripsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QuerySupplierTripsWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `supplierTrips`. */
export type QuerySupplierTripsWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QuerySupplierTripsWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QuerySupplierTripsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QuerySupplierTripsWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `supplierTrips`. */
export type QuerySupplierTripsWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QuerySupplierTripsWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.suppliers.orderBy. */
export enum QuerySuppliersOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME'
}

/** Order by clause for Query.suppliers.orderBy. */
export type QuerySuppliersOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QuerySuppliersOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.tasks.orderBy. */
export enum QueryTasksOrderByColumn {
  CreatedAt = 'CREATED_AT',
  DueAt = 'DUE_AT',
  Status = 'STATUS'
}

/** Order by clause for Query.tasks.orderBy. */
export type QueryTasksOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryTasksOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.tasks.where. */
export enum QueryTasksWhereColumn {
  RelatedToId = 'RELATED_TO_ID',
  RelatedToType = 'RELATED_TO_TYPE',
  Status = 'STATUS',
  Type = 'TYPE'
}

/** Dynamic WHERE conditions for the `where` argument of the query `tasks`. */
export type QueryTasksWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryTasksWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryTasksWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryTasksWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryTasksWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `tasks`. */
export type QueryTasksWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryTasksWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryTasksWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryTasksWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `tasks`. */
export type QueryTasksWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryTasksWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.threadMessages.orderBy. */
export enum QueryThreadMessagesOrderByColumn {
  CreatedAt = 'CREATED_AT'
}

/** Order by clause for Query.threadMessages.orderBy. */
export type QueryThreadMessagesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryThreadMessagesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate specification for Query.trips.order.cityA. */
export type QueryTripsOrderCityA = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryTripsOrderCityAColumn>;
};

/** Allowed column names for Query.trips.order. */
export enum QueryTripsOrderCityAColumn {
  Name = 'NAME'
}

/** Aggregate specification for Query.trips.order.cityB. */
export type QueryTripsOrderCityB = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryTripsOrderCityBColumn>;
};

/** Allowed column names for Query.trips.order. */
export enum QueryTripsOrderCityBColumn {
  Name = 'NAME'
}

/** Order by clause for Query.trips.order. */
export type QueryTripsOrderRelationOrderByClause = {
  /** Aggregate specification. */
  cityA?: InputMaybe<QueryTripsOrderCityA>;
  /** Aggregate specification. */
  cityB?: InputMaybe<QueryTripsOrderCityB>;
  /** The column that is used for ordering. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.users.orderBy. */
export enum QueryUsersOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME'
}

/** Order by clause for Query.users.orderBy. */
export type QueryUsersOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryUsersOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.vehicles.orderBy. */
export enum QueryVehiclesOrderByColumn {
  Code = 'CODE',
  CreatedAt = 'CREATED_AT',
  ExtraHireUnitRate = 'EXTRA_HIRE_UNIT_RATE',
  HireUnitType = 'HIRE_UNIT_TYPE',
  Id = 'ID',
  Name = 'NAME',
  Transmission = 'TRANSMISSION',
  Type = 'TYPE'
}

/** Order by clause for Query.vehicles.orderBy. */
export type QueryVehiclesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryVehiclesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.waitlists.order. */
export enum QueryWaitlistsOrderColumn {
  CreatedAt = 'CREATED_AT',
  EarliestDepartureDate = 'EARLIEST_DEPARTURE_DATE'
}

/** Order by clause for Query.waitlists.order. */
export type QueryWaitlistsOrderRelationOrderByClause = {
  /** The column that is used for ordering. */
  column?: InputMaybe<QueryWaitlistsOrderColumn>;
  /** The direction that is used for ordering. */
  order: SortOrder;
  /** Aggregate specification. */
  user?: InputMaybe<QueryWaitlistsOrderUser>;
};

/** Aggregate specification for Query.waitlists.order.user. */
export type QueryWaitlistsOrderUser = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryWaitlistsOrderUserColumn>;
};

/** Allowed column names for Query.waitlists.order. */
export enum QueryWaitlistsOrderUserColumn {
  Name = 'NAME'
}

/** Allowed column names for Query.waitlists.where. */
export enum QueryWaitlistsWhereColumn {
  DeliveryCityId = 'DELIVERY_CITY_ID',
  DepartureCityId = 'DEPARTURE_CITY_ID',
  EarliestDepartureDate = 'EARLIEST_DEPARTURE_DATE',
  LatestDepartureDate = 'LATEST_DEPARTURE_DATE',
  UserId = 'USER_ID'
}

/** Dynamic WHERE conditions for the `where` argument of the query `waitlists`. */
export type QueryWaitlistsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryWaitlistsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryWaitlistsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryWaitlistsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryWaitlistsWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `waitlists`. */
export type QueryWaitlistsWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryWaitlistsWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryWaitlistsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryWaitlistsWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `waitlists`. */
export type QueryWaitlistsWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryWaitlistsWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.workOrderAssignments.orderBy. */
export enum QueryWorkOrderAssignmentsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  DeliveryDate = 'DELIVERY_DATE',
  Id = 'ID',
  PickupDate = 'PICKUP_DATE',
  Status = 'STATUS'
}

/** Aggregate specification for Query.workOrderAssignments.orderBy.deliveryAddress. */
export type QueryWorkOrderAssignmentsOrderByDeliveryAddress = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryWorkOrderAssignmentsOrderByDeliveryAddressColumn>;
};

/** Allowed column names for Query.workOrderAssignments.orderBy. */
export enum QueryWorkOrderAssignmentsOrderByDeliveryAddressColumn {
  City = 'CITY',
  Id = 'ID'
}

/** Aggregate specification for Query.workOrderAssignments.orderBy.departureAddress. */
export type QueryWorkOrderAssignmentsOrderByDepartureAddress = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryWorkOrderAssignmentsOrderByDepartureAddressColumn>;
};

/** Allowed column names for Query.workOrderAssignments.orderBy. */
export enum QueryWorkOrderAssignmentsOrderByDepartureAddressColumn {
  City = 'CITY',
  Id = 'ID'
}

/** Aggregate specification for Query.workOrderAssignments.orderBy.proDriver. */
export type QueryWorkOrderAssignmentsOrderByProDriver = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryWorkOrderAssignmentsOrderByProDriverColumn>;
};

/** Allowed column names for Query.workOrderAssignments.orderBy. */
export enum QueryWorkOrderAssignmentsOrderByProDriverColumn {
  Id = 'ID',
  Name = 'NAME'
}

/** Order by clause for Query.workOrderAssignments.orderBy. */
export type QueryWorkOrderAssignmentsOrderByRelationOrderByClause = {
  /** The column that is used for ordering. */
  column?: InputMaybe<QueryWorkOrderAssignmentsOrderByColumn>;
  /** Aggregate specification. */
  deliveryAddress?: InputMaybe<QueryWorkOrderAssignmentsOrderByDeliveryAddress>;
  /** Aggregate specification. */
  departureAddress?: InputMaybe<QueryWorkOrderAssignmentsOrderByDepartureAddress>;
  /** The direction that is used for ordering. */
  order: SortOrder;
  /** Aggregate specification. */
  proDriver?: InputMaybe<QueryWorkOrderAssignmentsOrderByProDriver>;
  /** Aggregate specification. */
  supplier?: InputMaybe<QueryWorkOrderAssignmentsOrderBySupplier>;
  /** Aggregate specification. */
  workOrder?: InputMaybe<QueryWorkOrderAssignmentsOrderByWorkOrder>;
};

/** Aggregate specification for Query.workOrderAssignments.orderBy.supplier. */
export type QueryWorkOrderAssignmentsOrderBySupplier = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryWorkOrderAssignmentsOrderBySupplierColumn>;
};

/** Allowed column names for Query.workOrderAssignments.orderBy. */
export enum QueryWorkOrderAssignmentsOrderBySupplierColumn {
  Id = 'ID',
  Name = 'NAME'
}

/** Aggregate specification for Query.workOrderAssignments.orderBy.workOrder. */
export type QueryWorkOrderAssignmentsOrderByWorkOrder = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryWorkOrderAssignmentsOrderByWorkOrderColumn>;
};

/** Allowed column names for Query.workOrderAssignments.orderBy. */
export enum QueryWorkOrderAssignmentsOrderByWorkOrderColumn {
  Id = 'ID',
  Reference = 'REFERENCE',
  Status = 'STATUS'
}

/** Allowed column names for Query.workOrderAssignments.where. */
export enum QueryWorkOrderAssignmentsWhereColumn {
  DeliveryDate = 'DELIVERY_DATE',
  Id = 'ID',
  PickupDate = 'PICKUP_DATE',
  Status = 'STATUS'
}

/** Dynamic WHERE conditions for the `where` argument of the query `workOrderAssignments`. */
export type QueryWorkOrderAssignmentsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryWorkOrderAssignmentsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryWorkOrderAssignmentsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryWorkOrderAssignmentsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryWorkOrderAssignmentsWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `workOrderAssignments`. */
export type QueryWorkOrderAssignmentsWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryWorkOrderAssignmentsWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryWorkOrderAssignmentsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryWorkOrderAssignmentsWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `workOrderAssignments`. */
export type QueryWorkOrderAssignmentsWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryWorkOrderAssignmentsWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.workOrderJobOpeningOffers.orderBy. */
export enum QueryWorkOrderJobOpeningOffersOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  LicenseType = 'LICENSE_TYPE',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

/** Order by clause for Query.workOrderJobOpeningOffers.orderBy. */
export type QueryWorkOrderJobOpeningOffersOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryWorkOrderJobOpeningOffersOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.workOrderJobOpenings.orderBy. */
export enum QueryWorkOrderJobOpeningsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

/** Order by clause for Query.workOrderJobOpenings.orderBy. */
export type QueryWorkOrderJobOpeningsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryWorkOrderJobOpeningsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.workOrders.orderBy. */
export enum QueryWorkOrdersOrderByColumn {
  CreatedAt = 'CREATED_AT',
  DeliverBefore = 'DELIVER_BEFORE',
  DepartAfter = 'DEPART_AFTER',
  Id = 'ID',
  Reference = 'REFERENCE',
  Status = 'STATUS',
  VehicleType = 'VEHICLE_TYPE'
}

/** Aggregate specification for Query.workOrders.orderBy.deliveryAddress. */
export type QueryWorkOrdersOrderByDeliveryAddress = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryWorkOrdersOrderByDeliveryAddressColumn>;
};

/** Allowed column names for Query.workOrders.orderBy. */
export enum QueryWorkOrdersOrderByDeliveryAddressColumn {
  City = 'CITY',
  Id = 'ID'
}

/** Aggregate specification for Query.workOrders.orderBy.departureAddress. */
export type QueryWorkOrdersOrderByDepartureAddress = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryWorkOrdersOrderByDepartureAddressColumn>;
};

/** Allowed column names for Query.workOrders.orderBy. */
export enum QueryWorkOrdersOrderByDepartureAddressColumn {
  City = 'CITY',
  Id = 'ID'
}

/** Order by clause for Query.workOrders.orderBy. */
export type QueryWorkOrdersOrderByRelationOrderByClause = {
  /** The column that is used for ordering. */
  column?: InputMaybe<QueryWorkOrdersOrderByColumn>;
  /** Aggregate specification. */
  deliveryAddress?: InputMaybe<QueryWorkOrdersOrderByDeliveryAddress>;
  /** Aggregate specification. */
  departureAddress?: InputMaybe<QueryWorkOrdersOrderByDepartureAddress>;
  /** The direction that is used for ordering. */
  order: SortOrder;
  /** Aggregate specification. */
  supplier?: InputMaybe<QueryWorkOrdersOrderBySupplier>;
};

/** Aggregate specification for Query.workOrders.orderBy.supplier. */
export type QueryWorkOrdersOrderBySupplier = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryWorkOrdersOrderBySupplierColumn>;
};

/** Allowed column names for Query.workOrders.orderBy. */
export enum QueryWorkOrdersOrderBySupplierColumn {
  Id = 'ID',
  Name = 'NAME'
}

/** Allowed column names for Query.workOrders.whereAssignments. */
export enum QueryWorkOrdersWhereAssignmentsColumn {
  ProDriverId = 'PRO_DRIVER_ID'
}

/** Dynamic WHERE conditions for the `whereAssignments` argument of the query `workOrders`. */
export type QueryWorkOrdersWhereAssignmentsWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryWorkOrdersWhereAssignmentsWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryWorkOrdersWhereAssignmentsWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryWorkOrdersWhereAssignmentsWhereHasConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryWorkOrdersWhereAssignmentsColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `whereAssignments` argument of the query `workOrders`. */
export type QueryWorkOrdersWhereAssignmentsWhereHasConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryWorkOrdersWhereAssignmentsWhereHasConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryWorkOrdersWhereAssignmentsWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryWorkOrdersWhereAssignmentsWhereHasConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `whereAssignments` argument of the query `workOrders`. */
export type QueryWorkOrdersWhereAssignmentsWhereHasConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryWorkOrdersWhereAssignmentsWhereHasConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.workOrders.where. */
export enum QueryWorkOrdersWhereColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Reference = 'REFERENCE',
  Status = 'STATUS',
  VehicleType = 'VEHICLE_TYPE'
}

/** Dynamic WHERE conditions for the `where` argument of the query `workOrders`. */
export type QueryWorkOrdersWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryWorkOrdersWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryWorkOrdersWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryWorkOrdersWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryWorkOrdersWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `workOrders`. */
export type QueryWorkOrdersWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryWorkOrdersWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryWorkOrdersWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryWorkOrdersWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `workOrders`. */
export type QueryWorkOrdersWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryWorkOrdersWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

export type Quote = {
  additional_notations?: Maybe<Scalars['String']['output']>;
  admin_url: Scalars['String']['output'];
  amount_exc_tax: Scalars['Int']['output'];
  amount_inc_tax: Scalars['Int']['output'];
  amount_tax: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  declined_reason?: Maybe<QuoteDeclinedReason>;
  declined_reason_description?: Maybe<Scalars['String']['output']>;
  expiry_date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoice?: Maybe<Invoice>;
  lineItems: Array<QuoteLineItem>;
  organisation_url: Scalars['String']['output'];
  payee: Contact;
  pdf_url: Scalars['String']['output'];
  purchase_order_number?: Maybe<Scalars['String']['output']>;
  quote_date: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: QuoteStatus;
  tax_inclusion_type: TaxInclusionType;
  updated_at: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  workOrder?: Maybe<WorkOrder>;
  workOrders?: Maybe<Array<WorkOrder>>;
};

export enum QuoteDeclinedReason {
  FoundAlternative = 'FOUND_ALTERNATIVE',
  NoLongerNeeded = 'NO_LONGER_NEEDED',
  Other = 'OTHER',
  PriceTooHigh = 'PRICE_TOO_HIGH'
}

export type QuoteLineItem = {
  amount: Scalars['Int']['output'];
  amount_exc_tax: Scalars['Int']['output'];
  amount_inc_tax: Scalars['Int']['output'];
  amount_tax: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  quantity: Scalars['Float']['output'];
  tax_type: TaxType;
  unit_amount: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type QuoteLineItemUpsertInput = {
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  upsert?: InputMaybe<Array<UpsertQuoteLineItemInput>>;
};

/** A paginated list of Quote items. */
export type QuotePaginator = {
  /** A list of Quote items. */
  data: Array<Quote>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum QuoteStatus {
  Accepted = 'ACCEPTED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Invoiced = 'INVOICED',
  Issued = 'ISSUED',
  Rejected = 'REJECTED',
  Voided = 'VOIDED'
}

export type QuoteStatusStat = {
  count: Scalars['Int']['output'];
  status: QuoteStatus;
};

export type RadiusAround = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  radius: Scalars['Int']['input'];
};

export type Receipt = {
  amount_inc_tax: Scalars['Int']['output'];
  amount_tax: Scalars['Int']['output'];
  claimable_amount_exc_tax: Scalars['Int']['output'];
  claimable_amount_inc_tax: Scalars['Int']['output'];
  claimable_amount_tax: Scalars['Int']['output'];
  claimable_converted_amount_exc_tax?: Maybe<Scalars['Int']['output']>;
  claimable_converted_amount_inc_tax?: Maybe<Scalars['Int']['output']>;
  claimable_converted_amount_tax?: Maybe<Scalars['Int']['output']>;
  claimable_percentage: Scalars['Float']['output'];
  converted_currency?: Maybe<Currency>;
  currency: Currency;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Media>;
  type: ReceiptType;
};

export type ReceiptAnalysis = {
  amount_inc_tax?: Maybe<Scalars['Int']['output']>;
  amount_tax?: Maybe<Scalars['Int']['output']>;
  claimable_amount_inc_tax?: Maybe<Scalars['Int']['output']>;
  claimable_amount_tax?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  filePath: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  is_claimable: Scalars['Boolean']['output'];
  type?: Maybe<ReceiptType>;
};

export enum ReceiptType {
  Accommodation = 'ACCOMMODATION',
  Ferry = 'FERRY',
  Flight = 'FLIGHT',
  Fuel = 'FUEL',
  Other = 'OTHER',
  Toll = 'TOLL',
  Transportation = 'TRANSPORTATION'
}

export type ReceivablesReconciliationItem = {
  amount_due: Scalars['Int']['output'];
  contact_id: Scalars['ID']['output'];
  contact_name: Scalars['String']['output'];
  currency: Currency;
  total_credits: Scalars['Int']['output'];
  total_invoiced: Scalars['Int']['output'];
  total_payments: Scalars['Int']['output'];
  total_refunds: Scalars['Int']['output'];
};

export type ReceivablesReconciliationSummary = {
  account_count: Scalars['Int']['output'];
  currency: Currency;
  total_amount_due: Scalars['Int']['output'];
  total_credits: Scalars['Int']['output'];
  total_invoiced: Scalars['Int']['output'];
  total_payments: Scalars['Int']['output'];
  total_refunds: Scalars['Int']['output'];
};

export type RecordLocationsInput = {
  locations: Array<LocationPointInput>;
  workOrderAssignmentId: Scalars['ID']['input'];
};

export type Refund = {
  bank_account_name?: Maybe<Scalars['String']['output']>;
  bank_account_number?: Maybe<Scalars['String']['output']>;
  bank_country?: Maybe<Scalars['String']['output']>;
  bank_identifier_code?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  booking_deliver_at?: Maybe<Scalars['DateTime']['output']>;
  booking_depart_at?: Maybe<Scalars['DateTime']['output']>;
  currency: Currency;
  id: Scalars['ID']['output'];
  maximum_refund_amount?: Maybe<Scalars['Int']['output']>;
  object_id: Scalars['ID']['output'];
  object_type: Scalars['String']['output'];
  payments: Array<RefundPayment>;
  permalink: Scalars['String']['output'];
  receipts: Array<Receipt>;
  recipient_address?: Maybe<Scalars['String']['output']>;
  refund_amount: Scalars['Int']['output'];
  status: RefundStatus;
  supplierPayments: Array<Payment>;
  type: RefundType;
  uuid: Scalars['String']['output'];
};

export type RefundPayment = {
  amount: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  method: RefundPaymentMethod;
  refund_form_id: Scalars['ID']['output'];
  refunded_at?: Maybe<Scalars['String']['output']>;
  transaction_number?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export enum RefundPaymentMethod {
  DirectDeposit = 'DIRECT_DEPOSIT',
  Paypal = 'PAYPAL'
}

export enum RefundStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED'
}

export enum RefundType {
  Ferry = 'FERRY',
  Fuel = 'FUEL'
}

export enum Region {
  Au = 'AU',
  Ca = 'CA',
  Eu = 'EU',
  Jp = 'JP',
  Kr = 'KR',
  Me = 'ME',
  Mx = 'MX',
  Nz = 'NZ',
  Pi = 'PI',
  Sa = 'SA',
  Sacu = 'SACU',
  Tw = 'TW',
  Us = 'US'
}

export type Relocation = {
  acknowledgements: Array<RelocationAcknowledgement>;
  admin_url: Scalars['String']['output'];
  available_from_date: Scalars['String']['output'];
  available_to_date: Scalars['String']['output'];
  blogPostTripArticles: Array<BlogPostTripArticle>;
  bookedBookingsCount?: Maybe<Scalars['Int']['output']>;
  /** Active bookings against the group */
  booked_count?: Maybe<Scalars['Int']['output']>;
  booking_fee_amount: Scalars['Int']['output'];
  charge_per_move_amount: Scalars['Int']['output'];
  /** Remaining availability (quantity - booked_count) */
  count: Scalars['Int']['output'];
  createdBy?: Maybe<User>;
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  /** @deprecated Use customer_url */
  customer_link: Scalars['String']['output'];
  customer_url: Scalars['String']['output'];
  /** @deprecated Table removed; always returns empty. Kept for old mobile clients. REMOVE once they are gone. */
  datoArticles: Array<DatoTripArticle>;
  /** The agent's full answer, in the shape the admin answer renderer parses. */
  deal_rated_at?: Maybe<Scalars['DateTime']['output']>;
  /** The deal analysis agent's score out of 10, null until the first run lands. */
  deal_score?: Maybe<Scalars['Int']['output']>;
  deal_slug: Scalars['String']['output'];
  deliveryCity: City;
  deliveryOffice: SupplierOffice;
  departureCity: City;
  departureOffice: SupplierOffice;
  departure_dates: Array<OpeningHours>;
  discount_percent?: Maybe<Scalars['Int']['output']>;
  distance_allowed?: Maybe<Scalars['Int']['output']>;
  earliest_departure_date: Scalars['String']['output'];
  excess_distance_rate?: Maybe<Scalars['Int']['output']>;
  extra_distance_allowed_per_extra_hire_unit?: Maybe<Scalars['Int']['output']>;
  extra_hire_unit_deposit_rate?: Maybe<Scalars['Int']['output']>;
  extra_hire_unit_rate?: Maybe<Scalars['Int']['output']>;
  extra_hire_unit_supplier_net_rate?: Maybe<Scalars['Int']['output']>;
  extra_hire_units_allowed: Scalars['Int']['output'];
  ferryInclusion?: Maybe<RelocationInclusion>;
  fixed_latest_departure_date?: Maybe<Scalars['String']['output']>;
  fuelInclusion?: Maybe<RelocationInclusion>;
  group: RelocationGroup;
  hire_unit_rate: Scalars['Int']['output'];
  hire_unit_type: HireUnitType;
  hire_units_allowed: Scalars['Int']['output'];
  holding_deposit_amount: Scalars['Int']['output'];
  holding_deposit_refunded_at: DepositRefundedAt;
  holding_deposit_refunded_by: HoldingDepositRefundedBy;
  id: Scalars['ID']['output'];
  /** limit caps the number of images returned (by display priority). */
  images: Array<Media>;
  inclusions: Array<RelocationInclusion>;
  is_ferry_required?: Maybe<Scalars['Boolean']['output']>;
  is_linked: Scalars['Boolean']['output'];
  latest_departure_date: Scalars['String']['output'];
  /** @deprecated REMOVE with mobile v5.1.4 is live */
  line: RelocationGroup;
  lines: Array<RelocationLine>;
  linkedRelocationCount: Scalars['Int']['output'];
  measurement: Measurement;
  minimum_hire_units: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  ogImage?: Maybe<Media>;
  open_delivery_dates?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Dates the supplier opens for this deal even though the office or supplier is
   * normally closed then. The office's usual hours apply on the day.
   */
  open_departure_dates?: Maybe<Array<Scalars['String']['output']>>;
  organisation_url: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  promotion?: Maybe<RelocationPromotion>;
  /** The vehicle's purchasable extras enabled for this relocation's type */
  purchasableExtras: Array<SupplierPurchasableExtra>;
  /** Constant fleet size for the listing */
  quantity?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['String']['output'];
  rental_units: RelocationRentalUnits;
  retail_rate?: Maybe<Scalars['Int']['output']>;
  /** Standard inclusions for this relocation's type; gap rentals use only the supplier's gap rental inclusions. */
  standard_inclusions?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<RelocationStats>;
  status: RelocationStatus;
  supplier: Supplier;
  supplierInsuranceOption: SupplierInsuranceOption;
  /** Supplier terms PDF for this relocation's type; gap rentals use only the supplier's gap rental terms. */
  supplier_terms_pdf_url?: Maybe<Scalars['String']['output']>;
  trip?: Maybe<Trip>;
  type: RelocationType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  vehicle: Vehicle;
  workOrders: Array<WorkOrder>;
  workOrdersCount?: Maybe<Scalars['Int']['output']>;
};


export type RelocationImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type RelocationAcknowledgement = {
  acknowledgement: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type RelocationAcknowledgementInput = {
  acknowledgement: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type RelocationByRegionCount = {
  count: Scalars['Int']['output'];
  region: Region;
};

export type RelocationCost = {
  additional_charges: Array<RelocationInclusion>;
  discounted_units: Scalars['Int']['output'];
  full_price_units: Scalars['Int']['output'];
  imoova_refund_amount: Scalars['Int']['output'];
  pay_later_discounted_amount: Scalars['Int']['output'];
  pay_later_full_price_amount: Scalars['Int']['output'];
  pay_later_purchasable_extras_amount: Scalars['Int']['output'];
  pay_later_total_amount: Scalars['Int']['output'];
  pay_now_booking_fee_amount: Scalars['Int']['output'];
  pay_now_full_price_units_deposit_amount: Scalars['Int']['output'];
  pay_now_holding_deposit_amount: Scalars['Int']['output'];
  pay_now_total_amount: Scalars['Int']['output'];
  purchasable_extras: Array<RelocationPurchasableExtra>;
  supplier_refund_amount: Scalars['Int']['output'];
  total_cost_amount: Scalars['Int']['output'];
  total_refund_amount: Scalars['Int']['output'];
};

export type RelocationCostInput = {
  delivery_date: Scalars['String']['input'];
  delivery_time: Scalars['String']['input'];
  departure_date: Scalars['String']['input'];
  departure_time: Scalars['String']['input'];
  purchasable_extras: Array<PurchasableExtrasInput>;
  relocation_id: Scalars['ID']['input'];
};

export type RelocationDealChatMessage = {
  content: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Either 'user' or 'assistant'. */
  role: Scalars['String']['output'];
  /** The staff member who asked; null for the assistant's replies. */
  user?: Maybe<User>;
};

export type RelocationDepartureDatesResponse = {
  departureDates: Array<OpeningHours>;
  earliestBookableTime?: Maybe<Scalars['String']['output']>;
};

export type RelocationFlowCity = {
  city_id: Scalars['ID']['output'];
  city_name: Scalars['String']['output'];
  delivery_count: Scalars['Int']['output'];
  departure_count: Scalars['Int']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  median_days_to_book_delivery?: Maybe<Scalars['Float']['output']>;
  median_days_to_book_departure?: Maybe<Scalars['Float']['output']>;
};

export type RelocationFlowMovement = {
  count: Scalars['Int']['output'];
  delivery_city_id: Scalars['ID']['output'];
  delivery_city_name: Scalars['String']['output'];
  departure_city_id: Scalars['ID']['output'];
  departure_city_name: Scalars['String']['output'];
  median_days_to_book?: Maybe<Scalars['Float']['output']>;
};

export type RelocationFlowReport = {
  cities: Array<RelocationFlowCity>;
  movements: Array<RelocationFlowMovement>;
  total_bookings: Scalars['Int']['output'];
};

export type RelocationGroup = {
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated For backwards compat - remove v5.1.4 of app */
  reference?: Maybe<Scalars['String']['output']>;
  relocations: Array<Relocation>;
};

/** A paginated list of RelocationGroup items. */
export type RelocationGroupPaginator = {
  /** A list of RelocationGroup items. */
  data: Array<RelocationGroup>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type RelocationHighlight = {
  created_at: Scalars['DateTime']['output'];
  deliveryCity?: Maybe<City>;
  departureCity?: Maybe<City>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  primary_text: Scalars['String']['output'];
  region?: Maybe<Region>;
  secondary_text?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of RelocationHighlight items. */
export type RelocationHighlightPaginator = {
  /** A list of RelocationHighlight items. */
  data: Array<RelocationHighlight>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type RelocationInclusion = {
  description?: Maybe<Scalars['String']['output']>;
  has_free_tank: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_acknowledgment_required: Scalars['Boolean']['output'];
  relocation?: Maybe<Relocation>;
  type: RelocationInclusionType;
  value?: Maybe<Scalars['Int']['output']>;
};

export type RelocationInclusionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  has_free_tank?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type: RelocationInclusionType;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export enum RelocationInclusionType {
  Charge = 'CHARGE',
  Ferry = 'FERRY',
  Fuel = 'FUEL',
  Negative = 'NEGATIVE',
  Other = 'OTHER'
}

export type RelocationItemInput = {
  available_from: Scalars['String']['input'];
  available_to: Scalars['String']['input'];
  delivery_office_code: Scalars['String']['input'];
  departure_office_code: Scalars['String']['input'];
  distance_allowed?: InputMaybe<Scalars['Int']['input']>;
  extra_hire_unit_supplier_net_rate?: InputMaybe<Scalars['Int']['input']>;
  extra_hire_units_allowed?: InputMaybe<Scalars['Int']['input']>;
  ferry_note?: InputMaybe<Scalars['String']['input']>;
  fuel_amount?: InputMaybe<Scalars['Int']['input']>;
  fuel_note?: InputMaybe<Scalars['String']['input']>;
  hire_unit_rate?: InputMaybe<Scalars['Int']['input']>;
  hire_units_allowed?: InputMaybe<Scalars['Int']['input']>;
  inclusion_note?: InputMaybe<Scalars['String']['input']>;
  line?: InputMaybe<Scalars['String']['input']>;
  minimum_hire_units?: InputMaybe<Scalars['Int']['input']>;
  preparation_charge_amount?: InputMaybe<Scalars['Int']['input']>;
  preparation_charge_note?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  vehicle_code: Scalars['String']['input'];
};

export type RelocationLine = {
  booking?: Maybe<Booking>;
  created_at: Scalars['DateTime']['output'];
  group: RelocationGroup;
  id: Scalars['ID']['output'];
  reference: Scalars['String']['output'];
  sold_at?: Maybe<Scalars['DateTime']['output']>;
  sold_by?: Maybe<Competitor>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type RelocationLineEmail = {
  actions: Array<RelocationLineEmailAction>;
  created_at: Scalars['DateTime']['output'];
  email_from: Scalars['String']['output'];
  email_received_at: Scalars['DateTime']['output'];
  email_subject: Scalars['String']['output'];
  email_text?: Maybe<Scalars['String']['output']>;
  failure_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  resolvedBy?: Maybe<User>;
  resolved_at?: Maybe<Scalars['DateTime']['output']>;
  status: RelocationLineEmailStatus;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type RelocationLineEmailAction = {
  confident: Scalars['Boolean']['output'];
  line_reference: Scalars['String']['output'];
  outcome?: Maybe<RelocationLineEmailActionOutcome>;
  region?: Maybe<Region>;
  relocation_line_id?: Maybe<Scalars['ID']['output']>;
  sold_by?: Maybe<Scalars['String']['output']>;
  type: RelocationLineEmailActionType;
};

export enum RelocationLineEmailActionOutcome {
  AlreadySet = 'ALREADY_SET',
  Applied = 'APPLIED',
  LineAmbiguous = 'LINE_AMBIGUOUS',
  LineHasBooking = 'LINE_HAS_BOOKING',
  LineNotFound = 'LINE_NOT_FOUND',
  SoldByImoova = 'SOLD_BY_IMOOVA',
  Uncertain = 'UNCERTAIN',
  UnknownSeller = 'UNKNOWN_SELLER'
}

export enum RelocationLineEmailActionType {
  Released = 'RELEASED',
  Sold = 'SOLD',
  Withdrawn = 'WITHDRAWN'
}

export enum RelocationLineEmailStatus {
  Applied = 'APPLIED',
  AwaitingReview = 'AWAITING_REVIEW',
  Failed = 'FAILED',
  NoAction = 'NO_ACTION',
  Processing = 'PROCESSING',
  Resolved = 'RESOLVED'
}

export type RelocationLineInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  reference: Scalars['String']['input'];
};

/** A paginated list of RelocationLine items. */
export type RelocationLinePaginator = {
  /** A list of RelocationLine items. */
  data: Array<RelocationLine>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** A geographic point deals are ranked against by proximity. */
export type RelocationNearInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type RelocationPage = {
  articles: Array<RelocationPageArticle>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Media>;
  points: Array<RelocationPagePoint>;
  region: Region;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type RelocationPageArticle = {
  created_at: Scalars['DateTime']['output'];
  dato_article_slug: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  relocation_page_id: Scalars['ID']['output'];
  sort_order: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of RelocationPage items. */
export type RelocationPagePaginator = {
  /** A list of RelocationPage items. */
  data: Array<RelocationPage>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type RelocationPagePoint = {
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  radius: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Relocation items. */
export type RelocationPaginator = {
  /** A list of Relocation items. */
  data: Array<Relocation>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type RelocationPoint = {
  city_id: Scalars['ID']['output'];
  city_name?: Maybe<Scalars['String']['output']>;
  city_slug?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  region?: Maybe<Region>;
  relocation_ids: Array<Scalars['ID']['output']>;
  secondary_points: Array<RelocationSecondaryPoint>;
};

export type RelocationPointInput = {
  delivery_city_id?: InputMaybe<Scalars['ID']['input']>;
  depart_after?: InputMaybe<Scalars['String']['input']>;
  depart_before?: InputMaybe<Scalars['String']['input']>;
  depart_on_or_after?: InputMaybe<Scalars['String']['input']>;
  departure_city_id?: InputMaybe<Scalars['ID']['input']>;
  driver_age?: InputMaybe<Scalars['Int']['input']>;
  ferry_included?: InputMaybe<Scalars['String']['input']>;
  fuel_included?: InputMaybe<Scalars['String']['input']>;
  number_of_travelers?: InputMaybe<Scalars['Int']['input']>;
  relocation_types?: InputMaybe<Array<RelocationType>>;
  type: RelocationPointType;
  vehicle_category?: InputMaybe<VehicleCategory>;
};

export enum RelocationPointType {
  DeliverTo = 'DELIVER_TO',
  DepartFrom = 'DEPART_FROM'
}

export type RelocationPromotion = {
  budget_amount: Scalars['Int']['output'];
  channels: Array<PromotionChannel>;
  clicks: Scalars['Int']['output'];
  conversions: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  creative?: Maybe<PromotionCreative>;
  id: Scalars['ID']['output'];
  /** The promotion's channels' metrics, summed. */
  impressions: Scalars['Int']['output'];
  relocation: Relocation;
  spend_amount: Scalars['Int']['output'];
};

/** A paginated list of RelocationPromotion items. */
export type RelocationPromotionPaginator = {
  /** A list of RelocationPromotion items. */
  data: Array<RelocationPromotion>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type RelocationPurchasableExtra = {
  quantity: Scalars['Int']['output'];
  supplier_purchasable_extra: SupplierPurchasableExtra;
};

export type RelocationRecommendation = {
  closestCity: City;
  relocations: Array<Relocation>;
  type: RelocationRecommendationType;
};

export enum RelocationRecommendationType {
  ArrivingToCity = 'ARRIVING_TO_CITY',
  DepartingFromCity = 'DEPARTING_FROM_CITY',
  NearMe = 'NEAR_ME'
}

export type RelocationRentalUnits = {
  extraUnits: Scalars['Int']['output'];
  relocationUnits: Scalars['Int']['output'];
};

export type RelocationSecondaryPoint = {
  city_id: Scalars['ID']['output'];
  city_name?: Maybe<Scalars['String']['output']>;
  city_slug?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  region?: Maybe<Region>;
  relocation_ids?: Maybe<Array<Scalars['ID']['output']>>;
};

export type RelocationStats = {
  bookings_count: Scalars['Int']['output'];
  completed_bookings_count: Scalars['Int']['output'];
  confirmed_bookings_count: Scalars['Int']['output'];
  days_until_expiry: Scalars['Int']['output'];
  pending_bookings_count: Scalars['Int']['output'];
  views_today: Scalars['Int']['output'];
  views_total: Scalars['Int']['output'];
  views_yesterday: Scalars['Int']['output'];
};

export enum RelocationStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Paused = 'PAUSED',
  Ready = 'READY',
  SoldOut = 'SOLD_OUT'
}

export type RelocationStatusStat = {
  count: Scalars['Int']['output'];
  status: RelocationStatus;
  sum: Scalars['Int']['output'];
};

export type RelocationTableItem = {
  available_from_date: Scalars['String']['output'];
  available_to_date: Scalars['String']['output'];
  booking_fee_amount: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  currency: Currency;
  deal_slug: Scalars['String']['output'];
  delivery_city_name: Scalars['String']['output'];
  delivery_city_region?: Maybe<Scalars['String']['output']>;
  delivery_city_slug: Scalars['String']['output'];
  departure_city_name: Scalars['String']['output'];
  departure_city_region?: Maybe<Scalars['String']['output']>;
  departure_city_slug: Scalars['String']['output'];
  extra_hire_unit_rate?: Maybe<Scalars['Int']['output']>;
  extra_units: Scalars['Int']['output'];
  ferry_description?: Maybe<Scalars['String']['output']>;
  fuel_amount?: Maybe<Scalars['Int']['output']>;
  fuel_description?: Maybe<Scalars['String']['output']>;
  has_ferry: Scalars['Boolean']['output'];
  has_fuel: Scalars['Boolean']['output'];
  hire_unit_rate: Scalars['Int']['output'];
  hire_unit_type: HireUnitType;
  id: Scalars['ID']['output'];
  latest_departure_date: Scalars['String']['output'];
  minimum_age: Scalars['Int']['output'];
  reference: Scalars['String']['output'];
  relocation_units: Scalars['Int']['output'];
  type: RelocationType;
  vehicle_hero_image: Scalars['String']['output'];
  vehicle_name: Scalars['String']['output'];
  vehicle_seatbelts: Scalars['Int']['output'];
  vehicle_sleeps?: Maybe<Scalars['Int']['output']>;
  vehicle_transmission: Transmission;
  vehicle_type: VehicleType;
};

export enum RelocationType {
  GapRental = 'GAP_RENTAL',
  Relocation = 'RELOCATION'
}

export type RelocationViewByHour = {
  hour: Scalars['String']['output'];
  view_count: Scalars['Int']['output'];
};

export type RelocationViews = {
  region_average: Array<RelocationViewByHour>;
  relocation: Array<RelocationViewByHour>;
};

export type ReportBooking = {
  booking_confirmed_at?: Maybe<Scalars['String']['output']>;
  booking_created_at: Scalars['String']['output'];
  booking_currency: Currency;
  booking_customer_cost: Scalars['Int']['output'];
  booking_deliver_at: Scalars['String']['output'];
  booking_depart_at: Scalars['String']['output'];
  booking_email: Scalars['String']['output'];
  booking_name: Scalars['String']['output'];
  booking_phone: Scalars['String']['output'];
  booking_reference: Scalars['String']['output'];
  booking_status: BookingStatus;
  booking_supplier_reference?: Maybe<Scalars['String']['output']>;
  days_to_booking: Scalars['Int']['output'];
  delivery_office_name: Scalars['String']['output'];
  departure_office_name: Scalars['String']['output'];
  ferry_description?: Maybe<Scalars['String']['output']>;
  fuel_description?: Maybe<Scalars['String']['output']>;
  fuel_value?: Maybe<Scalars['Int']['output']>;
  negative_description?: Maybe<Scalars['String']['output']>;
  negative_value?: Maybe<Scalars['Int']['output']>;
  other_description?: Maybe<Scalars['String']['output']>;
  other_value?: Maybe<Scalars['Int']['output']>;
  relocation_created_at: Scalars['String']['output'];
  relocation_reference: Scalars['String']['output'];
  supplier_name: Scalars['String']['output'];
  vehicle_name: Scalars['String']['output'];
};

export type ReportIncidentInput = {
  claim_document_file_paths?: InputMaybe<Array<Scalars['String']['input']>>;
  claim_reference?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  excess_amount?: InputMaybe<Scalars['Int']['input']>;
  follow_up_contact: Scalars['String']['input'];
  found_at: Scalars['DateTimeTz']['input'];
  insurer?: InputMaybe<Scalars['String']['input']>;
  /** Opens the claim straight away; needs the excess and at least one supporting document. */
  open_claim?: InputMaybe<Scalars['Boolean']['input']>;
  photo_file_paths: Array<Scalars['String']['input']>;
  type: IncidentType;
  work_order_assignment_id: Scalars['ID']['input'];
};

export type ReportInvoice = {
  amount_due: Scalars['Int']['output'];
  amount_inc_tax: Scalars['Int']['output'];
  amount_paid: Scalars['Int']['output'];
  currency: Currency;
  customer_name?: Maybe<Scalars['String']['output']>;
  date_paid?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice_date?: Maybe<Scalars['String']['output']>;
  invoice_reference: Scalars['String']['output'];
  invoice_status: Scalars['String']['output'];
  managed_by_name: Scalars['String']['output'];
  payment_method?: Maybe<Scalars['String']['output']>;
  payments: Array<ReportInvoicePayment>;
};

export type ReportInvoicePayment = {
  amount: Scalars['Int']['output'];
  payment_date: Scalars['String']['output'];
  payment_description?: Maybe<Scalars['String']['output']>;
  payment_method: Scalars['String']['output'];
  payment_reference: Scalars['String']['output'];
};

export type ReportReceipt = {
  amount_exc_tax: Scalars['Int']['output'];
  amount_inc_tax: Scalars['Int']['output'];
  amount_tax: Scalars['Int']['output'];
  claimable_amount_exc_tax: Scalars['Int']['output'];
  claimable_amount_inc_tax: Scalars['Int']['output'];
  claimable_amount_tax: Scalars['Int']['output'];
  created_at: Scalars['String']['output'];
  currency: Currency;
  date: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  related_id?: Maybe<Scalars['ID']['output']>;
  related_reference?: Maybe<Scalars['String']['output']>;
  related_type?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ReportReceiptTotals = {
  total_amount_exc_tax: Scalars['Int']['output'];
  total_amount_inc_tax: Scalars['Int']['output'];
  total_amount_tax: Scalars['Int']['output'];
  total_claimable_amount_exc_tax: Scalars['Int']['output'];
  total_claimable_amount_inc_tax: Scalars['Int']['output'];
  total_claimable_amount_tax: Scalars['Int']['output'];
  total_receipts: Scalars['Int']['output'];
};

export type ReportReceiptsResult = {
  receipts: Array<ReportReceipt>;
  totals: ReportReceiptTotals;
};

export type ReportRelocation = {
  available_from_date?: Maybe<Scalars['String']['output']>;
  available_to_date?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  currency: Currency;
  delivery_office_name?: Maybe<Scalars['String']['output']>;
  departure_office_name?: Maybe<Scalars['String']['output']>;
  distance_allowed?: Maybe<Scalars['Int']['output']>;
  extra_hire_unit_rate?: Maybe<Scalars['Int']['output']>;
  extra_hire_units_allowed?: Maybe<Scalars['Int']['output']>;
  failed_bookings: Scalars['Int']['output'];
  ferry_description?: Maybe<Scalars['String']['output']>;
  fuel_description?: Maybe<Scalars['String']['output']>;
  hire_unit_rate?: Maybe<Scalars['Int']['output']>;
  hire_unit_type?: Maybe<Scalars['String']['output']>;
  hire_units_allowed?: Maybe<Scalars['Int']['output']>;
  latest_departure_date?: Maybe<Scalars['String']['output']>;
  num_bookings: Scalars['Int']['output'];
  region?: Maybe<Region>;
  relocation_reference: Scalars['String']['output'];
  remaining: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  successful_bookings: Scalars['Int']['output'];
  supplier_name: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  vehicle_name?: Maybe<Scalars['String']['output']>;
  vehicle_transmission?: Maybe<Scalars['String']['output']>;
  vehicle_type?: Maybe<Scalars['String']['output']>;
};

export type ReportWorkOrder = {
  created_at: Scalars['String']['output'];
  currency: Currency;
  delivery_city?: Maybe<Scalars['String']['output']>;
  departure_city?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice_amount_exc_tax: Scalars['Int']['output'];
  invoice_amount_exc_tax_aud: Scalars['Int']['output'];
  invoice_amount_exc_tax_wo_currency: Scalars['Int']['output'];
  invoice_id?: Maybe<Scalars['ID']['output']>;
  invoice_reference?: Maybe<Scalars['String']['output']>;
  invoice_status?: Maybe<Scalars['String']['output']>;
  managed_by_name: Scalars['String']['output'];
  profit: Scalars['Int']['output'];
  profit_aud: Scalars['Int']['output'];
  supplier_name?: Maybe<Scalars['String']['output']>;
  total_claimed_expenses: Scalars['Int']['output'];
  total_claimed_expenses_aud: Scalars['Int']['output'];
  total_expected_payout: Scalars['Int']['output'];
  total_expected_payout_aud: Scalars['Int']['output'];
  total_payouts: Scalars['Int']['output'];
  total_payouts_aud: Scalars['Int']['output'];
  work_order_reference: Scalars['String']['output'];
  work_order_status: Scalars['String']['output'];
};

export type ReportWorkOrderAssignment = {
  assignment_status: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  delivery_city?: Maybe<Scalars['String']['output']>;
  delivery_date?: Maybe<Scalars['String']['output']>;
  delivery_hours_late?: Maybe<Scalars['Float']['output']>;
  departure_city?: Maybe<Scalars['String']['output']>;
  driver_age?: Maybe<Scalars['Int']['output']>;
  driver_email?: Maybe<Scalars['String']['output']>;
  driver_name?: Maybe<Scalars['String']['output']>;
  driver_phone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pickup_date?: Maybe<Scalars['String']['output']>;
  pickup_hours_late?: Maybe<Scalars['Float']['output']>;
  supplier_name?: Maybe<Scalars['String']['output']>;
  vehicle_type: Scalars['String']['output'];
  work_order_id: Scalars['ID']['output'];
  work_order_reference: Scalars['String']['output'];
};

export type RequestCallbackInput = {
  description: Scalars['String']['input'];
};

export type ResolveBookingChangeRequestInput = {
  amount_to_capture?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  status: BookingChangeRequestStatus;
};

export type ResolveBookingPaymentRequestInput = {
  amountToCapture?: InputMaybe<Scalars['Int']['input']>;
  status: BookingPaymentRequestStatus;
};

/** The available SQL operators that are used to filter query results. */
export enum SqlOperator {
  /** Whether a value is within a range of values (`BETWEEN`) */
  Between = 'BETWEEN',
  /** Equal operator (`=`) */
  Eq = 'EQ',
  /** Greater than operator (`>`) */
  Gt = 'GT',
  /** Greater than or equal operator (`>=`) */
  Gte = 'GTE',
  /** Whether a value is within a set of values (`IN`) */
  In = 'IN',
  /** Whether a value is not null (`IS NOT NULL`) */
  IsNotNull = 'IS_NOT_NULL',
  /** Whether a value is null (`IS NULL`) */
  IsNull = 'IS_NULL',
  /** Simple pattern matching (`LIKE`) */
  Like = 'LIKE',
  /** Less than operator (`<`) */
  Lt = 'LT',
  /** Less than or equal operator (`<=`) */
  Lte = 'LTE',
  /** Not equal operator (`!=`) */
  Neq = 'NEQ',
  /** Whether a value is not within a range of values (`NOT BETWEEN`) */
  NotBetween = 'NOT_BETWEEN',
  /** Whether a value is not within a set of values (`NOT IN`) */
  NotIn = 'NOT_IN',
  /** Negation of simple pattern matching (`NOT LIKE`) */
  NotLike = 'NOT_LIKE'
}

export type SalesCommissionData = {
  bookingCount: Scalars['Int']['output'];
  commissionAmount: Scalars['Int']['output'];
  currency: Currency;
  organisations: Array<OrganisationCommissionData>;
  quarter: Scalars['Int']['output'];
  totalRevenue: Scalars['Int']['output'];
  trend?: Maybe<SalesCommissionTrend>;
  user?: Maybe<User>;
  year: Scalars['Int']['output'];
};

export type SalesCommissionTrend = {
  isPartialComparison: Scalars['Boolean']['output'];
  percentageChange?: Maybe<Scalars['Float']['output']>;
  previousRevenue: Scalars['Int']['output'];
};

export type SalesOrganisationAttribution = {
  id: Scalars['ID']['output'];
  organisation: Organisation;
  user: User;
};

export type SignProDriverAgreementInput = {
  signature_svg?: InputMaybe<Scalars['String']['input']>;
  signer_name: Scalars['String']['input'];
};

export type SignedStorageUrl = {
  filePath: Scalars['String']['output'];
  headers: Scalars['Mixed']['output'];
  url: Scalars['String']['output'];
};

export type SignedStorageUrlInput = {
  cache_control?: InputMaybe<Scalars['String']['input']>;
  content_type?: InputMaybe<Scalars['String']['input']>;
  expires?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<Visibility>;
};

export type SnoozeCallbackLeadInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  snoozed_until: Scalars['DateTime']['input'];
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export enum State {
  Ad = 'AD',
  AeAd = 'AE_AD',
  AeDu = 'AE_DU',
  Al = 'AL',
  Am = 'AM',
  ArBa = 'AR_BA',
  ArCf = 'AR_CF',
  ArCo = 'AR_CO',
  ArMz = 'AR_MZ',
  ArSf = 'AR_SF',
  ArTu = 'AR_TU',
  At = 'AT',
  AuAct = 'AU_ACT',
  AuNsw = 'AU_NSW',
  AuNt = 'AU_NT',
  AuQld = 'AU_QLD',
  AuSa = 'AU_SA',
  AuTas = 'AU_TAS',
  AuVic = 'AU_VIC',
  AuWa = 'AU_WA',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Be = 'BE',
  Bg = 'BG',
  BrBa = 'BR_BA',
  BrMg = 'BR_MG',
  BrPr = 'BR_PR',
  BrRj = 'BR_RJ',
  BrRs = 'BR_RS',
  BrSp = 'BR_SP',
  BwCe = 'BW_CE',
  BwCh = 'BW_CH',
  BwGh = 'BW_GH',
  BwKg = 'BW_KG',
  BwKl = 'BW_KL',
  BwKw = 'BW_KW',
  BwNe = 'BW_NE',
  BwNw = 'BW_NW',
  BwSe = 'BW_SE',
  BwSo = 'BW_SO',
  By = 'BY',
  CaAb = 'CA_AB',
  CaBc = 'CA_BC',
  CaMb = 'CA_MB',
  CaNb = 'CA_NB',
  CaNl = 'CA_NL',
  CaNs = 'CA_NS',
  CaNt = 'CA_NT',
  CaNu = 'CA_NU',
  CaOn = 'CA_ON',
  CaPe = 'CA_PE',
  CaQc = 'CA_QC',
  CaSk = 'CA_SK',
  CaYt = 'CA_YT',
  Ch = 'CH',
  ClAn = 'CL_AN',
  ClAr = 'CL_AR',
  ClBi = 'CL_BI',
  ClCo = 'CL_CO',
  ClLl = 'CL_LL',
  ClMa = 'CL_MA',
  ClRm = 'CL_RM',
  ClVs = 'CL_VS',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dk = 'DK',
  Ee = 'EE',
  Es = 'ES',
  Fa = 'FA',
  Fi = 'FI',
  Fj = 'FJ',
  Fo = 'FO',
  Fr = 'FR',
  Gb = 'GB',
  Ge = 'GE',
  Gg = 'GG',
  Gi = 'GI',
  Gr = 'GR',
  Hr = 'HR',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Im = 'IM',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jp_01 = 'JP_01',
  Jp_02 = 'JP_02',
  Jp_03 = 'JP_03',
  Jp_04 = 'JP_04',
  Jp_05 = 'JP_05',
  Jp_06 = 'JP_06',
  Jp_07 = 'JP_07',
  Jp_08 = 'JP_08',
  Jp_09 = 'JP_09',
  Jp_10 = 'JP_10',
  Jp_11 = 'JP_11',
  Jp_12 = 'JP_12',
  Jp_13 = 'JP_13',
  Jp_14 = 'JP_14',
  Jp_15 = 'JP_15',
  Jp_16 = 'JP_16',
  Jp_17 = 'JP_17',
  Jp_18 = 'JP_18',
  Jp_19 = 'JP_19',
  Jp_20 = 'JP_20',
  Jp_21 = 'JP_21',
  Jp_22 = 'JP_22',
  Jp_23 = 'JP_23',
  Jp_24 = 'JP_24',
  Jp_25 = 'JP_25',
  Jp_26 = 'JP_26',
  Jp_27 = 'JP_27',
  Jp_28 = 'JP_28',
  Jp_29 = 'JP_29',
  Jp_30 = 'JP_30',
  Jp_31 = 'JP_31',
  Jp_32 = 'JP_32',
  Jp_33 = 'JP_33',
  Jp_34 = 'JP_34',
  Jp_35 = 'JP_35',
  Jp_36 = 'JP_36',
  Jp_37 = 'JP_37',
  Jp_38 = 'JP_38',
  Jp_39 = 'JP_39',
  Jp_40 = 'JP_40',
  Jp_41 = 'JP_41',
  Jp_42 = 'JP_42',
  Jp_43 = 'JP_43',
  Jp_44 = 'JP_44',
  Jp_45 = 'JP_45',
  Jp_46 = 'JP_46',
  Jp_47 = 'JP_47',
  KrDag = 'KR_DAG',
  KrGgi = 'KR_GGI',
  KrInc = 'KR_INC',
  KrJej = 'KR_JEJ',
  KrPus = 'KR_PUS',
  KrSeo = 'KR_SEO',
  Kw = 'KW',
  Li = 'LI',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mk = 'MK',
  Mt = 'MT',
  MxBcn = 'MX_BCN',
  MxCmx = 'MX_CMX',
  MxJal = 'MX_JAL',
  MxNle = 'MX_NLE',
  MxQue = 'MX_QUE',
  MxYuc = 'MX_YUC',
  NaCa = 'NA_CA',
  NaEr = 'NA_ER',
  NaHa = 'NA_HA',
  NaKa = 'NA_KA',
  NaKe = 'NA_KE',
  NaKh = 'NA_KH',
  NaKu = 'NA_KU',
  NaKw = 'NA_KW',
  NaOd = 'NA_OD',
  NaOh = 'NA_OH',
  NaOn = 'NA_ON',
  NaOs = 'NA_OS',
  NaOt = 'NA_OT',
  NaOw = 'NA_OW',
  Nc = 'NC',
  Nl = 'NL',
  No = 'NO',
  NzAuk = 'NZ_AUK',
  NzBop = 'NZ_BOP',
  NzCan = 'NZ_CAN',
  NzGis = 'NZ_GIS',
  NzHkb = 'NZ_HKB',
  NzMbh = 'NZ_MBH',
  NzMwt = 'NZ_MWT',
  NzNsn = 'NZ_NSN',
  NzNtl = 'NZ_NTL',
  NzOta = 'NZ_OTA',
  NzStl = 'NZ_STL',
  NzTas = 'NZ_TAS',
  NzTki = 'NZ_TKI',
  NzWgn = 'NZ_WGN',
  NzWko = 'NZ_WKO',
  NzWtc = 'NZ_WTC',
  Om = 'OM',
  Pg = 'PG',
  Pl = 'PL',
  Pt = 'PT',
  Qa = 'QA',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  SaMk = 'SA_MK',
  SaRy = 'SA_RY',
  Sb = 'SB',
  Se = 'SE',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sm = 'SM',
  SzHh = 'SZ_HH',
  SzLu = 'SZ_LU',
  SzMa = 'SZ_MA',
  SzSh = 'SZ_SH',
  Tr = 'TR',
  TwKhh = 'TW_KHH',
  TwNwt = 'TW_NWT',
  TwTao = 'TW_TAO',
  TwTnn = 'TW_TNN',
  TwTpe = 'TW_TPE',
  TwTxg = 'TW_TXG',
  Ua = 'UA',
  UsAk = 'US_AK',
  UsAl = 'US_AL',
  UsAr = 'US_AR',
  UsAz = 'US_AZ',
  UsCa = 'US_CA',
  UsCo = 'US_CO',
  UsCt = 'US_CT',
  UsDc = 'US_DC',
  UsDe = 'US_DE',
  UsFl = 'US_FL',
  UsGa = 'US_GA',
  UsHi = 'US_HI',
  UsIa = 'US_IA',
  UsId = 'US_ID',
  UsIl = 'US_IL',
  UsIn = 'US_IN',
  UsKs = 'US_KS',
  UsKy = 'US_KY',
  UsLa = 'US_LA',
  UsMa = 'US_MA',
  UsMd = 'US_MD',
  UsMe = 'US_ME',
  UsMi = 'US_MI',
  UsMn = 'US_MN',
  UsMo = 'US_MO',
  UsMs = 'US_MS',
  UsMt = 'US_MT',
  UsNc = 'US_NC',
  UsNd = 'US_ND',
  UsNe = 'US_NE',
  UsNh = 'US_NH',
  UsNj = 'US_NJ',
  UsNm = 'US_NM',
  UsNv = 'US_NV',
  UsNy = 'US_NY',
  UsOh = 'US_OH',
  UsOk = 'US_OK',
  UsOr = 'US_OR',
  UsPa = 'US_PA',
  UsRi = 'US_RI',
  UsSc = 'US_SC',
  UsSd = 'US_SD',
  UsTn = 'US_TN',
  UsTx = 'US_TX',
  UsUt = 'US_UT',
  UsVa = 'US_VA',
  UsVt = 'US_VT',
  UsWa = 'US_WA',
  UsWi = 'US_WI',
  UsWv = 'US_WV',
  UsWy = 'US_WY',
  Va = 'VA',
  Vu = 'VU',
  Xk = 'XK',
  ZaEc = 'ZA_EC',
  ZaFs = 'ZA_FS',
  ZaGp = 'ZA_GP',
  ZaKzn = 'ZA_KZN',
  ZaLp = 'ZA_LP',
  ZaMp = 'ZA_MP',
  ZaNc = 'ZA_NC',
  ZaNw = 'ZA_NW',
  ZaWc = 'ZA_WC'
}

export type StripeCheckoutSession = {
  checkout_session_id: Scalars['String']['output'];
  checkout_session_url: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  object?: Maybe<StripeCheckoutSessionObject>;
  payment_intent_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type StripeCheckoutSessionObject = Invoice;

export type StripeCustomer = {
  id: Scalars['ID']['output'];
  paymentMethods?: Maybe<Array<StripePaymentMethod>>;
};

export type StripePayment = {
  amount: Scalars['Int']['output'];
  amount_captured: Scalars['Int']['output'];
  amount_dispute_fee?: Maybe<Scalars['Int']['output']>;
  amount_disputed: Scalars['Int']['output'];
  amount_fee?: Maybe<Scalars['Int']['output']>;
  amount_refunded: Scalars['Int']['output'];
  attributed_to_id?: Maybe<Scalars['ID']['output']>;
  attributed_to_type?: Maybe<ModelType>;
  brand?: Maybe<Scalars['String']['output']>;
  client_secret?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  dispute_status?: Maybe<Scalars['String']['output']>;
  exp_month?: Maybe<Scalars['Int']['output']>;
  exp_year?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  last4?: Maybe<Scalars['String']['output']>;
  payment_intent_id: Scalars['String']['output'];
  receipt_url?: Maybe<Scalars['String']['output']>;
  status: StripePaymentStatus;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type StripePaymentMethod = {
  card_brand?: Maybe<Scalars['String']['output']>;
  card_exp_month?: Maybe<Scalars['String']['output']>;
  card_exp_year?: Maybe<Scalars['String']['output']>;
  card_last_four?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_primary: Scalars['Boolean']['output'];
  type: StripePaymentMethodType;
};

export enum StripePaymentMethodType {
  Card = 'CARD'
}

export enum StripePaymentStatus {
  Canceled = 'Canceled',
  Processing = 'Processing',
  RequiresAction = 'RequiresAction',
  RequiresCapture = 'RequiresCapture',
  RequiresConfirmation = 'RequiresConfirmation',
  RequiresPaymentMethod = 'RequiresPaymentMethod',
  Succeeded = 'Succeeded'
}

export type StructuredOpeningHours = {
  closes: Scalars['String']['output'];
  dayOfWeek?: Maybe<DayOfWeek>;
  opens: Scalars['String']['output'];
  validFrom?: Maybe<Scalars['String']['output']>;
  validThrough?: Maybe<Scalars['String']['output']>;
};

export type SuggestedRelocations = {
  recommendations: Array<RelocationRecommendation>;
};

export type Supplier = {
  acknowledgements: Array<SupplierAcknowledgement>;
  age_surcharge_amount?: Maybe<Scalars['Int']['output']>;
  age_surcharge_type: AgeSurchargeType;
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  billingEntity: Contact;
  billing_currency: Currency;
  booking_fee_amount: Scalars['Int']['output'];
  charge_per_move_amount: Scalars['Int']['output'];
  closed_dates?: Maybe<Scalars['Mixed']['output']>;
  collect_address_on_bookings: Scalars['Boolean']['output'];
  collect_gender_on_bookings: Scalars['Boolean']['output'];
  confirm_delivery_before_billing: Scalars['Boolean']['output'];
  contact_notes?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  /** Units currently available across the supplier's ready relocations. */
  current_listings_count?: Maybe<Scalars['Int']['output']>;
  debit_card_accepted: Scalars['Boolean']['output'];
  default_extra_hire_units_allowed?: Maybe<Scalars['Int']['output']>;
  delivery_hours?: Maybe<Scalars['Mixed']['output']>;
  departure_hours?: Maybe<Scalars['Mixed']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_on_line_sold: Scalars['Boolean']['output'];
  excess_distance_rate?: Maybe<Scalars['Int']['output']>;
  extra_distance_allowed_per_extra_hire_unit?: Maybe<Scalars['Int']['output']>;
  ferryDates: Array<SupplierFerryDate>;
  ferry_refund_fee: Scalars['Int']['output'];
  fuel_refund_fee: Scalars['Int']['output'];
  fuel_refund_instructions?: Maybe<Scalars['String']['output']>;
  gapRentalTermsAndConditions?: Maybe<SupplierTermsAndConditions>;
  gap_rentals_cancellation_policy?: Maybe<Scalars['String']['output']>;
  gap_rentals_standard_inclusions?: Maybe<Scalars['String']['output']>;
  has_age_surcharge: Scalars['Boolean']['output'];
  hire_unit_type: HireUnitType;
  holding_deposit_amount: Scalars['Int']['output'];
  holding_deposit_refunded_at: DepositRefundedAt;
  holding_deposit_refunded_by: HoldingDepositRefundedBy;
  hours_to_confirm: Scalars['Int']['output'];
  icon?: Maybe<Media>;
  id: Scalars['ID']['output'];
  imoova_refunds_ferry: Scalars['Boolean']['output'];
  imoova_refunds_fuel: Scalars['Boolean']['output'];
  is_holding_deposit_required: Scalars['Boolean']['output'];
  is_tax_included: Scalars['Boolean']['output'];
  line_sold_email?: Maybe<Scalars['String']['output']>;
  line_sold_timezone?: Maybe<Scalars['String']['output']>;
  logistics_hours?: Maybe<Scalars['Mixed']['output']>;
  logo?: Maybe<Media>;
  managedBy: Organisation;
  managed_by_id: Scalars['ID']['output'];
  maximum_age: Scalars['Int']['output'];
  maximum_no_surcharge_age?: Maybe<Scalars['Int']['output']>;
  measurement: Measurement;
  minimum_age: Scalars['Int']['output'];
  minimum_no_surcharge_age?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  notificationSettings?: Maybe<Array<SupplierNotificationSetting>>;
  payment_instructions?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pre_checkin_instructions?: Maybe<Scalars['String']['output']>;
  relist_on_cancellation: Scalars['Boolean']['output'];
  relocation_lines_valid_until?: Maybe<Scalars['String']['output']>;
  standard_inclusions?: Maybe<Scalars['String']['output']>;
  tax_type: TaxType;
  termsAndConditions: SupplierTermsAndConditions;
  timezone: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type SupplierAcknowledgement = {
  acknowledgement: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of SupplierAcknowledgement items. */
export type SupplierAcknowledgementPaginator = {
  /** A list of SupplierAcknowledgement items. */
  data: Array<SupplierAcknowledgement>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SupplierActiveLineStats = {
  available_count: Scalars['Int']['output'];
  coseats_count: Scalars['Int']['output'];
  drivenow_count: Scalars['Int']['output'];
  imoova_count: Scalars['Int']['output'];
  transfercar_count: Scalars['Int']['output'];
};

export type SupplierAdminContact = {
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of SupplierAdminContact items. */
export type SupplierAdminContactPaginator = {
  /** A list of SupplierAdminContact items. */
  data: Array<SupplierAdminContact>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SupplierBookingReport = {
  created_at: Scalars['DateTime']['output'];
  excel_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  month: Scalars['Int']['output'];
  pdf_url?: Maybe<Scalars['String']['output']>;
  supplier: Supplier;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  year: Scalars['Int']['output'];
};

/** A paginated list of SupplierBookingReport items. */
export type SupplierBookingReportPaginator = {
  /** A list of SupplierBookingReport items. */
  data: Array<SupplierBookingReport>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SupplierBookingStatBlock = {
  avg_confirmation_hours?: Maybe<Scalars['Float']['output']>;
  avg_confirmation_hours_trend?: Maybe<Scalars['Float']['output']>;
  cancelled_count: Scalars['Int']['output'];
  completed_count: Scalars['Int']['output'];
  confirmed_count: Scalars['Int']['output'];
  pending_count: Scalars['Int']['output'];
  successful_bookings_trend?: Maybe<Scalars['Float']['output']>;
};

export type SupplierFerryDate = {
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  sailing_date: Scalars['Date']['output'];
};

export type SupplierInsuranceOption = {
  bond_amount?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  liability_reduction_options?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  standard_liability_amount?: Maybe<Scalars['Int']['output']>;
  supplier: Supplier;
  termsAndConditions: TermsAndConditions;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of SupplierInsuranceOption items. */
export type SupplierInsuranceOptionPaginator = {
  /** A list of SupplierInsuranceOption items. */
  data: Array<SupplierInsuranceOption>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SupplierNotificationSetting = {
  created_at: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  event: SupplierNotificationSettingEvent;
  id: Scalars['ID']['output'];
  type: SupplierNotificationSettingType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum SupplierNotificationSettingEvent {
  BookingAccepted = 'BOOKING_ACCEPTED',
  BookingCancelledAfterConfirmation = 'BOOKING_CANCELLED_AFTER_CONFIRMATION',
  BookingCancelledBeforeConfirmation = 'BOOKING_CANCELLED_BEFORE_CONFIRMATION',
  BookingConfirmed = 'BOOKING_CONFIRMED',
  BookingPending = 'BOOKING_PENDING',
  BookingPendingReminder = 'BOOKING_PENDING_REMINDER',
  BookingReport = 'BOOKING_REPORT',
  InvoiceIssued = 'INVOICE_ISSUED',
  InvoiceOverdue = 'INVOICE_OVERDUE',
  JucyIntegrationFailed = 'JUCY_INTEGRATION_FAILED',
  ProDriverWorkOrderQuotes = 'PRO_DRIVER_WORK_ORDER_QUOTES',
  RcmIntegrationPushFailed = 'RCM_INTEGRATION_PUSH_FAILED',
  RcmIntegrationPushSuccess = 'RCM_INTEGRATION_PUSH_SUCCESS',
  RelocationsCreated = 'RELOCATIONS_CREATED',
  RelocationsExpired = 'RELOCATIONS_EXPIRED'
}

export type SupplierNotificationSettingInput = {
  email: Scalars['String']['input'];
  event: SupplierNotificationSettingEvent;
  id?: InputMaybe<Scalars['ID']['input']>;
  type: SupplierNotificationSettingType;
};

export enum SupplierNotificationSettingType {
  Bcc = 'BCC',
  Cc = 'CC',
  To = 'TO'
}

export type SupplierNotificationSettingUpsert = {
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  upsert: Array<SupplierNotificationSettingInput>;
};

export type SupplierOffice = {
  address: Address;
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  billingEntity?: Maybe<Contact>;
  billing_entity_id?: Maybe<Scalars['ID']['output']>;
  booking_email?: Maybe<Scalars['String']['output']>;
  cc_booking_to_departure_office?: Maybe<Scalars['Boolean']['output']>;
  city: City;
  city_id: Scalars['String']['output'];
  closed_dates?: Maybe<Scalars['Mixed']['output']>;
  closed_delivery_dates?: Maybe<Array<Scalars['String']['output']>>;
  closed_departure_dates?: Maybe<Array<Scalars['String']['output']>>;
  code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  delivery_hours?: Maybe<Scalars['Mixed']['output']>;
  departure_hours?: Maybe<Scalars['Mixed']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationImage?: Maybe<Media>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  pickup_instructions?: Maybe<Scalars['String']['output']>;
  structuredDeliveryHours: Array<StructuredOpeningHours>;
  structuredDepartureHours: Array<StructuredOpeningHours>;
  supplier: Supplier;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of SupplierOffice items. */
export type SupplierOfficePaginator = {
  /** A list of SupplierOffice items. */
  data: Array<SupplierOffice>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** A paginated list of Supplier items. */
export type SupplierPaginator = {
  /** A list of Supplier items. */
  data: Array<Supplier>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SupplierPurchasableExtra = {
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Photo used to present the extra to customers */
  image?: Maybe<Media>;
  name: Scalars['String']['output'];
  supplier: Supplier;
  unit_price: Scalars['Int']['output'];
  units_purchasable: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of SupplierPurchasableExtra items. */
export type SupplierPurchasableExtraPaginator = {
  /** A list of SupplierPurchasableExtra items. */
  data: Array<SupplierPurchasableExtra>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SupplierReport = {
  admin_cancelled_bookings: Scalars['Int']['output'];
  admin_cancelled_percentage: Scalars['Float']['output'];
  avg_booking_value?: Maybe<Scalars['Float']['output']>;
  avg_extra_days?: Maybe<Scalars['Float']['output']>;
  avg_hours_to_confirm?: Maybe<Scalars['Float']['output']>;
  avg_weekly_sales: Scalars['Float']['output'];
  booking_fee_amount: Scalars['Int']['output'];
  charge_per_move_amount: Scalars['Int']['output'];
  clearance_rate?: Maybe<Scalars['Float']['output']>;
  /** Currency of charge_per_move_amount and booking_fee_amount. */
  currency: Currency;
  current_listings_count: Scalars['Int']['output'];
  customer_cancelled_bookings: Scalars['Int']['output'];
  customer_cancelled_percentage: Scalars['Float']['output'];
  last_listing_time?: Maybe<Scalars['String']['output']>;
  listing_frequency?: Maybe<Scalars['String']['output']>;
  other_bookings: Scalars['Int']['output'];
  other_percentage: Scalars['Float']['output'];
  pending_bookings: Scalars['Int']['output'];
  pending_percentage: Scalars['Float']['output'];
  region?: Maybe<Region>;
  /** Average AUD revenue per booking over the 3 months ending at the report's end date. */
  revenue_per_booking?: Maybe<Scalars['Float']['output']>;
  /** The same average over the 3 months preceding that window. */
  revenue_per_booking_previous?: Maybe<Scalars['Float']['output']>;
  /** Percentage movement between the two windows. Null when there is no preceding baseline. */
  revenue_per_booking_trend?: Maybe<Scalars['Float']['output']>;
  successful_bookings: Scalars['Int']['output'];
  successful_percentage: Scalars['Float']['output'];
  supplier_cancelled_bookings: Scalars['Int']['output'];
  supplier_cancelled_percentage: Scalars['Float']['output'];
  supplier_id: Scalars['ID']['output'];
  supplier_name: Scalars['String']['output'];
  total_bookings: Scalars['Int']['output'];
  total_relocations: Scalars['Int']['output'];
};

export type SupplierTermsAndConditions = {
  id: Scalars['ID']['output'];
  license_requirements?: Maybe<Scalars['String']['output']>;
  pdf?: Maybe<Media>;
  pdf_url?: Maybe<Scalars['String']['output']>;
  relocation_type: RelocationType;
  type: SupplierTermsAndConditionsType;
};

export enum SupplierTermsAndConditionsType {
  Pdf = 'PDF',
  Text = 'TEXT'
}

export type SupplierTrip = {
  distance_allowed?: Maybe<Scalars['Int']['output']>;
  extra_hire_units_allowed: Scalars['Int']['output'];
  hire_units_allowed: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inclusions: Array<SupplierTripInclusion>;
  is_ferry_required: Scalars['Boolean']['output'];
  minimum_hire_units: Scalars['Int']['output'];
  officeA: SupplierOffice;
  officeB: SupplierOffice;
  supplier: Supplier;
};

export type SupplierTripInclusion = {
  description?: Maybe<Scalars['String']['output']>;
  has_free_tank: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  supplierTrip: SupplierTrip;
  type: RelocationInclusionType;
  value?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of SupplierTrip items. */
export type SupplierTripPaginator = {
  /** A list of SupplierTrip items. */
  data: Array<SupplierTrip>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SyncPayoutLineItemsInput = {
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  upsert: Array<UpsertPayoutLineItemInput>;
};

export type Task = {
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  due_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  relatedTo?: Maybe<TaskRelatedTo>;
  related_to_id: Scalars['ID']['output'];
  related_to_type: ModelType;
  status: TaskStatus;
  supplier?: Maybe<Supplier>;
  type: TaskType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

/** A paginated list of Task items. */
export type TaskPaginator = {
  /** A list of Task items. */
  data: Array<Task>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type TaskRelatedTo = Booking | BookingSupplierConfirmation | Refund | RelocationLineEmail | User | Waitlist | WorkOrderAssignment | WorkOrderAssignmentPayout;

export enum TaskStatus {
  Completed = 'COMPLETED',
  Overdue = 'OVERDUE',
  Pending = 'PENDING',
  Snoozed = 'SNOOZED'
}

export enum TaskType {
  Callback = 'CALLBACK',
  ConfirmRelocationWasCompleted = 'CONFIRM_RELOCATION_WAS_COMPLETED',
  ConfirmSupplierBooking = 'CONFIRM_SUPPLIER_BOOKING',
  ProcessDriverPayout = 'PROCESS_DRIVER_PAYOUT',
  ProcessFerryRefund = 'PROCESS_FERRY_REFUND',
  ProcessFuelRefund = 'PROCESS_FUEL_REFUND',
  ReviewDriverReceipts = 'REVIEW_DRIVER_RECEIPTS',
  ReviewRelocationLineEmail = 'REVIEW_RELOCATION_LINE_EMAIL'
}

export enum TaxInclusionType {
  Exclusive = 'EXCLUSIVE',
  Inclusive = 'INCLUSIVE',
  NoTax = 'NO_TAX'
}

export enum TaxRegistration {
  GstAu = 'GST_AU',
  GstCa = 'GST_CA',
  GstNz = 'GST_NZ',
  HstCa = 'HST_CA',
  None = 'NONE',
  VatAt = 'VAT_AT',
  VatBe = 'VAT_BE',
  VatBg = 'VAT_BG',
  VatCy = 'VAT_CY',
  VatCz = 'VAT_CZ',
  VatDe = 'VAT_DE',
  VatDk = 'VAT_DK',
  VatEe = 'VAT_EE',
  VatEs = 'VAT_ES',
  VatFi = 'VAT_FI',
  VatFr = 'VAT_FR',
  VatGr = 'VAT_GR',
  VatHr = 'VAT_HR',
  VatHu = 'VAT_HU',
  VatIe = 'VAT_IE',
  VatIt = 'VAT_IT',
  VatLt = 'VAT_LT',
  VatLu = 'VAT_LU',
  VatLv = 'VAT_LV',
  VatMt = 'VAT_MT',
  VatNl = 'VAT_NL',
  VatPl = 'VAT_PL',
  VatPt = 'VAT_PT',
  VatRo = 'VAT_RO',
  VatSe = 'VAT_SE',
  VatSi = 'VAT_SI',
  VatSk = 'VAT_SK'
}

export enum TaxType {
  Gst = 'GST',
  NoGst = 'NO_GST',
  Reimbursement = 'REIMBURSEMENT'
}

export type TermsAndConditions = {
  pdf_url?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Thread = {
  closed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  latestMessage?: Maybe<ThreadMessage>;
  managedBy?: Maybe<PublicOrganisation>;
  managed_by_id?: Maybe<Scalars['ID']['output']>;
  subscribers: Array<ThreadSubscriber>;
  subscription?: Maybe<ThreadSubscriber>;
  threadable?: Maybe<Threadable>;
  threadable_id?: Maybe<Scalars['String']['output']>;
  threadable_type?: Maybe<Scalars['String']['output']>;
};

export type ThreadMessage = {
  attachments: Array<Media>;
  body?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_admin_note: Scalars['Boolean']['output'];
  organisation?: Maybe<PublicOrganisation>;
  organisation_id?: Maybe<Scalars['ID']['output']>;
  thread_id: Scalars['ID']['output'];
  user: User;
  user_id: Scalars['String']['output'];
};

/** A paginated list of ThreadMessage items. */
export type ThreadMessagePaginator = {
  /** A list of ThreadMessage items. */
  data: Array<ThreadMessage>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** A paginated list of Thread items. */
export type ThreadPaginator = {
  /** A list of Thread items. */
  data: Array<Thread>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/**
 * How a thread list is ordered. UNREAD_FIRST is answered against the viewer's
 * own subscription, so it lifts the threads only they have left unread.
 */
export enum ThreadSort {
  LatestMessage = 'LATEST_MESSAGE',
  UnreadFirst = 'UNREAD_FIRST'
}

/**
 * How a thread list is split for the reader. Closing is scoped to the side doing
 * it, so OPEN and CLOSED are answered against the viewer's own closed state and
 * each side archives without moving the thread for the other.
 */
export enum ThreadStatusFilter {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type ThreadSubscriber = {
  id: Scalars['ID']['output'];
  notifications_enabled: Scalars['Boolean']['output'];
  read_at?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  user_id: Scalars['ID']['output'];
};

export type Threadable = WorkOrder;

export enum TimelineFilterOption {
  Month = 'Month',
  SevenDays = 'SevenDays',
  Today = 'TODAY',
  ThirtyDays = 'ThirtyDays',
  ThreeSixFiveDays = 'ThreeSixFiveDays',
  Week = 'Week',
  Year = 'Year'
}

export enum TransferMode {
  Bus = 'BUS',
  Ferry = 'FERRY',
  Flight = 'FLIGHT',
  Train = 'TRAIN'
}

export enum Transmission {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
  Unspecified = 'UNSPECIFIED'
}

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type Trip = {
  cityA: City;
  cityB: City;
  city_a_id: Scalars['ID']['output'];
  city_b_id: Scalars['ID']['output'];
  /** @deprecated use distance_kms */
  distance: Scalars['Int']['output'];
  distance_kms?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use distance_kms */
  distance_override?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use duration_hrs */
  duration: Scalars['Int']['output'];
  duration_hrs?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use duration_hrs */
  duration_override?: Maybe<Scalars['Int']['output']>;
  faqs: Array<TripFaq>;
  faqs_count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  landscape_image: Media;
  route_name?: Maybe<Scalars['String']['output']>;
  square_image: Media;
};

export type TripDraft = {
  /** Every leg resolved, so the trip as a whole can be booked. */
  is_feasible: Scalars['Boolean']['output'];
  legs: Array<TripDraftLeg>;
};

export type TripDraftInput = {
  /** The earliest the trip as a whole may start. */
  depart_after?: InputMaybe<Scalars['String']['input']>;
  driver_age?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Ordered hops. Leg N is picked up no earlier than leg N-1 is dropped off.
   * Capped because each leg costs a query and an open-hours computation.
   */
  legs: Array<TripDraftLegInput>;
  number_of_travellers?: InputMaybe<Scalars['Int']['input']>;
  vehicle_types?: InputMaybe<Array<VehicleType>>;
};

export type TripDraftLeg = {
  dropoff_date?: Maybe<Scalars['String']['output']>;
  dropoff_time?: Maybe<Scalars['String']['output']>;
  /**
   * The earliest this leg may be picked up — the drop-off of the leg before it.
   * Null on the first leg unless the trip has a start date.
   */
  floor?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  /**
   * Whether the dates are the traveller's own. False means the leg is running on
   * the resolver's suggestion — either it was never pinned, or the pin no longer
   * holds and was released.
   */
  is_pinned: Scalars['Boolean']['output'];
  /** Relocations that can serve this hop on or after the floor. */
  options: Array<Relocation>;
  pickup_date?: Maybe<Scalars['String']['output']>;
  pickup_time?: Maybe<Scalars['String']['output']>;
  /** The one the leg settled on: the sticky choice if it still serves, else the first option. */
  relocation?: Maybe<Relocation>;
  status: TripDraftLegStatus;
};

export type TripDraftLegInput = {
  delivery_city_id: Scalars['ID']['input'];
  departure_city_id: Scalars['ID']['input'];
  dropoff_date?: InputMaybe<Scalars['String']['input']>;
  dropoff_time?: InputMaybe<Scalars['String']['input']>;
  /**
   * The traveller's chosen dates. Supply all of pickup_date, pickup_time and
   * dropoff_date to pin the leg; the resolver reports back whether the pin still
   * holds, and falls back to its own suggestion when it doesn't.
   */
  pickup_date?: InputMaybe<Scalars['String']['input']>;
  pickup_time?: InputMaybe<Scalars['String']['input']>;
  /** The traveller's sticky relocation choice, if they made one. */
  relocation_id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Days the traveller needs to get from where the leg before this one ended to
   * this leg's pick-up city, when the two are not the same place.
   */
  transfer_days?: InputMaybe<Scalars['Int']['input']>;
};

export enum TripDraftLegStatus {
  /**
   * Something serves the hop, but it has no bookable hand-back — the hire
   * period runs past the point the vehicle can be returned.
   */
  NoDates = 'NO_DATES',
  /**
   * Nothing serves this hop that can still be picked up once the legs before it
   * have run their course. The trip cannot continue past here as it stands.
   */
  NoOptions = 'NO_OPTIONS',
  /** The leg has a relocation and a bookable date pair. */
  Resolved = 'RESOLVED'
}

export type TripFaq = {
  answer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
};

export type TripFaqInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

/** A paginated list of Trip items. */
export type TripPaginator = {
  /** A list of Trip items. */
  data: Array<Trip>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type UpdateBlogAuthorInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBlogPostInput = {
  audience?: InputMaybe<BlogAudience>;
  blog_author_id?: InputMaybe<Scalars['ID']['input']>;
  body_html?: InputMaybe<Scalars['String']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  reading_time_minutes?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBlogTagInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBookingChangeRequestInput = {
  request: Scalars['String']['input'];
};

export type UpdateBookingDatesInput = {
  deliver_at: Scalars['DateTime']['input'];
  depart_at: Scalars['DateTime']['input'];
};

export type UpdateBookingInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  charges?: InputMaybe<UpsertBookingChargesInput>;
  customer_note?: InputMaybe<Scalars['String']['input']>;
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  deliver_at?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryOffice?: InputMaybe<ConnectBelongsTo>;
  depart_at?: InputMaybe<Scalars['DateTime']['input']>;
  departureOffice?: InputMaybe<ConnectBelongsTo>;
  distance_allowed?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  inclusions?: InputMaybe<UpsertBookingInclusions>;
  name?: InputMaybe<Scalars['String']['input']>;
  number_of_travellers?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferred_ferry_date?: InputMaybe<Scalars['String']['input']>;
  purchasableExtras?: InputMaybe<UpsertBookingPurchasableExtraInput>;
  supplierInsuranceOption?: InputMaybe<ConnectBelongsTo>;
  supplier_reference?: InputMaybe<Scalars['String']['input']>;
  vehicle?: InputMaybe<ConnectBelongsTo>;
};

export type UpdateCityInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Region>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<State>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactInput = {
  billingAddress?: InputMaybe<BelongsToAddress>;
  billing_cycle_day_of_month?: InputMaybe<Scalars['Int']['input']>;
  billing_email?: InputMaybe<Scalars['String']['input']>;
  billing_phone?: InputMaybe<Scalars['String']['input']>;
  company_number?: InputMaybe<Scalars['String']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  purchase_order_number?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCurrentOrganisationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDefaultRateInput = {
  booking_fee_amount?: InputMaybe<Scalars['Int']['input']>;
  charge_per_move_amount?: InputMaybe<Scalars['Int']['input']>;
  extra_hire_unit_deposit_rate?: InputMaybe<Scalars['Int']['input']>;
  hire_unit_rate?: InputMaybe<Scalars['Int']['input']>;
  holding_deposit_amount?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFaqInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  display_on_relocation?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFeatureFlagInput = {
  enabled: Scalars['Boolean']['input'];
  organisation_id: Scalars['ID']['input'];
  type: FeatureFlagType;
};

export type UpdateIncidentInput = {
  claim_reference?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  excess_amount?: InputMaybe<Scalars['Int']['input']>;
  follow_up_contact?: InputMaybe<Scalars['String']['input']>;
  found_at?: InputMaybe<Scalars['DateTimeTz']['input']>;
  insurer?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IncidentType>;
};

export type UpdateIntegrationInput = {
  metadata?: InputMaybe<Scalars['Mixed']['input']>;
  supplier?: InputMaybe<ConnectBelongsTo>;
  type?: InputMaybe<IntegrationType>;
};

export type UpdateIntegrationLinkInput = {
  external_id?: InputMaybe<Scalars['String']['input']>;
  integration?: InputMaybe<ConnectBelongsTo>;
  object?: InputMaybe<ConnectMorphTo>;
};

export type UpdateInvoiceInput = {
  due_date?: InputMaybe<Scalars['String']['input']>;
  invoice_date?: InputMaybe<Scalars['String']['input']>;
  lineItems?: InputMaybe<UpdatePayableLineItemInput>;
  payee?: InputMaybe<ConnectBelongsTo>;
  purchase_order_number?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInvoicePaymentInput = {
  amount: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  payment_date: Scalars['String']['input'];
};

export type UpdateJobOpeningOffersHasMany = {
  create?: InputMaybe<Array<CreateJobOpeningOfferInput>>;
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateMeInput = {
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primary_phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMediaInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyProDriverProfileInput = {
  bank_account_name?: InputMaybe<Scalars['String']['input']>;
  bank_account_number?: InputMaybe<Scalars['String']['input']>;
  bank_identifier_code?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  basedIn?: InputMaybe<ConnectBelongsTo>;
  has_tow_vehicle?: InputMaybe<Scalars['Boolean']['input']>;
  license_number?: InputMaybe<Scalars['String']['input']>;
  tow_capacity_kg?: InputMaybe<Scalars['Int']['input']>;
  tow_vehicle_type?: InputMaybe<ProDriverTowVehicleType>;
  tow_vehicle_year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePartnerInput = {
  logo_path?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePayableLineItemInput = {
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  upsert: Array<UpsertPayableLineItemInput>;
};

export type UpdatePaymentInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Currency>;
  description?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['String']['input']>;
  is_tax_included?: InputMaybe<Scalars['Boolean']['input']>;
  payee?: InputMaybe<ConnectBelongsTo>;
  tax_type?: InputMaybe<TaxType>;
};

export type UpdatePopularTripInput = {
  allow_booking_requests?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryCity?: InputMaybe<ConnectBelongsTo>;
  departureCity?: InputMaybe<ConnectBelongsTo>;
  region?: InputMaybe<Region>;
  standard_relocation_days_allowed?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProDriverAgreementInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProDriverAgreementTemplateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProDriverInput = {
  bank_account_name?: InputMaybe<Scalars['String']['input']>;
  bank_account_number?: InputMaybe<Scalars['String']['input']>;
  bank_identifier_code?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  basedIn?: InputMaybe<ConnectBelongsTo>;
  bio?: InputMaybe<Scalars['String']['input']>;
  business_registration_number?: InputMaybe<Scalars['String']['input']>;
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  has_tow_vehicle?: InputMaybe<Scalars['Boolean']['input']>;
  license_issuer?: InputMaybe<Scalars['String']['input']>;
  license_number?: InputMaybe<Scalars['String']['input']>;
  license_type?: InputMaybe<ProDriverLicenseType>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tax_registration?: InputMaybe<TaxRegistration>;
  tow_capacity_kg?: InputMaybe<Scalars['Int']['input']>;
  tow_vehicle_type?: InputMaybe<ProDriverTowVehicleType>;
  tow_vehicle_year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePromotionChannelInput = {
  budget_amount?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PromotionStatus>;
};

export type UpdateQuoteInput = {
  additional_notations?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  expiry_date?: InputMaybe<Scalars['String']['input']>;
  lineItems?: InputMaybe<QuoteLineItemUpsertInput>;
  payee?: InputMaybe<ConnectBelongsTo>;
  purchase_order_number?: InputMaybe<Scalars['String']['input']>;
  quote_date?: InputMaybe<Scalars['String']['input']>;
  tax_inclusion_type?: InputMaybe<TaxInclusionType>;
};

export type UpdateReceiptInput = {
  amount_inc_tax?: InputMaybe<Scalars['Int']['input']>;
  amount_tax?: InputMaybe<Scalars['Int']['input']>;
  /** Claimable percentage as a decimal between 0.0 and 1.0 (e.g. 0.75 = 75%) */
  claimable_percentage?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Currency>;
  date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ReceiptType>;
};

export type UpdateRefundBankDetailsInput = {
  bank_account_name: Scalars['String']['input'];
  bank_account_number: Scalars['String']['input'];
  bank_country: Scalars['String']['input'];
  bank_identifier_code?: InputMaybe<Scalars['String']['input']>;
  bank_name: Scalars['String']['input'];
  recipient_address: Scalars['String']['input'];
};

export type UpdateRefundInput = {
  bank_account_name?: InputMaybe<Scalars['String']['input']>;
  bank_account_number?: InputMaybe<Scalars['String']['input']>;
  bank_country?: InputMaybe<Scalars['String']['input']>;
  bank_identifier_code?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  maximum_refund_amount?: InputMaybe<Scalars['Int']['input']>;
  recipient_address?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RefundStatus>;
};

export type UpdateRefundPaymentInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Currency>;
  method?: InputMaybe<RefundPaymentMethod>;
  refunded_at?: InputMaybe<Scalars['String']['input']>;
  transaction_number?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRelocationCompletedTaskInput = {
  cancellation_status?: InputMaybe<BookingStatus>;
  description?: InputMaybe<Scalars['String']['input']>;
  was_relocation_completed: Scalars['Boolean']['input'];
};

export type UpdateRelocationHighlightInput = {
  deliveryCity?: InputMaybe<ConnectBelongsTo>;
  departureCity?: InputMaybe<ConnectBelongsTo>;
  order?: InputMaybe<Scalars['Int']['input']>;
  primary_text: Scalars['String']['input'];
  region?: InputMaybe<Region>;
  secondary_text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRelocationInput = {
  acknowledgements?: InputMaybe<UpsertRelocationAcknowledgements>;
  available_from_date?: InputMaybe<Scalars['String']['input']>;
  available_to_date?: InputMaybe<Scalars['String']['input']>;
  booking_fee_amount?: InputMaybe<Scalars['Int']['input']>;
  charge_per_move_amount?: InputMaybe<Scalars['Int']['input']>;
  /** Sets the available relocations directly; quantity is re-derived as count + booked_count */
  count?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Currency>;
  /** List of delivery office IDs. First ID is the main relocation's delivery office, additional IDs create/manage linked relocations. */
  deliveryOfficeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  departureOffice?: InputMaybe<ConnectBelongsTo>;
  discount_percent?: InputMaybe<Scalars['Int']['input']>;
  distance_allowed?: InputMaybe<Scalars['Int']['input']>;
  excess_distance_rate?: InputMaybe<Scalars['Int']['input']>;
  extra_distance_allowed_per_extra_hire_unit?: InputMaybe<Scalars['Int']['input']>;
  extra_hire_unit_deposit_rate?: InputMaybe<Scalars['Int']['input']>;
  extra_hire_unit_rate?: InputMaybe<Scalars['Int']['input']>;
  extra_hire_unit_supplier_net_rate?: InputMaybe<Scalars['Int']['input']>;
  extra_hire_units_allowed?: InputMaybe<Scalars['Int']['input']>;
  fixed_latest_departure_date?: InputMaybe<Scalars['String']['input']>;
  hire_unit_rate?: InputMaybe<Scalars['Int']['input']>;
  hire_unit_type?: InputMaybe<HireUnitType>;
  hire_units_allowed?: InputMaybe<Scalars['Int']['input']>;
  holding_deposit_amount?: InputMaybe<Scalars['Int']['input']>;
  holding_deposit_refunded_at?: InputMaybe<DepositRefundedAt>;
  holding_deposit_refunded_by?: InputMaybe<HoldingDepositRefundedBy>;
  inclusions?: InputMaybe<UpsertRelocationInclusions>;
  is_ferry_required?: InputMaybe<Scalars['Boolean']['input']>;
  lines?: InputMaybe<UpsertRelocationLines>;
  measurement?: InputMaybe<Measurement>;
  minimum_hire_units?: InputMaybe<Scalars['Int']['input']>;
  open_delivery_dates?: InputMaybe<Array<Scalars['String']['input']>>;
  open_departure_dates?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Constant fleet size; available count is derived as quantity - booked_count */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  retail_rate?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<RelocationStatus>;
  supplier?: InputMaybe<ConnectBelongsTo>;
  supplierInsuranceOption?: InputMaybe<ConnectBelongsTo>;
  type?: InputMaybe<RelocationType>;
  vehicle?: InputMaybe<ConnectBelongsTo>;
};

export type UpdateRelocationPageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Mixed']['input']>;
  region?: InputMaybe<Region>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStripePaymentMethodInput = {
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSupplierAcknowledgementInput = {
  acknowledgement?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierAdminContactInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierInput = {
  age_surcharge_amount?: InputMaybe<Scalars['Int']['input']>;
  age_surcharge_type?: InputMaybe<AgeSurchargeType>;
  billingEntity?: InputMaybe<ConnectBelongsTo>;
  billing_currency?: InputMaybe<Currency>;
  booking_fee_amount?: InputMaybe<Scalars['Int']['input']>;
  charge_per_move_amount?: InputMaybe<Scalars['Int']['input']>;
  closed_dates?: InputMaybe<Scalars['Mixed']['input']>;
  collect_address_on_bookings?: InputMaybe<Scalars['Boolean']['input']>;
  collect_gender_on_bookings?: InputMaybe<Scalars['Boolean']['input']>;
  confirm_delivery_before_billing?: InputMaybe<Scalars['Boolean']['input']>;
  contact_notes?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  debit_card_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  default_extra_hire_units_allowed?: InputMaybe<Scalars['Int']['input']>;
  delivery_hours?: InputMaybe<Scalars['Mixed']['input']>;
  departure_hours?: InputMaybe<Scalars['Mixed']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_on_line_sold?: InputMaybe<Scalars['Boolean']['input']>;
  excess_distance_rate?: InputMaybe<Scalars['Int']['input']>;
  extra_distance_allowed_per_extra_hire_unit?: InputMaybe<Scalars['Int']['input']>;
  ferry_refund_fee?: InputMaybe<Scalars['Int']['input']>;
  fuel_refund_fee?: InputMaybe<Scalars['Int']['input']>;
  fuel_refund_instructions?: InputMaybe<Scalars['String']['input']>;
  gap_rentals_cancellation_policy?: InputMaybe<Scalars['String']['input']>;
  gap_rentals_standard_inclusions?: InputMaybe<Scalars['String']['input']>;
  has_age_surcharge?: InputMaybe<Scalars['Boolean']['input']>;
  hire_unit_type?: InputMaybe<HireUnitType>;
  holding_deposit_amount?: InputMaybe<Scalars['Int']['input']>;
  holding_deposit_refunded_at?: InputMaybe<DepositRefundedAt>;
  holding_deposit_refunded_by?: InputMaybe<HoldingDepositRefundedBy>;
  hours_to_confirm?: InputMaybe<Scalars['Int']['input']>;
  imoova_refunds_ferry?: InputMaybe<Scalars['Boolean']['input']>;
  imoova_refunds_fuel?: InputMaybe<Scalars['Boolean']['input']>;
  import_template?: InputMaybe<Scalars['String']['input']>;
  is_holding_deposit_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_tax_included?: InputMaybe<Scalars['Boolean']['input']>;
  line_sold_email?: InputMaybe<Scalars['String']['input']>;
  line_sold_timezone?: InputMaybe<Scalars['String']['input']>;
  logistics_hours?: InputMaybe<Scalars['Mixed']['input']>;
  maximum_age?: InputMaybe<Scalars['Int']['input']>;
  maximum_no_surcharge_age?: InputMaybe<Scalars['Int']['input']>;
  measurement?: InputMaybe<Measurement>;
  minimum_age?: InputMaybe<Scalars['Int']['input']>;
  minimum_no_surcharge_age?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<SupplierNotificationSettingUpsert>;
  payment_instructions?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pre_checkin_instructions?: InputMaybe<Scalars['String']['input']>;
  relist_on_cancellation?: InputMaybe<Scalars['Boolean']['input']>;
  relocation_lines_valid_until?: InputMaybe<Scalars['String']['input']>;
  standard_inclusions?: InputMaybe<Scalars['String']['input']>;
  tax_type?: InputMaybe<TaxType>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierInsuranceOptionInput = {
  bond_amount?: InputMaybe<Scalars['Int']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  liability_reduction_options?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  standard_liability_amount?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSupplierOfficeInput = {
  address?: InputMaybe<BelongsToAddress>;
  billing_entity_id?: InputMaybe<Scalars['ID']['input']>;
  booking_email?: InputMaybe<Scalars['String']['input']>;
  cc_booking_to_departure_office?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<ConnectBelongsTo>;
  closed_dates?: InputMaybe<Scalars['Mixed']['input']>;
  closed_delivery_dates?: InputMaybe<Array<Scalars['String']['input']>>;
  closed_departure_dates?: InputMaybe<Array<Scalars['String']['input']>>;
  code?: InputMaybe<Scalars['String']['input']>;
  delivery_hours?: InputMaybe<Scalars['Mixed']['input']>;
  departure_hours?: InputMaybe<Scalars['Mixed']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pickup_instructions?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<ConnectBelongsTo>;
};

export type UpdateSupplierPurchasableExtraInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Zero means the extra is offered free of charge */
  unit_price?: InputMaybe<Scalars['Int']['input']>;
  units_purchasable?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSupplierTermsAndConditionsInput = {
  license_requirements?: InputMaybe<Scalars['String']['input']>;
  relocation_type?: InputMaybe<RelocationType>;
  supplier_id: Scalars['ID']['input'];
};

export type UpdateSupplierTripInput = {
  distance_allowed?: InputMaybe<Scalars['Int']['input']>;
  extra_hire_units_allowed?: InputMaybe<Scalars['Int']['input']>;
  hire_units_allowed?: InputMaybe<Scalars['Int']['input']>;
  inclusions?: InputMaybe<UpsertSupplierTripInclusion>;
  is_ferry_required?: InputMaybe<Scalars['Boolean']['input']>;
  minimum_hire_units?: InputMaybe<Scalars['Int']['input']>;
  officeA?: InputMaybe<ConnectBelongsTo>;
  officeB?: InputMaybe<ConnectBelongsTo>;
  supplier?: InputMaybe<ConnectBelongsTo>;
};

export type UpdateTaskInput = {
  completed_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TaskStatus>;
};

export type UpdateTenantInput = {
  is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTripInput = {
  distance_kms: Scalars['Int']['input'];
  duration_hrs: Scalars['Int']['input'];
  polyline?: InputMaybe<Scalars['String']['input']>;
  route_name: Scalars['String']['input'];
};

export type UpdateUserInput = {
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVehicleInput = {
  age_surcharge_amount?: InputMaybe<Scalars['Int']['input']>;
  age_surcharge_type?: InputMaybe<AgeSurchargeType>;
  approximate_age?: InputMaybe<VehicleApproximateAge>;
  brand?: InputMaybe<Scalars['String']['input']>;
  child_seat_anchor_points?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extra_hire_unit_deposit_rate?: InputMaybe<Scalars['Int']['input']>;
  extra_hire_unit_rate?: InputMaybe<Scalars['Int']['input']>;
  extra_hire_unit_supplier_net_rate?: InputMaybe<Scalars['Int']['input']>;
  fuel?: InputMaybe<Fuel>;
  has_age_surcharge?: InputMaybe<Scalars['Boolean']['input']>;
  has_heating?: InputMaybe<Scalars['Boolean']['input']>;
  has_kitchen?: InputMaybe<Scalars['Boolean']['input']>;
  has_shower_and_toilet?: InputMaybe<Scalars['Boolean']['input']>;
  hire_unit_rate?: InputMaybe<Scalars['Int']['input']>;
  hire_unit_type?: InputMaybe<HireUnitType>;
  is_pet_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_self_contained?: InputMaybe<Scalars['Boolean']['input']>;
  maximum_age?: InputMaybe<Scalars['Int']['input']>;
  maximum_no_surcharge_age?: InputMaybe<Scalars['Int']['input']>;
  minimum_age?: InputMaybe<Scalars['Int']['input']>;
  minimum_no_surcharge_age?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pet_cleaning_fee?: InputMaybe<Scalars['Int']['input']>;
  seatbelts?: InputMaybe<Scalars['Int']['input']>;
  sleeps?: InputMaybe<Scalars['Int']['input']>;
  supplier?: InputMaybe<ConnectBelongsTo>;
  transmission?: InputMaybe<Transmission>;
  type?: InputMaybe<VehicleType>;
};

export type UpdateWaitlistInput = {
  delivery_city_id?: InputMaybe<Scalars['String']['input']>;
  delivery_state?: InputMaybe<State>;
  departure_city_id?: InputMaybe<Scalars['String']['input']>;
  departure_state?: InputMaybe<State>;
  earliest_departure_date?: InputMaybe<Scalars['String']['input']>;
  latest_departure_date?: InputMaybe<Scalars['String']['input']>;
  number_of_travellers?: InputMaybe<Scalars['Int']['input']>;
  vehicle_category?: InputMaybe<VehicleCategory>;
};

export type UpdateWaitlistPreferenceInput = {
  number_of_travellers?: InputMaybe<Scalars['Int']['input']>;
  vehicle_category?: InputMaybe<VehicleCategory>;
};

export type UpdateWorkOrderAssignmentExpenseInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Currency>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkOrderAssignmentInput = {
  booking_reference?: InputMaybe<Scalars['String']['input']>;
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  delivery_time?: InputMaybe<Scalars['String']['input']>;
  driver_notes?: InputMaybe<Scalars['String']['input']>;
  pickup_date?: InputMaybe<Scalars['String']['input']>;
  pickup_time?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkOrderAssignmentPayoutInput = {
  currency?: InputMaybe<Currency>;
  lineItems?: InputMaybe<SyncPayoutLineItemsInput>;
  paid_at?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PayoutStatus>;
  transaction_reference?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkOrderDriverReviewInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateWorkOrderInput = {
  admin_notes?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  deliver_before?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<BelongsToAddress>;
  depart_after?: InputMaybe<Scalars['String']['input']>;
  departureAddress?: InputMaybe<BelongsToAddress>;
  description?: InputMaybe<Scalars['String']['input']>;
  has_return_trip?: InputMaybe<Scalars['Boolean']['input']>;
  is_service_center?: InputMaybe<Scalars['Boolean']['input']>;
  notificationSettings?: InputMaybe<UpsertWorkOrderNotificationSettingsManyInput>;
  number_of_drivers?: InputMaybe<Scalars['Int']['input']>;
  vehicle_type?: InputMaybe<VehicleType>;
};

export type UpdateWorkOrderJobOpeningInput = {
  deliver_at?: InputMaybe<Scalars['String']['input']>;
  depart_at?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  offers?: InputMaybe<UpdateJobOpeningOffersHasMany>;
  positions_available?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<WorkOrderJobOpeningStatus>;
};

export type UpdateWorkOrderJobOpeningOfferInput = {
  status?: InputMaybe<WorkOrderJobOpeningOfferStatus>;
};

export type UpdateWorkOrderNotificationSettingInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<SupplierNotificationSettingType>;
};

export type UpsertAddressInput = {
  address_line_1?: InputMaybe<Scalars['String']['input']>;
  address_line_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertBookingChargesInput = {
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  upsert?: InputMaybe<Array<BookingChargeInput>>;
};

export type UpsertBookingInclusions = {
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  upsert?: InputMaybe<Array<BookingInclusionInput>>;
};

export type UpsertBookingPurchasableExtraInput = {
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  upsert?: InputMaybe<Array<BookingPurchasableExtraInput>>;
};

export type UpsertPayableLineItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fulfills?: InputMaybe<PayableLineItemFulfilledByInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  tax_type: TaxType;
  unit_amount: Scalars['Int']['input'];
};

export type UpsertPayoutLineItemInput = {
  amount_inc_tax: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  tax_type: TaxType;
};

export type UpsertQuoteLineItemInput = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  tax_type: TaxType;
  unit_amount: Scalars['Int']['input'];
};

export type UpsertRelocationAcknowledgements = {
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  upsert?: InputMaybe<Array<RelocationAcknowledgementInput>>;
};

export type UpsertRelocationInclusions = {
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  upsert?: InputMaybe<Array<RelocationInclusionInput>>;
};

export type UpsertRelocationLines = {
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  upsert?: InputMaybe<Array<RelocationLineInput>>;
};

export type UpsertSupplierTripInclusion = {
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  upsert?: InputMaybe<Array<UpsertSupplierTripInclusionItem>>;
};

export type UpsertSupplierTripInclusionItem = {
  description?: InputMaybe<Scalars['String']['input']>;
  has_free_tank?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type: RelocationInclusionType;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertWorkOrderNotificationSettingInput = {
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  type: SupplierNotificationSettingType;
};

export type UpsertWorkOrderNotificationSettingsManyInput = {
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  upsert?: InputMaybe<Array<UpsertWorkOrderNotificationSettingInput>>;
};

export type User = {
  activities?: Maybe<Array<ActivityLog>>;
  contact?: Maybe<Contact>;
  created_at: Scalars['DateTime']['output'];
  date_of_birth?: Maybe<Scalars['String']['output']>;
  email_undeliverable_at?: Maybe<Scalars['DateTime']['output']>;
  email_undeliverable_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intercom_user_hash?: Maybe<Scalars['String']['output']>;
  is_admin: Scalars['Boolean']['output'];
  is_supplier: Scalars['Boolean']['output'];
  is_system: Scalars['Boolean']['output'];
  latestCallActivity?: Maybe<ActivityLog>;
  name?: Maybe<Scalars['String']['output']>;
  notificationSettings?: Maybe<UserNotificationSetting>;
  pending_email?: Maybe<Scalars['String']['output']>;
  primary_email?: Maybe<Scalars['String']['output']>;
  primary_phone?: Maybe<Scalars['String']['output']>;
  proDriver?: Maybe<ProDriver>;
  profilePicture?: Maybe<Media>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  waitlistPreference?: Maybe<WaitlistPreference>;
  waitlist_count: Scalars['Int']['output'];
  waitlists?: Maybe<Array<Waitlist>>;
};


export type UserIntercom_User_HashArgs = {
  platform: IntercomPlatform;
};

export type UserNotificationSetting = {
  created_at: Scalars['DateTime']['output'];
  gets_email_notifications: Scalars['Boolean']['output'];
  gets_push_notifications: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of User items. */
export type UserPaginator = {
  /** A list of User items. */
  data: Array<User>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type UserSalesData = {
  organisations: Array<OrganisationSalesData>;
  user: User;
};

export type Vehicle = {
  age_surcharge_amount?: Maybe<Scalars['Int']['output']>;
  age_surcharge_type: AgeSurchargeType;
  approximate_age?: Maybe<VehicleApproximateAge>;
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  child_seat_anchor_points?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  extra_hire_unit_deposit_rate?: Maybe<Scalars['Int']['output']>;
  extra_hire_unit_rate?: Maybe<Scalars['Int']['output']>;
  extra_hire_unit_supplier_net_rate?: Maybe<Scalars['Int']['output']>;
  fallback_image_url: Scalars['String']['output'];
  fuel: Fuel;
  has_age_surcharge?: Maybe<Scalars['Boolean']['output']>;
  has_heating?: Maybe<Scalars['Boolean']['output']>;
  has_kitchen?: Maybe<Scalars['Boolean']['output']>;
  has_shower_and_toilet?: Maybe<Scalars['Boolean']['output']>;
  heroImage: Scalars['String']['output'];
  hire_unit_rate: Scalars['Int']['output'];
  hire_unit_type: HireUnitType;
  id: Scalars['ID']['output'];
  images: Array<Media>;
  is_pet_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_self_contained?: Maybe<Scalars['Boolean']['output']>;
  maximum_age: Scalars['Int']['output'];
  maximum_no_surcharge_age?: Maybe<Scalars['Int']['output']>;
  minimum_age: Scalars['Int']['output'];
  minimum_no_surcharge_age?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pet_cleaning_fee?: Maybe<Scalars['Int']['output']>;
  /**
   * Every extra enabled on this vehicle, regardless of relocation type
   * @deprecated Use Relocation.purchasableExtras, which is scoped to the relocation's type
   */
  purchasableExtras: Array<SupplierPurchasableExtra>;
  seatbelts: Scalars['Int']['output'];
  sleeps?: Maybe<Scalars['Int']['output']>;
  supplier: Supplier;
  transmission: Transmission;
  type: VehicleType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  vehiclePurchasableExtras: Array<VehiclePurchasableExtra>;
};

export enum VehicleApproximateAge {
  LessThanFiveYears = 'LESS_THAN_FIVE_YEARS',
  LessThanTenYears = 'LESS_THAN_TEN_YEARS',
  LessThanThreeYears = 'LESS_THAN_THREE_YEARS',
  LessThanTwentyYears = 'LESS_THAN_TWENTY_YEARS',
  MoreThanTwentyYears = 'MORE_THAN_TWENTY_YEARS',
  New = 'NEW'
}

export enum VehicleCategory {
  Car = 'CAR',
  Rv = 'RV',
  Truck = 'TRUCK'
}

/** A paginated list of Vehicle items. */
export type VehiclePaginator = {
  /** A list of Vehicle items. */
  data: Array<Vehicle>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type VehiclePurchasableExtra = {
  id: Scalars['ID']['output'];
  relocation_type: RelocationType;
  supplierPurchasableExtra: SupplierPurchasableExtra;
};

export enum VehicleType {
  BoxTruck = 'BOX_TRUCK',
  CamperVan = 'CAMPER_VAN',
  Car = 'CAR',
  Caravan = 'CARAVAN',
  FourWheelDrive = 'FOUR_WHEEL_DRIVE',
  FourWheelDriveCamper = 'FOUR_WHEEL_DRIVE_CAMPER',
  LuxuryCar = 'LUXURY_CAR',
  MiniVan = 'MINI_VAN',
  MotorHome = 'MOTOR_HOME',
  Suv = 'SUV',
  Ute = 'UTE',
  Van = 'VAN'
}

export type VerifiedLocality = {
  /** Imoova city for the address: its local government area when that is a city, otherwise the nearest city, otherwise the suburb. Empty when nothing could be resolved. */
  city: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** G-NAF suburb, null when the address could not be verified. */
  suburb?: Maybe<Scalars['String']['output']>;
};

export type VipBookingStatusInput = {
  customer_note?: InputMaybe<Scalars['String']['input']>;
};

export enum Visibility {
  Private = 'private',
  Public = 'public'
}

export type Waitlist = {
  activities: Array<ActivityLog>;
  created_at: Scalars['DateTime']['output'];
  deliveryCity?: Maybe<City>;
  delivery_state?: Maybe<State>;
  departureCity?: Maybe<City>;
  departure_state?: Maybe<State>;
  earliest_departure_date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last_sent_at?: Maybe<Scalars['DateTime']['output']>;
  latest_departure_date: Scalars['String']['output'];
  number_of_travellers?: Maybe<Scalars['Int']['output']>;
  /** False when the mutation matched an existing alert instead of adding one. */
  recently_created: Scalars['Boolean']['output'];
  relocationLink: Scalars['String']['output'];
  relocations_count: Scalars['Int']['output'];
  source?: Maybe<WaitlistSource>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  vehicle_category?: Maybe<VehicleCategory>;
};

/** A paginated list of Waitlist items. */
export type WaitlistPaginator = {
  /** A list of Waitlist items. */
  data: Array<Waitlist>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type WaitlistPreference = {
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  number_of_travellers?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  vehicle_category?: Maybe<VehicleCategory>;
};

/**
 * Which surface created the waitlist, so the one click entry points can be
 * compared against the full form.
 */
export enum WaitlistSource {
  Admin = 'ADMIN',
  BookingReturn = 'BOOKING_RETURN',
  DealPage = 'DEAL_PAGE',
  DealUnavailable = 'DEAL_UNAVAILABLE',
  MobileDeal = 'MOBILE_DEAL',
  MobileForm = 'MOBILE_FORM',
  SearchEmpty = 'SEARCH_EMPTY',
  SearchResults = 'SEARCH_RESULTS',
  WaitlistPage = 'WAITLIST_PAGE'
}

/** Dynamic WHERE conditions for queries. */
export type WhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<WhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<WhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<WhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE conditions for HAS conditions. */
export type WhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<WhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<WhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<WhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE condition queries. */
export type WhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<WhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

export type WorkOrder = {
  acceptedOfferCount: Scalars['Int']['output'];
  /** The Imoova staff handling this work order. Threads on it subscribe them. */
  adminAssignees: Array<User>;
  admin_notes?: Maybe<Scalars['String']['output']>;
  admin_url: Scalars['String']['output'];
  assignments: Array<WorkOrderAssignment>;
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  currentInvoice?: Maybe<Invoice>;
  currentQuote?: Maybe<Quote>;
  deliver_before?: Maybe<Scalars['String']['output']>;
  deliveryAddress: Address;
  depart_after?: Maybe<Scalars['String']['output']>;
  departureAddress: Address;
  description?: Maybe<Scalars['String']['output']>;
  has_return_trip: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Lets the work order complete without an invoice, e.g. when it is billed on another work order's invoice. */
  invoice_not_required: Scalars['Boolean']['output'];
  /** The vehicle is collected from a dealership or workshop, which needs paperwork before it releases the vehicle to a driver. */
  is_service_center: Scalars['Boolean']['output'];
  manifest_url: Scalars['String']['output'];
  notificationSettings: Array<WorkOrderNotificationSetting>;
  number_of_drivers: Scalars['Int']['output'];
  organisation_url: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  relocation?: Maybe<Relocation>;
  /**
   * Static map of the drive. Null until the generation job has run, and stays
   * null when the route could not be drawn — an address without coordinates, or
   * no route back from Google.
   */
  routeImage?: Maybe<Media>;
  status: WorkOrderStatus;
  supplier: Supplier;
  supplier_thread_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  vehicle_type: VehicleType;
};

export type WorkOrderAssignment = {
  activeProDriverAgreement?: Maybe<ProDriverAgreement>;
  booking_reference?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  deliveryImages: Array<Media>;
  delivery_date?: Maybe<Scalars['String']['output']>;
  delivery_time?: Maybe<Scalars['String']['output']>;
  departureImages: Array<Media>;
  driver_delivered_at?: Maybe<Scalars['DateTime']['output']>;
  driver_notes?: Maybe<Scalars['String']['output']>;
  driver_pick_up_at?: Maybe<Scalars['DateTime']['output']>;
  expenses: Array<WorkOrderAssignmentExpense>;
  files: Array<Media>;
  id: Scalars['ID']['output'];
  latestLocation?: Maybe<WorkOrderAssignmentLocation>;
  payouts: Array<WorkOrderAssignmentPayout>;
  pickup_date?: Maybe<Scalars['String']['output']>;
  pickup_time?: Maybe<Scalars['String']['output']>;
  proDriver: ProDriver;
  pro_driver_id: Scalars['ID']['output'];
  review?: Maybe<ProDriverReview>;
  status: WorkOrderAssignmentStatus;
  workOrder: WorkOrder;
  work_order_id: Scalars['ID']['output'];
};

export type WorkOrderAssignmentExpense = {
  amount: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  paid_by: ExpensePaidBy;
  paid_to: ExpensePaidTo;
  payout_amount: Scalars['Int']['output'];
  receipts: Array<Receipt>;
  type: ExpenseType;
  updated_at: Scalars['DateTime']['output'];
  workOrderAssignment: WorkOrderAssignment;
};

export type WorkOrderAssignmentLocation = {
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  recorded_at: Scalars['DateTime']['output'];
};

/** A paginated list of WorkOrderAssignment items. */
export type WorkOrderAssignmentPaginator = {
  /** A list of WorkOrderAssignment items. */
  data: Array<WorkOrderAssignment>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type WorkOrderAssignmentPayout = {
  amount: Scalars['Int']['output'];
  amount_tax: Scalars['Int']['output'];
  converted_amount?: Maybe<Scalars['Int']['output']>;
  converted_currency?: Maybe<Currency>;
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  invoice_url: Scalars['String']['output'];
  lineItems: Array<WorkOrderAssignmentPayoutLineItem>;
  paid_at?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status: PayoutStatus;
  transaction_reference?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  workOrderAssignment: WorkOrderAssignment;
};

export type WorkOrderAssignmentPayoutLineItem = {
  amount_exc_tax: Scalars['Int']['output'];
  amount_inc_tax: Scalars['Int']['output'];
  amount_tax: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  payout: WorkOrderAssignmentPayout;
  tax_type: TaxType;
  updated_at: Scalars['DateTime']['output'];
};

export enum WorkOrderAssignmentStatus {
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  Delivered = 'DELIVERED',
  OnRoad = 'ON_ROAD',
  ReceiptsApproved = 'RECEIPTS_APPROVED',
  ReceiptsUploaded = 'RECEIPTS_UPLOADED'
}

export type WorkOrderJobOpening = {
  deliver_at?: Maybe<Scalars['String']['output']>;
  depart_at?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  myOffer?: Maybe<WorkOrderJobOpeningOffer>;
  offers_count: Scalars['Int']['output'];
  positions_available: Scalars['Int']['output'];
  status: WorkOrderJobOpeningStatus;
  workOrder: WorkOrder;
};

export type WorkOrderJobOpeningDriverFilterInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeJobOpeningId?: InputMaybe<Scalars['ID']['input']>;
  licenseType?: InputMaybe<Array<ProDriverLicenseType>>;
  radiusAround?: InputMaybe<RadiusAround>;
  region?: InputMaybe<Array<Region>>;
};

export type WorkOrderJobOpeningOffer = {
  id: Scalars['ID']['output'];
  jobOpening: WorkOrderJobOpening;
  proDriver: ProDriver;
  status: WorkOrderJobOpeningOfferStatus;
};

/** A paginated list of WorkOrderJobOpeningOffer items. */
export type WorkOrderJobOpeningOfferPaginator = {
  /** A list of WorkOrderJobOpeningOffer items. */
  data: Array<WorkOrderJobOpeningOffer>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum WorkOrderJobOpeningOfferStatus {
  Confirmed = 'CONFIRMED',
  Declined = 'DECLINED',
  DriverAccepted = 'DRIVER_ACCEPTED',
  Pending = 'PENDING'
}

/** A paginated list of WorkOrderJobOpening items. */
export type WorkOrderJobOpeningPaginator = {
  /** A list of WorkOrderJobOpening items. */
  data: Array<WorkOrderJobOpening>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum WorkOrderJobOpeningStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type WorkOrderNotificationSetting = {
  created_at: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: SupplierNotificationSettingType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of WorkOrder items. */
export type WorkOrderPaginator = {
  /** A list of WorkOrder items. */
  data: Array<WorkOrder>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type WorkOrderRegionalCount = {
  cancelled_count: Scalars['Int']['output'];
  pending_count: Scalars['Int']['output'];
  region: Region;
  won_count: Scalars['Int']['output'];
};

export enum WorkOrderStatus {
  Archived = 'ARCHIVED',
  AssigningDrivers = 'ASSIGNING_DRIVERS',
  Completed = 'COMPLETED',
  DriversAssigned = 'DRIVERS_ASSIGNED',
  Invoiced = 'INVOICED',
  InProgress = 'IN_PROGRESS',
  QuoteIssued = 'QUOTE_ISSUED',
  QuoteRejected = 'QUOTE_REJECTED',
  QuoteRequested = 'QUOTE_REQUESTED'
}

export type WorkOrderStatusCount = {
  count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<WorkOrderStatus>;
};

export type WorldMapPointData = {
  city: City;
  count: Scalars['Int']['output'];
  deliveryCities: Array<WorldMapPointDeliveryCity>;
};

export type WorldMapPointDeliveryCity = {
  city: City;
  count: Scalars['Int']['output'];
};

/**
 * Someone on the Zoom account holding a Zoom Phone licence. Read live from Zoom,
 * not stored — the only part we keep is which staff account they belong to.
 */
export type ZoomPhoneUser = {
  email: Scalars['String']['output'];
  /**
   * Zoom's id for the user's extension. Call history names our end of a call by
   * this rather than by user, so it is stored alongside the user id.
   */
  extension_id?: Maybe<Scalars['String']['output']>;
  extension_number?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /**
   * The staff account this Zoom user is mapped to, which is who their calls are
   * attributed to.
   */
  user?: Maybe<User>;
};

export type ZoomPhoneUserMatchResult = {
  linked: Scalars['Int']['output'];
  unchanged: Scalars['Int']['output'];
  unmatched: Array<Scalars['String']['output']>;
};
